var _style, _rect, _defs, _defs2, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4, _g, _g2, _rect7, _rect8, _path5, _path6, _path7, _path8, _g3, _g4, _path9, _g5, _path10, _path11, _path12, _path13, _g6, _g7, _rect9, _rect10, _path14, _g8, _path15, _path16, _path17, _path18, _g9, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _defs3, _defs4, _defs5, _defs6, _defs7, _rect17, _rect18, _path19, _path20, _path21, _path22, _g10, _defs8, _defs9, _rect19, _rect20, _path23, _path24, _path25, _path26, _g11, _defs10, _defs11, _defs12, _defs13, _rect21, _rect22, _rect23, _rect24, _path27, _path28, _path29, _path30, _g12, _path31, _path32, _path33, _path34, _path35, _g13, _defs14, _defs15, _defs16, _defs17, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _defs18, _rect34, _rect35, _rect36, _defs19, _defs20, _defs21, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _defs22, _rect47, _defs23, _defs24, _rect48, _rect49, _rect50, _rect51, _rect52, _defs25, _defs26, _defs27, _defs28, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _defs29, _rect60, _defs30, _defs31, _rect61, _rect62, _defs32, _rect63, _rect64, _rect65;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 37.7 47",
    style: {
      enableBackground: "new 0 0 37.7 47"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{clip-path:url(#XMLID_00000155850433909461159730000001406747203663230363_);}\n\t.st2{clip-path:url(#XMLID_00000111906787755396117340000018170655013089709988_);}\n\t.st3{opacity:0.7;fill:#4F80FF;}\n\t.st4{opacity:0.9;fill:#4F80FF;}\n\t.st5{opacity:0.7;fill:#E84F1C;}\n\t.st6{opacity:0.9;fill:#E84F1C;}\n\t.st7{fill:#0080C9;}\n\t.st8{fill:#E4ECFF;}\n\t.st9{fill:#F8F9FA;}\n\t.st10{fill:#0D2846;}\n\t.st11{opacity:0.7;fill:#3398F3;}\n\t.st12{opacity:0.7;fill:#007EF0;}\n\t.st13{fill:#004681;}\n\t.st14{fill:#E84F1C;}\n\t.st15{fill:#840000;}\n\t.st16{fill:#EF8460;}\n\t.st17{opacity:0.7;}\n\t.st18{fill:#E84E0F;}\n\t.st19{opacity:0.7;fill:#FF0000;}\n\t.st20{opacity:0.7;fill:#CC0000;}\n\t.st21{fill:#AD3434;}\n\t.st22{fill:#4F80FF;}\n\t.st23{opacity:0.4;fill:#4F80FF;}\n\t.st24{opacity:0.15;fill:#E84F1C;}\n\t.st25{opacity:0.15;fill:#4F80FF;}\n\t.st26{clip-path:url(#XMLID_00000099636080189047497470000015436884949877411214_);}\n\t.st27{clip-path:url(#XMLID_00000059995694502467881970000006459089479503261855_);}\n\t.st28{clip-path:url(#XMLID_00000045613588207225200290000006039537710954475197_);}\n\t.st29{clip-path:url(#SVGID_00000025421040893866530760000003569243740059110553_);}\n\t.st30{clip-path:url(#SVGID_00000017511862886378634600000012566922866980423083_);fill:#FFFFFF;}\n\t.st31{clip-path:url(#SVGID_00000017511862886378634600000012566922866980423083_);fill:#005CA9;}\n\t.st32{clip-path:url(#SVGID_00000012444200662021956290000005483811892663436977_);}\n\t.st33{clip-path:url(#SVGID_00000038407391908327227900000015281915557080333973_);fill:#FFFFFF;}\n\t.st34{clip-path:url(#SVGID_00000038407391908327227900000015281915557080333973_);fill:#005CA9;}\n\t.st35{opacity:0.15;fill:#0080C9;}\n\t.st36{opacity:0.4;fill:#0080C9;}\n\t.st37{clip-path:url(#SVGID_00000106839663819926465980000004197889789783345847_);}\n\t.st38{clip-path:url(#SVGID_00000116198570732710408350000012447155409621084049_);fill:#FFFFFF;}\n\t.st39{clip-path:url(#SVGID_00000116198570732710408350000012447155409621084049_);fill:#005CA9;}\n\t.st40{clip-path:url(#SVGID_00000076584902524784500400000017565528105247246469_);}\n\t.st41{clip-path:url(#SVGID_00000058556908716764588920000016553782371326811520_);fill:#FFFFFF;}\n\t.st42{clip-path:url(#SVGID_00000058556908716764588920000016553782371326811520_);fill:#005CA9;}\n\t.st43{opacity:0.15;fill:#E84E0F;}\n\t.st44{opacity:0.7;fill:#E84E0F;}\n\t.st45{clip-path:url(#SVGID_00000176755260282254256990000004404222508083354534_);}\n\t.st46{clip-path:url(#SVGID_00000117659244076800861680000003807517724560622727_);fill:#FFFFFF;}\n\t.st47{clip-path:url(#SVGID_00000117659244076800861680000003807517724560622727_);fill:#005CA9;}\n\t.st48{clip-path:url(#SVGID_00000055697309443417102310000008950023574722956964_);}\n\t.st49{clip-path:url(#SVGID_00000062908268558511541130000003231381077937462676_);fill:#FFFFFF;}\n\t.st50{clip-path:url(#SVGID_00000062908268558511541130000003231381077937462676_);fill:#005CA9;}\n\t.st51{fill:#FBE4DD;}\n\t.st52{fill:#B9CCFF;}\n\t.st53{clip-path:url(#XMLID_00000072252132192204286180000012523313466375380875_);}\n\t.st54{clip-path:url(#XMLID_00000058573736494869616120000004920091104897965748_);}\n\t.st55{clip-path:url(#XMLID_00000038397603626276965980000000520394433450948501_);}\n\t.st56{clip-path:url(#XMLID_00000161601854965812049310000011000800792733756824_);fill:#E84F1C;}\n\t.st57{clip-path:url(#XMLID_00000096757570685468782180000014126059492671220151_);fill:#E84F1C;}\n\t.st58{clip-path:url(#XMLID_00000003821369650038802860000003854186159184503938_);}\n\t.st59{clip-path:url(#XMLID_00000144338567255908824430000008920656852421025980_);}\n\t.st60{opacity:0.7;clip-path:url(#XMLID_00000150072145471943198340000014442381193334272641_);fill:#E84F1C;}\n\t.st61{opacity:0.7;clip-path:url(#XMLID_00000157306676034542342530000014994156898631740839_);fill:#E84F1C;}\n\t.st62{clip-path:url(#XMLID_00000134219603413128016570000001874555383163328931_);}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1473.8,
    y: 1289.1,
    className: "st0",
    width: 1920,
    height: 1080.9
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000134228845075436213970000005383912030887655604_",
    x: -508.4,
    y: 1867,
    width: 954.6,
    height: 503.1
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000134228845075436213970000005383912030887655604_",
    style: {
      overflow: "visible",
      fill: "#E84F1C"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000004533530922436264650000003120550824359560610_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000134228845075436213970000005383912030887655604_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#XMLID_00000004533530922436264650000003120550824359560610_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1024,
    height: 580,
    xlinkHref: "3B6BDB7D.png",
    transform: "matrix(1 0 0 1 -543.3183 1829.0848)"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000160148121041261727130000010065501165050934925_",
    x: -1473.6,
    y: 1867,
    width: 954.6,
    height: 503.1
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000160148121041261727130000010065501165050934925_",
    style: {
      overflow: "visible",
      fill: "#E84F1C"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000096027619375581353940000017726702406742431663_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000160148121041261727130000010065501165050934925_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#XMLID_00000096027619375581353940000017726702406742431663_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1024,
    height: 580,
    xlinkHref: "3B6BDB7F.png",
    transform: "matrix(1 0 0 1 -1508.5891 1829.0848)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -7313.5,
    y: 1289.1,
    className: "st0",
    width: 1920,
    height: 1080.9
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 2048,
    height: 1331,
    xlinkHref: "3B6BDB7D.jpg",
    transform: "matrix(0.6215 0 0 0.631 -111.5225 -1521.5685)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 2048,
    height: 1331,
    xlinkHref: "3B6BDB7B.jpg",
    transform: "matrix(0.6215 0 0 0.631 -1438.1608 -650.377)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fotolia_x5F_85652600_x5F_L.tif"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 2500,
    height: 1650,
    id: "Fotolia_x5F_85652600_x5F_L_00000069390496385996797370000011960070832535211966_",
    xlinkHref: "3B6BDB85.jpg",
    transform: "matrix(0.5072 0 0 0.5072 -6319.5312 -1520.0686)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fotolia_x5F_85652600_x5F_L_x5F_SW.tif"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 2500,
    height: 1650,
    id: "Fotolia_x5F_85652600_x5F_L_x5F_SW",
    xlinkHref: "3B6BDB87.jpg",
    transform: "matrix(0.5088 0 0 0.5088 -6323.4097 -645.0705)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -109.1,
    y: -1503.6,
    className: "st3",
    width: 634,
    height: 804
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 524.8,
    y: -1503.6,
    className: "st4",
    width: 634,
    height: 804
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -1437.8,
    y: -630.6,
    className: "st5",
    width: 635.9,
    height: 800.7
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      display: "none",
      overflow: "visible"
    },
    width: 1272,
    height: 801,
    xlinkHref: "../../Downloads/MicrosoftTeams-image (51).png",
    transform: "matrix(1 0 0 1 -4554.7227 -630.9152)"
  }), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -801.9,
    y: -630.7,
    className: "st6",
    width: 636.1,
    height: 800.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 710.9113 -1133.4379)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "24.0745px"
    }
  }, "Thursday, 23 September"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 705.7512 -1184.2434)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Bold'",
      fontSize: "100.3104px"
    }
  }, "10:18"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M790.5-1029.9h-69.6c-2.9,0-5.3-2.4-5.3-5.3v-29.8c0-2.9,2.4-5.3,5.3-5.3h69.6c2.9,0,5.3,2.4,5.3,5.3v29.8 C795.8-1032.3,793.4-1029.9,790.5-1029.9z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 731.1091 -1045.1005)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "15 Min")), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M878.2-1029.9h-69.6c-2.9,0-5.3-2.4-5.3-5.3v-29.8c0-2.9,2.4-5.3,5.3-5.3h69.6c2.9,0,5.3,2.4,5.3,5.3v29.8 C883.5-1032.3,881.1-1029.9,878.2-1029.9z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 818.843 -1045.0999)",
    style: {
      opacity: 0.7,
      fill: "#4D4D4D",
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "30 Min")), /*#__PURE__*/React.createElement("g", null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M966-1029.9h-69.6c-2.9,0-5.3-2.4-5.3-5.3v-29.8c0-2.9,2.4-5.3,5.3-5.3H966c2.9,0,5.3,2.4,5.3,5.3v29.8 C971.2-1032.3,968.9-1029.9,966-1029.9z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 906.5768 -1045.101)",
    style: {
      opacity: 0.7,
      fill: "#4D4D4D",
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "60 Min"))), /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M896.4-951.1H790.5c-3.5,0-6.4-2.9-6.4-6.4V-985c0-3.5,2.9-6.4,6.4-6.4h105.9c3.5,0,6.4,2.9,6.4,6.4v27.5 C902.8-954,899.9-951.1,896.4-951.1z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 818.843 -966.3062)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "30 Min"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M871.6-752.4h-56.3c-5.7,0-10.3-4.6-10.3-10.3v-56.3c0-5.7,4.6-10.3,10.3-10.3h56.3c5.7,0,10.3,4.6,10.3,10.3 v56.3C881.9-757,877.3-752.4,871.6-752.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M836.4-800.4h-3c-0.7,0-1.3-0.6-1.3-1.3v-11.5c0-0.7,0.6-1.3,1.3-1.3h3c0.7,0,1.3,0.6,1.3,1.3v11.5 C837.6-801,837.1-800.4,836.4-800.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M854.1-800.4h-3c-0.7,0-1.3-0.6-1.3-1.3v-11.5c0-0.7,0.6-1.3,1.3-1.3h3c0.7,0,1.3,0.6,1.3,1.3v11.5 C855.4-801,854.8-800.4,854.1-800.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M824.6-799v-2.9c0-3,2.4-5.4,5.4-5.4h26.9c3,0,5.4,2.4,5.4,5.4v2.9H824.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M824.6-772.8v-24.3h37.7v24.3c0,3-2.4,5.4-5.4,5.4H830C827-767.4,824.6-769.8,824.6-772.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 824.6,
    y: -799,
    className: "st7",
    width: 37.7,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 824.6,
    y: -787.9,
    className: "st7",
    width: 37.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 824.6,
    y: -777.7,
    className: "st7",
    width: 37.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 828.7,
    y: -782.4,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 61.2876 -1625.5653)",
    className: "st7",
    width: 29.5,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.2,
    y: -782.4,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 70.8259 -1635.1036)",
    className: "st7",
    width: 29.5,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 819.2,
    y: -782.4,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 51.7493 -1616.027)",
    className: "st7",
    width: 29.5,
    height: 0.5
  })))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 75.4274 -1126.3727)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 40
    }
  }, "Meeting Room"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 92.8879 -1076.8408)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Bold'",
      fontSize: 20
    }
  }, "Available for 15 minutes"), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-4951.9-758.2c-1.1,0-2.2,0-3.2,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.5-0.1-1.1-0.1-1.6-0.2 c-5.6-1.1-9.8-4.1-12.6-9c-1.3-2.2-2-4.6-2.2-7.1c0-0.1-0.1-0.1-0.1-0.2c0-1.1,0-2.2,0-3.2c0,0,0,0,0,0c0,0,0,0,0,0 c0-0.1,0-0.1,0.1-0.2c0.1-0.7,0.2-1.3,0.3-2c1.5-6.3,5.2-10.7,11.3-13.2c1.5-0.6,3.1-1,4.7-1.1c0.1,0,0.1-0.1,0.2-0.1 c1.1,0,2.2,0,3.2,0c0,0,0,0,0,0c0,0,0,0,0,0c0.5,0.1,1.1,0.1,1.6,0.2c5.6,1.1,9.8,4.1,12.6,9.1c1.2,2.2,1.9,4.5,2.2,7 c0,0.1,0.1,0.1,0.1,0.2c0,1.1,0,2.2,0,3.2c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0.5-0.1,1.1-0.2,1.6c-1.1,5.5-4.1,9.8-9,12.6 c-2.2,1.3-4.6,2-7.1,2.3C-4951.8-758.3-4951.8-758.2-4951.9-758.2z M-4953.5-770.2c-1.5,0-2.6,1.3-2.3,2.8c0.2,1.2,1.2,2,2.3,1.9 c1.3,0,2.3-1,2.3-2.4C-4951.2-769.1-4952.3-770.2-4953.5-770.2z M-4953.5-773.3c1.3,0,2.5,0.5,3.5,1.3c0.2,0.2,0.4,0.4,0.7,0.5 c0.4,0.3,0.9,0.3,1.3,0c0.4-0.2,0.6-0.7,0.5-1.1c-0.1-0.3-0.2-0.6-0.5-0.8c-0.4-0.4-0.9-0.8-1.4-1.1c-1.3-0.8-2.6-1.2-4.1-1.1 c-1.9,0-3.6,0.6-5.1,1.8c-0.3,0.3-0.6,0.6-0.8,1c-0.2,0.3-0.2,0.7,0,1c0.3,0.6,1,0.8,1.6,0.5c0.3-0.1,0.5-0.3,0.8-0.5 C-4956.1-772.8-4954.9-773.3-4953.5-773.3z M-4954.5-778.7c0,0,0.1,0.1,0.1,0.1c0.4,0,0.8,0,1.1,0c0.1,0,0.2-0.1,0.3-0.1 c0.1,0,0.1,0,0.2,0c0.2,0.2,0.3,0.2,0.5,0c0,0,0.1,0,0.1,0c2.6,0.3,4.9,1.3,6.8,3.1c0.2,0.2,0.5,0.4,0.7,0.5 c0.7,0.4,1.5,0,1.7-0.8c0.2-0.7-0.1-1.2-0.6-1.7c-1.4-1.2-2.9-2.2-4.6-2.9c-1.7-0.7-3.5-1.1-5.4-1.1c-1.8,0-3.6,0.3-5.3,1 c-1.6,0.6-3,1.6-4.4,2.7c-0.2,0.2-0.4,0.3-0.5,0.5c-0.5,0.5-0.5,1.3-0.1,1.9c0.4,0.5,1,0.6,1.7,0.2c0.4-0.2,0.7-0.5,1.1-0.7 c0.8-0.5,1.5-1.1,2.3-1.6c1-0.6,2.1-1,3.3-1.1c0.1,0.1,0.2,0.1,0.3,0c0,0,0.1,0,0.1,0c0.2,0.2,0.3,0.1,0.4,0 C-4954.6-778.6-4954.6-778.7-4954.5-778.7z M-4952.6-787.3c-0.1,0-0.1-0.1-0.2-0.1c-0.5,0-0.9,0-1.4,0c-0.1,0-0.1,0.1-0.2,0.1 c-0.2,0-0.5,0-0.7,0.1c-3.2,0.2-6.2,1.1-9,2.6c-1.9,1-3.7,2.3-5.1,3.9c-0.1,0.1-0.2,0.3-0.2,0.4c-0.2,0.6,0,1.2,0.5,1.6 c0.5,0.4,1.1,0.4,1.6,0.1c0.4-0.2,0.7-0.5,1-0.8c2.5-2.3,5.4-3.8,8.8-4.5c1.3-0.3,2.6-0.4,4-0.4c0.8,0.1,1.6,0.1,2.4,0.2 c3.3,0.4,6.3,1.6,8.9,3.6c0.8,0.6,1.5,1.2,2.2,1.9c0.5,0.5,1.8,0.3,2.2-0.4c0.1-0.2,0.1-0.3,0.2-0.5c0-0.4-0.1-0.8-0.4-1.1 c-0.3-0.4-0.6-0.8-1-1.1c-2.4-2.2-5.3-3.7-8.4-4.7C-4949-787-4950.8-787.2-4952.6-787.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4953.5-784.3c-1.3,0-2.7,0.1-4,0.4c-3.3,0.7-6.3,2.2-8.8,4.5c-0.3,0.3-0.7,0.6-1,0.8 c-0.5,0.3-1.1,0.4-1.6-0.1c-0.5-0.4-0.7-1-0.5-1.6c0-0.1,0.1-0.3,0.2-0.4c1.4-1.7,3.2-2.9,5.1-3.9c2.8-1.6,5.8-2.4,9-2.6 c0.2,0,0.5,0,0.7-0.1c0.3,0,0.5,0,0.8,0C-4953.5-786.3-4953.5-785.3-4953.5-784.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4953.5-784.3c0-1,0-2,0-3c0.3,0,0.6,0,1,0c1.8,0.1,3.5,0.3,5.2,0.9c3.1,1,6,2.4,8.4,4.7 c0.4,0.3,0.7,0.7,1,1.1c0.2,0.3,0.4,0.7,0.4,1.1c0,0.2-0.1,0.4-0.2,0.5c-0.4,0.7-1.7,0.9-2.2,0.4c-0.7-0.7-1.5-1.3-2.2-1.9 c-2.6-2-5.6-3.2-8.9-3.6C-4951.9-784.3-4952.7-784.3-4953.5-784.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4953.5-781.4c1.9,0,3.7,0.4,5.4,1.1c1.7,0.7,3.2,1.6,4.6,2.9c0.5,0.5,0.8,1,0.6,1.7c-0.2,0.8-1,1.2-1.7,0.8 c-0.3-0.1-0.5-0.3-0.7-0.5c-1.9-1.8-4.2-2.8-6.8-3.1c0,0-0.1,0-0.1,0c-0.2,0-0.3,0-0.5,0c-0.1,0-0.1,0-0.2,0c-0.2,0-0.3,0-0.5,0 C-4953.5-779.6-4953.5-780.5-4953.5-781.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4953.5-781.4c0,0.9,0,1.8,0,2.7c-0.3,0-0.7,0-1,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.3,0-0.4,0c0,0-0.1,0-0.1,0 c-0.1,0-0.2,0-0.3,0c-1.2,0.2-2.3,0.5-3.3,1.1c-0.8,0.5-1.5,1-2.3,1.6c-0.4,0.2-0.7,0.5-1.1,0.7c-0.7,0.4-1.3,0.3-1.7-0.2 c-0.4-0.5-0.4-1.4,0.1-1.9c0.2-0.2,0.4-0.3,0.5-0.5c1.3-1.1,2.8-2.1,4.4-2.7C-4957.1-781.1-4955.4-781.4-4953.5-781.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4953.5-775.7c1.5-0.1,2.9,0.3,4.1,1.1c0.5,0.3,1,0.7,1.4,1.1c0.2,0.2,0.4,0.5,0.5,0.8 c0.1,0.5-0.1,0.9-0.5,1.1c-0.4,0.2-1,0.2-1.3,0c-0.2-0.2-0.4-0.4-0.7-0.5c-1-0.8-2.2-1.3-3.5-1.3 C-4953.5-774.1-4953.5-774.9-4953.5-775.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4953.5-775.7c0,0.8,0,1.6,0,2.4c-1.4,0-2.5,0.5-3.6,1.4c-0.2,0.2-0.5,0.4-0.8,0.5c-0.6,0.3-1.3,0.1-1.6-0.5 c-0.2-0.3-0.2-0.7,0-1c0.2-0.4,0.5-0.7,0.8-1C-4957.1-775.1-4955.4-775.6-4953.5-775.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4953.5-765.5c-1.1,0.1-2.1-0.7-2.3-1.9c-0.3-1.5,0.8-2.8,2.3-2.8C-4953.5-768.6-4953.5-767-4953.5-765.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4953.5-765.5c0-1.6,0-3.1,0-4.7c1.3,0,2.3,1,2.3,2.3C-4951.2-766.5-4952.2-765.4-4953.5-765.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-4954.5-778.7c0.3,0,0.7,0,1,0c0.2,0,0.3,0,0.5,0c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0-0.8,0-1.1,0 C-4954.5-778.6-4954.5-778.6-4954.5-778.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-4952.6-787.3c-0.3,0-0.6,0-1,0c-0.3,0-0.5,0-0.8,0c0.1,0,0.1-0.1,0.2-0.1c0.5,0,0.9,0,1.4,0 C-4952.7-787.4-4952.6-787.3-4952.6-787.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-4952.8-778.6c0.2,0,0.3,0,0.5,0C-4952.5-778.5-4952.7-778.5-4952.8-778.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-4955.1-778.6c0.1,0,0.3,0,0.4,0C-4954.8-778.5-4954.9-778.4-4955.1-778.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-4955.5-778.5c0.1,0,0.2,0,0.3,0C-4955.3-778.4-4955.4-778.4-4955.5-778.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: -4911.8,
    cy: -776.4,
    r: 18.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4904.1-766.8h-15.1c-0.6,0-1-0.5-1-1l0,0c0-0.6,0.5-1,1-1h15.1c0.6,0,1,0.5,1,1l0,0 C-4903.1-767.3-4903.5-766.8-4904.1-766.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4912.2,
    y: -771.7,
    className: "st9",
    width: 1.1,
    height: 4.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4901.9-783.9v11.9h-19.8v-11.9H-4901.9 M-4901.7-785.9h-20.2c-1,0-1.8,0.8-1.8,1.8v12.4 c0,1,0.8,1.8,1.8,1.8h20.2c1,0,1.8-0.8,1.8-1.8v-12.4C-4899.9-785.1-4900.7-785.9-4901.7-785.9L-4901.7-785.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: -4870.2,
    cy: -775.6,
    r: 18.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4858.7-765.1h-22.7c-1.6,0-2.9-1.3-2.9-2.9l0,0c0-0.1,0.1-0.2,0.2-0.2h27.8c0.1,0,0.2,0.1,0.2,0.2v0.2 C-4856-766.3-4857.2-765.1-4858.7-765.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4872.9,
    y: -769,
    className: "st10",
    width: 4.8,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4863.7-783.7c1.5,0,2.8,1.3,2.8,2.8v9.3h-19v-9.3c0-1.5,1.3-2.8,2.8-2.8H-4863.7 M-4863.7-786.1h-13.4 c-2.9,0-5.2,2.3-5.2,5.2v11.6c0,0,0,0.1,0.1,0.1h23.6c0,0,0.1,0,0.1-0.1v-11.6C-4858.5-783.8-4860.8-786.1-4863.7-786.1 L-4863.7-786.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: -4828.5,
    cy: -776.3,
    r: 18.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4838.7-779.5c-0.2-1.1-0.5-2.2-0.6-3.3c-0.2-1.1,0.6-1.9,1.8-1.9c5.1,0,10.2,0,15.3,0 c0.1,0.2,0.1,0.5,0.3,0.7c0.6,1.1,1.2,2.2,1.7,3.3c0.3,0.5,0.6,1,0.9,1.6c0,0.2,0,0.4-0.1,0.6c-0.3,1.8-0.6,3.6-1,5.4 c-0.1,0.7,0.1,0.8,0.7,0.8c1.8,0,3.6-1.6,3.7-3.5c0.1-1.8-0.9-3.1-3-3.9c0.1-0.6,0.3-1.1,0.4-1.7c2.2,0.2,4.3,2.5,4.5,4.8 c0.3,3.7-2.8,6.3-5.8,6c-0.2,0-0.5,0-0.8,0c-0.2,0.9-0.3,1.8-0.4,2.7c-0.1,0-0.2,0.1-0.3,0.1c-0.4-0.1-0.7-0.1-1.1-0.2 c-0.2-0.1-0.3-0.3-0.5-0.3c-4.6-1.8-8.6-4.6-12.2-8C-4836.6-777.3-4837.6-778.4-4838.7-779.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4838.7-779.5c1.1,1.1,2.1,2.2,3.2,3.3c3.5,3.4,7.5,6.2,12.2,8c0.2,0.1,0.3,0.2,0.5,0.3 c-4.6,0.1-9.2,0.1-13.8,0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.6-3.6-1.3-7.3-1.9-10.9C-4838.7-779.1-4838.7-779.3-4838.7-779.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4819.4-779.2c-0.3-0.5-0.6-1-0.9-1.6c-0.6-1.1-1.2-2.2-1.7-3.3c-0.1-0.2-0.2-0.5-0.3-0.7 c0.6,0,1.1,0,1.7,0c1.4,0,2.1,0.9,1.8,2.2c-0.1,0.4-0.1,0.8-0.1,1.1c-0.1,0.6-0.3,1.1-0.4,1.7 C-4819.3-779.5-4819.3-779.3-4819.4-779.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4821.7-767.7c-0.2,0.8-0.8,0.9-1.5,0.9c-3.9,0-7.8,0-11.8,0c-0.6,0-1.1-0.6-1.6-0.9 c4.6-0.1,9.2-0.1,13.8-0.2C-4822.4-767.8-4822.1-767.8-4821.7-767.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4818.9-766.3h-20.1c-0.4,0-0.7-0.3-0.7-0.7l0,0c0-0.4,0.3-0.7,0.7-0.7h20.1c0.4,0,0.7,0.3,0.7,0.7l0,0 C-4818.1-766.7-4818.5-766.3-4818.9-766.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: -4786.8,
    cy: -775.6,
    r: 18.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4778.7-780.4l-2.6,12.9c-0.1,0-0.3,0.1-0.5,0.1h-10.2c-0.2,0-0.4,0-0.5-0.1l-2.4-12.9H-4778.7  M-4777.2-782.6h-19.1c-0.6,0-1.1,0.6-1,1.2l2.8,14.7c0.2,0.8,1.3,1.5,2.6,1.5h10.2c1.3,0,2.5-0.6,2.6-1.4l2.9-14.7 C-4776.1-782-4776.6-782.6-4777.2-782.6L-4777.2-782.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -4793.9,
    y: -773.8,
    className: "st9",
    width: 14.3,
    height: 7.5
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: -4745.1,
    cy: -775.5,
    r: 18.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-4750.2-764.8c0-0.3-0.1-0.6-0.1-0.9c-0.1-0.9-0.2-1.8-0.2-2.6c0-0.2-0.1-0.3-0.3-0.2 c-1,0.1-1.9,0.3-2.9,0.4c-0.2,0-0.5,0-0.7,0.1c0.3-0.8,0.6-1.5,0.9-2.3c0.1-0.3,0.3-0.7,0.4-1c0.1-0.2,0-0.3-0.2-0.4 c-1.1-0.3-2.2-0.7-3.3-1.1c0,0-0.1,0-0.1-0.1c0.7-0.7,1.4-1.3,2.1-2c0.2-0.2,0.3-0.3,0.5-0.5c0.1-0.1,0.1-0.2,0-0.3 c-0.8-0.8-1.6-1.6-2.5-2.3c0,0-0.1-0.1-0.2-0.1c0.7-0.2,1.3-0.4,1.9-0.6c0.5-0.2,1.1-0.4,1.6-0.5c0.2-0.1,0.2-0.2,0.1-0.3 c-0.2-0.6-0.5-1.2-0.7-1.8c-0.2-0.5-0.4-1-0.6-1.6c0.5,0.1,0.9,0.1,1.3,0.2c0.8,0.1,1.5,0.2,2.3,0.3c0.2,0,0.3,0,0.3-0.2 c0.1-1,0.2-1.9,0.3-2.8c0-0.2,0-0.4,0-0.7c0.5,0.3,0.9,0.6,1.4,0.9c0.5,0.4,1.1,0.7,1.6,1.1c0.2,0.1,0.2,0.1,0.3-0.1 c0.6-1,1.1-1.9,1.7-2.9c0-0.1,0.1-0.1,0.2-0.2c0.2,0.3,0.3,0.5,0.4,0.7c0.5,0.8,1,1.6,1.4,2.4c0.1,0.2,0.2,0.2,0.3,0.1 c0.9-0.6,1.9-1.3,2.8-1.9c0,0,0.1,0,0.1-0.1c0,0.1,0,0.1,0,0.2c0.1,1.1,0.2,2.2,0.3,3.4c0,0.2,0.1,0.2,0.2,0.2 c0.6-0.1,1.2-0.2,1.8-0.2c0.6-0.1,1.1-0.2,1.7-0.3c-0.1,0.3-0.2,0.5-0.3,0.8c-0.3,0.8-0.6,1.7-1,2.5c-0.1,0.2-0.1,0.3,0.2,0.4 c1.1,0.3,2.2,0.7,3.3,1.1c-0.3,0.3-0.6,0.6-0.9,0.9c-0.6,0.5-1.1,1.1-1.7,1.6c-0.2,0.1-0.2,0.2,0,0.4c0.9,0.8,1.7,1.6,2.6,2.5 c-0.3,0.1-0.5,0.2-0.7,0.3c-0.9,0.3-1.7,0.6-2.6,0.8c-0.2,0.1-0.3,0.2-0.2,0.4c0.4,1,0.8,2.1,1.2,3.2c0,0,0,0.1,0,0.1 c-0.2,0-0.5,0-0.7-0.1c-0.6-0.1-1.2-0.2-1.9-0.3c-0.3,0-0.7-0.1-1-0.2c-0.2,0-0.3,0.1-0.3,0.3c-0.1,1.1-0.2,2.3-0.3,3.4 c0,0,0,0-0.1,0.1c-1.1-0.7-2.1-1.4-3.2-2.1c-0.7,1.1-1.3,2.2-2,3.3c-0.2-0.2-0.3-0.4-0.4-0.6c-0.5-0.8-1-1.6-1.4-2.4 c-0.1-0.2-0.2-0.2-0.4-0.1c-0.9,0.6-1.9,1.3-2.8,1.9C-4750.1-764.9-4750.2-764.8-4750.2-764.8z M-4745.4-775.5c0,2.3,0,4.7,0,7 c0,0.3,0,0.4,0.4,0.4c0.4-0.1,0.8-0.1,1.2-0.2c1-0.2,2-0.6,2.8-1.3c1.9-1.4,2.9-3.3,3-5.7c0.1-1.3-0.2-2.5-0.8-3.6 c-0.6-1.2-1.5-2.1-2.6-2.8c-1.1-0.7-2.3-1.1-3.6-1.1c-0.4,0-0.4,0-0.4,0.4C-4745.4-780.2-4745.4-777.8-4745.4-775.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: -4745.1,
    cy: -775.5,
    r: 7.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: -4745.1,
    cy: -775.5,
    r: 6.5
  }))))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: -5393.5,
    y: -3895.3,
    className: "st11",
    width: 775,
    height: 1164.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: -4618.5,
    y: -3895.3,
    className: "st12",
    width: 775,
    height: 1164.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -4424.0391 -3367.4285)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "35.0761px"
    }
  }, "Thursday, 23 September"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -4431.5566 -3441.4514)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Bold'",
      fontSize: "146.1504px"
    }
  }, "10:18"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-4305.7-3216.6h-106.3c-2.9,0-5.3-2.4-5.3-5.3v-48.2c0-2.9,2.4-5.3,5.3-5.3h106.3c2.9,0,5.3,2.4,5.3,5.3 v48.2C-4300.4-3218.9-4302.8-3216.6-4305.7-3216.6z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -4394.6108 -3238.7224)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "23.3117px"
    }
  }, "15 Min")), /*#__PURE__*/React.createElement("g", null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-4177.8-3216.6h-106.3c-2.9,0-5.3-2.4-5.3-5.3v-48.2c0-2.9,2.4-5.3,5.3-5.3h106.3c2.9,0,5.3,2.4,5.3,5.3 v48.2C-4172.6-3218.9-4174.9-3216.6-4177.8-3216.6z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -4266.7847 -3238.7224)",
    style: {
      opacity: 0.5,
      fill: "#F8F9FA",
      fontFamily: "'Aileron-Regular'",
      fontSize: "23.3117px"
    }
  }, "30 Min")), /*#__PURE__*/React.createElement("g", null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-4050-3216.6h-106.3c-2.9,0-5.3-2.4-5.3-5.3v-48.2c0-2.9,2.4-5.3,5.3-5.3h106.3c2.9,0,5.3,2.4,5.3,5.3 v48.2C-4044.7-3218.9-4047.1-3216.6-4050-3216.6z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -4138.9575 -3238.7224)",
    style: {
      opacity: 0.5,
      fill: "#F8F9FA",
      fontFamily: "'Aileron-Regular'",
      fontSize: "23.3117px"
    }
  }, "60 Min"))), /*#__PURE__*/React.createElement("g", null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-4150.9-3101.8H-4311c-3.5,0-6.4-2.9-6.4-6.4v-45.9c0-3.5,2.9-6.4,6.4-6.4h160.1c3.5,0,6.4,2.9,6.4,6.4 v45.9C-4144.5-3104.7-4147.4-3101.8-4150.9-3101.8z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -4266.7847 -3123.9211)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "23.3117px"
    }
  }, "30 Min"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-4185.2-2812.2h-91.5c-5.7,0-10.3-4.6-10.3-10.3v-91.5c0-5.7,4.6-10.3,10.3-10.3h91.5 c5.7,0,10.3,4.6,10.3,10.3v91.5C-4174.9-2816.9-4179.5-2812.2-4185.2-2812.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4240.7-2882.2h-5.5c-0.7,0-1.3-0.6-1.3-1.3v-17.8c0-0.7,0.6-1.3,1.3-1.3h5.5c0.7,0,1.3,0.6,1.3,1.3v17.8 C-4239.4-2882.7-4240-2882.2-4240.7-2882.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4214.8-2882.2h-5.5c-0.7,0-1.3-0.6-1.3-1.3v-17.8c0-0.7,0.6-1.3,1.3-1.3h5.5c0.7,0,1.3,0.6,1.3,1.3v17.8 C-4213.5-2882.7-4214.1-2882.2-4214.8-2882.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4258.4-2880.2v-6.8c0-3,2.4-5.4,5.4-5.4h44.1c3,0,5.4,2.4,5.4,5.4v6.8H-4258.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4258.4-2839.5v-37.8h54.9v37.8c0,3-2.4,5.4-5.4,5.4h-44.1C-4256-2834.1-4258.4-2836.5-4258.4-2839.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4258.4,
    y: -2880.2,
    className: "st10",
    width: 54.9,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4261.2,
    y: -2864,
    className: "st10",
    width: 60.4,
    height: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4261.2,
    y: -2849.1,
    className: "st10",
    width: 60.4,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4254,
    y: -2857.5,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -7088.1396 1373.7935)",
    className: "st10",
    width: 46.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4240.1,
    y: -2857.5,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -7074.2427 1359.8964)",
    className: "st10",
    width: 46.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4267.9,
    y: -2857.5,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -7102.0371 1387.6906)",
    className: "st10",
    width: 46.1,
    height: 0.7
  })))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -5197.5264 -3357.2351)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "58.2792px"
    }
  }, "Meeting Room"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -5172.0869 -3285.0686)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Bold'",
      fontSize: "29.1396px"
    }
  }, "Available for 15 minutes"), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-5156.2-2820.8c-1.6,0-3.1,0-4.7,0c0,0,0,0,0-0.1c0,0,0,0-0.1,0c-0.8-0.1-1.6-0.2-2.4-0.3 c-8.1-1.6-14.2-6-18.3-13.1c-1.8-3.2-2.9-6.6-3.2-10.3c0-0.1-0.1-0.2-0.1-0.3c0-1.6,0-3.1,0-4.7c0,0,0,0,0,0c0,0,0,0,0,0 c0-0.1,0.1-0.2,0.1-0.3c0.2-1,0.2-1.9,0.5-2.9c2.2-9.2,7.6-15.6,16.4-19.2c2.2-0.9,4.5-1.4,6.9-1.6c0.1,0,0.2-0.1,0.3-0.1 c1.6,0,3.1,0,4.7,0c0,0,0,0,0,0.1c0,0,0,0,0.1,0c0.8,0.1,1.6,0.2,2.4,0.3c8.1,1.6,14.3,6,18.4,13.2c1.8,3.2,2.8,6.6,3.2,10.2 c0,0.1,0.1,0.2,0.1,0.3c0,1.6,0,3.1,0,4.7c0,0,0,0-0.1,0c0,0,0,0,0,0.1c-0.1,0.8-0.2,1.6-0.3,2.4c-1.6,8.1-5.9,14.2-13.1,18.3 c-3.2,1.9-6.7,2.9-10.4,3.3C-5156-2820.9-5156.1-2820.8-5156.2-2820.8z M-5158.6-2838.2c-2.2-0.1-3.8,1.9-3.4,4 c0.4,1.8,1.7,2.9,3.4,2.8c1.9,0,3.4-1.5,3.4-3.4C-5155.1-2836.7-5156.7-2838.3-5158.6-2838.2z M-5158.6-2842.8 c1.9,0,3.6,0.7,5.1,1.9c0.3,0.3,0.6,0.5,1,0.8c0.5,0.4,1.4,0.4,1.9,0c0.6-0.4,0.9-1,0.7-1.7c-0.1-0.4-0.4-0.9-0.7-1.2 c-0.6-0.6-1.3-1.2-2.1-1.6c-1.8-1.1-3.9-1.7-6-1.6c-2.8,0-5.3,0.9-7.4,2.7c-0.5,0.4-0.9,0.9-1.2,1.4c-0.3,0.4-0.3,1,0,1.4 c0.5,0.8,1.5,1.1,2.3,0.7c0.4-0.2,0.8-0.5,1.1-0.8C-5162.3-2842.1-5160.5-2842.8-5158.6-2842.8z M-5160-2850.6 c0.1,0,0.1,0.1,0.2,0.1c0.6,0,1.1,0,1.7,0c0.1,0,0.2-0.1,0.4-0.2c0.1,0,0.2,0,0.3,0c0.2,0.2,0.5,0.3,0.7,0.1c0,0,0.1,0,0.1,0 c3.8,0.5,7.1,2,9.9,4.6c0.3,0.3,0.7,0.6,1,0.8c1.1,0.5,2.2,0,2.5-1.2c0.3-1-0.1-1.8-0.8-2.5c-2-1.8-4.2-3.2-6.7-4.2 c-2.5-1-5.2-1.6-7.9-1.5c-2.7,0-5.3,0.5-7.8,1.4c-2.4,0.9-4.4,2.4-6.4,4c-0.3,0.2-0.6,0.5-0.8,0.7c-0.7,0.7-0.7,2-0.1,2.7 c0.6,0.7,1.4,0.9,2.4,0.3c0.5-0.3,1.1-0.7,1.6-1.1c1.1-0.8,2.2-1.6,3.3-2.3c1.5-0.9,3.1-1.4,4.8-1.7c0.2,0.2,0.3,0.1,0.4-0.1 c0,0,0.1,0,0.1,0c0.2,0.3,0.4,0.1,0.6-0.1C-5160.2-2850.6-5160.1-2850.6-5160-2850.6z M-5157.2-2863.2c-0.1,0-0.2-0.1-0.3-0.1 c-0.7,0-1.3,0-2,0c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0-0.7,0.1-1.1,0.1c-4.6,0.3-9,1.6-13.1,3.8c-2.8,1.5-5.3,3.3-7.4,5.7 c-0.1,0.2-0.3,0.4-0.3,0.6c-0.2,0.9,0,1.8,0.7,2.4c0.7,0.6,1.5,0.5,2.3,0.1c0.5-0.3,1.1-0.7,1.5-1.1c3.7-3.4,7.9-5.5,12.8-6.6 c1.9-0.4,3.8-0.6,5.8-0.6c1.2,0.1,2.4,0.1,3.5,0.3c4.8,0.6,9.1,2.3,13,5.3c1.1,0.9,2.2,1.8,3.3,2.8c0.8,0.7,2.6,0.4,3.2-0.6 c0.1-0.2,0.2-0.5,0.2-0.8c0-0.6-0.2-1.1-0.6-1.6c-0.4-0.6-0.9-1.1-1.4-1.6c-3.5-3.3-7.7-5.4-12.2-6.8 C-5152-2862.7-5154.6-2863.1-5157.2-2863.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-5158.6-2858.9c-2,0-3.9,0.2-5.8,0.6c-4.8,1.1-9.1,3.2-12.8,6.6c-0.5,0.4-1,0.8-1.5,1.1 c-0.8,0.4-1.6,0.5-2.3-0.1c-0.7-0.6-0.9-1.5-0.7-2.4c0.1-0.2,0.2-0.4,0.3-0.6c2.1-2.4,4.6-4.2,7.4-5.7c4.1-2.3,8.5-3.5,13.1-3.8 c0.4,0,0.7-0.1,1.1-0.1c0.4,0,0.8,0,1.2,0C-5158.6-2861.8-5158.6-2860.3-5158.6-2858.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-5158.6-2858.9c0-1.4,0-2.9,0-4.3c0.5,0,0.9,0,1.4,0c2.6,0.1,5.1,0.5,7.6,1.3c4.5,1.4,8.7,3.5,12.2,6.8 c0.5,0.5,1,1,1.4,1.6c0.4,0.5,0.6,1,0.6,1.6c0,0.3-0.1,0.5-0.2,0.8c-0.6,1-2.5,1.3-3.2,0.6c-1.1-0.9-2.1-1.9-3.3-2.8 c-3.8-3-8.2-4.7-13-5.3C-5156.2-2858.8-5157.4-2858.8-5158.6-2858.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-5158.6-2854.6c2.7,0,5.4,0.5,7.9,1.5c2.5,1,4.7,2.4,6.7,4.2c0.7,0.7,1.1,1.5,0.8,2.5 c-0.3,1.2-1.4,1.7-2.5,1.2c-0.4-0.2-0.7-0.5-1-0.8c-2.8-2.6-6.1-4.1-9.9-4.6c0,0-0.1,0-0.1,0c-0.2,0-0.5,0-0.7-0.1 c-0.1,0-0.2,0-0.3,0c-0.2,0-0.5,0-0.7-0.1C-5158.6-2852-5158.6-2853.3-5158.6-2854.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-5158.6-2854.6c0,1.3,0,2.6,0,3.9c-0.5,0-1,0-1.5,0.1c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0-0.6,0.1 c0,0-0.1,0-0.1,0c-0.1,0-0.3,0-0.4,0.1c-1.7,0.2-3.3,0.8-4.8,1.7c-1.2,0.7-2.2,1.5-3.3,2.3c-0.5,0.4-1,0.8-1.6,1.1 c-1,0.6-1.9,0.5-2.4-0.3c-0.6-0.8-0.6-2,0.1-2.7c0.2-0.3,0.5-0.5,0.8-0.7c2-1.6,4-3,6.4-4 C-5163.8-2854.1-5161.2-2854.6-5158.6-2854.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-5158.6-2846.3c2.2-0.1,4.2,0.5,6,1.6c0.7,0.5,1.4,1,2.1,1.6c0.3,0.3,0.6,0.8,0.7,1.2 c0.2,0.7-0.2,1.3-0.7,1.7c-0.6,0.4-1.4,0.4-1.9,0c-0.3-0.2-0.7-0.5-1-0.8c-1.5-1.2-3.2-1.9-5.1-1.9 C-5158.6-2844-5158.6-2845.1-5158.6-2846.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-5158.6-2846.3c0,1.1,0,2.3,0,3.4c-2,0.1-3.7,0.7-5.2,2c-0.3,0.3-0.7,0.5-1.1,0.8c-0.9,0.4-1.8,0.1-2.3-0.7 c-0.3-0.5-0.3-1,0-1.4c0.4-0.5,0.8-1,1.2-1.4C-5163.8-2845.4-5161.3-2846.2-5158.6-2846.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-5158.6-2831.4c-1.6,0.1-3-1-3.4-2.8c-0.4-2.1,1.2-4.1,3.4-4C-5158.6-2835.9-5158.6-2833.7-5158.6-2831.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-5158.6-2831.4c0-2.3,0-4.6,0-6.8c1.8-0.1,3.4,1.5,3.4,3.4C-5155.1-2832.9-5156.7-2831.4-5158.6-2831.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-5160-2850.6c0.5,0,1,0,1.5-0.1c0.2,0,0.5,0,0.7,0.1c-0.1,0.1-0.2,0.2-0.4,0.2c-0.6,0-1.1,0-1.7,0 C-5159.9-2850.5-5160-2850.6-5160-2850.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-5157.2-2863.2c-0.5,0-0.9,0-1.4,0c-0.4,0-0.8,0-1.2,0c0.1,0,0.2-0.1,0.3-0.1c0.7,0,1.3,0,2,0 C-5157.3-2863.3-5157.3-2863.3-5157.2-2863.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-5157.5-2850.6c0.2,0,0.5,0,0.7,0.1C-5157.1-2850.3-5157.3-2850.4-5157.5-2850.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-5160.8-2850.5c0.2,0,0.4,0,0.6-0.1C-5160.4-2850.4-5160.6-2850.3-5160.8-2850.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-5161.4-2850.5c0.1,0,0.3,0,0.4-0.1C-5161.1-2850.3-5161.2-2850.3-5161.4-2850.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: -5097.8,
    cy: -2847.3,
    r: 26.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-5086.1-2833.4h-22.9c-0.6,0-1-0.5-1-1v-0.9c0-0.6,0.5-1,1-1h22.9c0.6,0,1,0.5,1,1v0.9 C-5085.1-2833.9-5085.5-2833.4-5086.1-2833.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5098.3,
    y: -2840.4,
    className: "st9",
    width: 1.6,
    height: 6.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-5083.4-2858.3v17.3h-28.8v-17.3H-5083.4 M-5082.3-2861.2h-31.1c-1,0-1.8,0.8-1.8,1.8v19.7 c0,1,0.8,1.8,1.8,1.8h31.1c1,0,1.8-0.8,1.8-1.8v-19.7C-5080.5-2860.4-5081.3-2861.2-5082.3-2861.2L-5082.3-2861.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: -5037.1,
    cy: -2846.2,
    r: 26.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-5019.2-2830.9h-35.6c-1.6,0-2.9-1.3-2.9-2.9v-1.4c0-0.1,0.1-0.2,0.2-0.2h40.7c0.1,0,0.2,0.1,0.2,0.2v1.6 C-5016.5-2832.1-5017.7-2830.9-5019.2-2830.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5041,
    y: -2836.5,
    className: "st10",
    width: 7,
    height: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-5025.3-2858c0.9,0,1.7,0.8,1.7,1.7v15.9h-27.7v-15.9c0-0.9,0.8-1.7,1.7-1.7H-5025.3 M-5025.3-2861.5 h-24.2c-2.9,0-5.2,2.3-5.2,5.2v19.3c0,0,0,0.1,0.1,0.1h34.5c0,0,0.1,0,0.1-0.1v-19.3 C-5020.1-2859.1-5022.5-2861.5-5025.3-2861.5L-5025.3-2861.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: -4976.4,
    cy: -2847.1,
    r: 26.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4991.3-2851.9c-0.3-1.6-0.7-3.2-0.9-4.8c-0.3-1.5,0.9-2.8,2.7-2.8c7.4,0,14.8,0,22.3,0 c0.1,0.4,0.2,0.7,0.4,1.1c0.8,1.6,1.7,3.2,2.5,4.8c0.4,0.8,0.8,1.5,1.2,2.3c0,0.3,0,0.6-0.1,0.9c-0.5,2.6-0.9,5.3-1.5,7.9 c-0.2,1,0.2,1.1,1,1.1c2.6,0.1,5.2-2.4,5.3-5c0.1-2.7-1.3-4.5-4.4-5.6c0.2-0.8,0.4-1.6,0.6-2.4c3.3,0.2,6.3,3.6,6.5,7 c0.4,5.3-4.1,9.1-8.4,8.7c-0.3,0-0.7,0-1.2,0c-0.2,1.4-0.4,2.7-0.6,4c-0.2,0.1-0.3,0.1-0.5,0.2c-0.5-0.1-1-0.2-1.6-0.2 c-0.2-0.2-0.5-0.4-0.8-0.5c-6.8-2.6-12.6-6.6-17.8-11.7C-4988.2-2848.6-4989.7-2850.3-4991.3-2851.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4991.3-2851.9c1.6,1.6,3.1,3.3,4.7,4.8c5.2,5,11,9.1,17.8,11.7c0.3,0.1,0.5,0.3,0.8,0.5 c-6.7,0.1-13.4,0.2-20.1,0.2c-0.1-0.1-0.2-0.1-0.2-0.2c-0.9-5.3-1.9-10.6-2.8-16C-4991.3-2851.2-4991.3-2851.6-4991.3-2851.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4963.1-2851.4c-0.4-0.8-0.8-1.5-1.2-2.3c-0.8-1.6-1.7-3.2-2.5-4.8c-0.2-0.3-0.3-0.7-0.4-1.1 c0.8,0,1.6,0,2.4,0c2,0,3.1,1.3,2.7,3.3c-0.1,0.5-0.1,1.1-0.1,1.6c-0.2,0.8-0.4,1.6-0.6,2.4 C-4962.9-2851.9-4963-2851.6-4963.1-2851.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4966.5-2834.7c-0.3,1.1-1.2,1.3-2.1,1.3c-5.7,0-11.4,0.1-17.1,0c-0.8,0-1.6-0.8-2.4-1.3 c6.7-0.1,13.4-0.2,20.1-0.2C-4967.5-2834.9-4967-2834.8-4966.5-2834.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4962-2832.7h-30c-0.4,0-0.7-0.3-0.7-0.7v-0.7c0-0.4,0.3-0.7,0.7-0.7h30c0.4,0,0.7,0.3,0.7,0.7v0.7 C-4961.3-2833-4961.6-2832.7-4962-2832.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: -4915.6,
    cy: -2846.1,
    r: 26.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4903.8-2853.2l-3.7,18.7c-0.2,0.1-0.4,0.1-0.8,0.1h-14.8c-0.3,0-0.6-0.1-0.8-0.1l-3.5-18.7H-4903.8  M-4901.7-2856.4h-27.9c-0.9,0-1.6,0.8-1.5,1.8l4,21.4c0.2,1.2,1.9,2.1,3.8,2.1h14.8c1.9,0,3.6-0.9,3.8-2.1l4.3-21.4 C-4900-2855.5-4900.7-2856.4-4901.7-2856.4L-4901.7-2856.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -4926,
    y: -2843.5,
    className: "st9",
    width: 20.8,
    height: 10.9
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: -4854.9,
    cy: -2846,
    r: 26.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-4862.4-2830.4c0-0.5-0.1-0.9-0.1-1.3c-0.1-1.3-0.2-2.6-0.3-3.8c0-0.3-0.1-0.4-0.4-0.3 c-1.4,0.2-2.8,0.4-4.2,0.6c-0.3,0-0.7,0.1-1.1,0.1c0.4-1.1,0.8-2.2,1.3-3.3c0.2-0.5,0.4-1,0.6-1.5c0.1-0.3,0.1-0.4-0.3-0.5 c-1.6-0.5-3.2-1-4.8-1.5c0,0-0.1,0-0.2-0.1c1-1,2-1.9,3-2.9c0.3-0.2,0.5-0.5,0.8-0.7c0.2-0.2,0.2-0.3,0-0.5 c-1.2-1.1-2.4-2.3-3.6-3.4c-0.1-0.1-0.1-0.1-0.3-0.2c1-0.3,1.9-0.6,2.8-0.9c0.8-0.3,1.6-0.5,2.4-0.8c0.3-0.1,0.2-0.2,0.2-0.4 c-0.3-0.9-0.7-1.8-1-2.6c-0.3-0.7-0.6-1.5-0.9-2.3c0.7,0.1,1.3,0.2,1.9,0.3c1.1,0.2,2.2,0.3,3.3,0.5c0.3,0,0.4,0,0.4-0.3 c0.1-1.4,0.2-2.8,0.4-4.2c0-0.3,0-0.6,0.1-1c0.7,0.5,1.4,0.9,2,1.3c0.8,0.5,1.6,1.1,2.4,1.6c0.2,0.2,0.3,0.1,0.5-0.1 c0.8-1.4,1.6-2.8,2.5-4.2c0.1-0.1,0.1-0.2,0.2-0.3c0.2,0.4,0.4,0.7,0.6,1c0.7,1.2,1.4,2.3,2.1,3.5c0.1,0.2,0.3,0.2,0.5,0.1 c1.4-0.9,2.8-1.8,4.1-2.7c0.1,0,0.1-0.1,0.2-0.1c0,0.1,0.1,0.2,0.1,0.3c0.1,1.6,0.3,3.3,0.4,4.9c0,0.2,0.1,0.3,0.3,0.3 c0.9-0.1,1.8-0.2,2.7-0.4c0.8-0.1,1.7-0.2,2.5-0.4c-0.1,0.4-0.3,0.8-0.4,1.2c-0.5,1.2-0.9,2.4-1.4,3.6c-0.1,0.3-0.1,0.5,0.3,0.6 c1.6,0.5,3.2,1,4.9,1.6c-0.5,0.4-0.9,0.8-1.3,1.3c-0.8,0.8-1.6,1.6-2.5,2.3c-0.2,0.2-0.2,0.3,0,0.5c1.3,1.2,2.5,2.4,3.8,3.6 c-0.4,0.1-0.7,0.3-1.1,0.4c-1.3,0.4-2.5,0.8-3.8,1.2c-0.3,0.1-0.4,0.2-0.3,0.6c0.6,1.5,1.2,3.1,1.8,4.6c0,0,0,0.1,0.1,0.2 c-0.4,0-0.7,0-1-0.1c-0.9-0.1-1.8-0.3-2.7-0.4c-0.5-0.1-1-0.1-1.4-0.2c-0.3-0.1-0.4,0.1-0.4,0.4c-0.1,1.6-0.3,3.3-0.4,4.9 c0,0,0,0.1-0.1,0.2c-1.5-1-3.1-2-4.6-3.1c-1,1.6-1.9,3.2-2.9,4.8c-0.2-0.4-0.4-0.6-0.6-0.9c-0.7-1.2-1.4-2.3-2.1-3.5 c-0.2-0.3-0.3-0.3-0.5-0.1c-1.4,0.9-2.8,1.8-4.1,2.7C-4862.2-2830.5-4862.3-2830.5-4862.4-2830.4z M-4855.4-2846.1 c0,3.4,0,6.8,0,10.2c0,0.5,0.1,0.6,0.6,0.5c0.6-0.1,1.2-0.2,1.8-0.3c1.5-0.3,2.9-0.9,4.1-1.8c2.7-2.1,4.2-4.9,4.3-8.3 c0.1-1.8-0.4-3.6-1.2-5.2c-0.9-1.7-2.1-3.1-3.8-4.1c-1.6-1-3.3-1.5-5.2-1.7c-0.5,0-0.6,0-0.6,0.5 C-4855.4-2852.8-4855.4-2849.4-4855.4-2846.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: -4854.9,
    cy: -2846,
    r: 10.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: -4854.9,
    cy: -2846,
    r: 9.4
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -1251.2108 -358.6028)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 40
    }
  }, "Meeting Room"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -1269.4296 -309.0709)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Bold'",
      fontSize: 20
    }
  }, "Booked For the next 30 minutes"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -1192.9613 -251.3688)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 20
    }
  }, "Current Meeting"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -1211.9227 -225.3263)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st0",
    style: {
      fontFamily: "'Aileron-Light'",
      fontSize: 17
    }
  }, "Quick meeting via 30 min"), /*#__PURE__*/React.createElement("tspan", {
    x: 45.2,
    y: 20.4,
    className: "st0",
    style: {
      fontFamily: "'Aileron-Light'",
      fontSize: 17
    }
  }, "14:41 - 15:11"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.3,
    y: 40.8,
    className: "st0",
    style: {
      fontFamily: "'Aileron-Light'",
      fontSize: 17
    }
  }, "Organizer: tablet user1")), /*#__PURE__*/React.createElement("g", null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M-1066.6-97.1h-105.9c-3.5,0-6.4-2.9-6.4-6.4V-131c0-3.5,2.9-6.4,6.4-6.4h105.9c3.5,0,6.4,2.9,6.4,6.4v27.5 C-1060.2-100-1063-97.1-1066.6-97.1z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -1152.3119 -112.3076)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "End Now"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M-4951.9,112.7c-1.1,0-2.2,0-3.2,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.5-0.1-1.1-0.1-1.6-0.2 c-5.6-1.1-9.8-4.1-12.6-9c-1.3-2.2-2-4.6-2.2-7.1c0-0.1-0.1-0.1-0.1-0.2c0-1.1,0-2.2,0-3.2c0,0,0,0,0,0c0,0,0,0,0,0 c0-0.1,0-0.1,0.1-0.2c0.1-0.7,0.2-1.3,0.3-2c1.5-6.3,5.2-10.7,11.3-13.2c1.5-0.6,3.1-1,4.7-1.1c0.1,0,0.1-0.1,0.2-0.1 c1.1,0,2.2,0,3.2,0c0,0,0,0,0,0c0,0,0,0,0,0c0.5,0.1,1.1,0.1,1.6,0.2c5.6,1.1,9.8,4.1,12.6,9.1c1.2,2.2,1.9,4.5,2.2,7 c0,0.1,0.1,0.1,0.1,0.2c0,1.1,0,2.2,0,3.2c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0.5-0.1,1.1-0.2,1.6c-1.1,5.5-4.1,9.8-9,12.6 c-2.2,1.3-4.6,2-7.1,2.3C-4951.8,112.6-4951.8,112.6-4951.9,112.7z M-4953.5,100.7c-1.5,0-2.6,1.3-2.3,2.8c0.2,1.2,1.2,2,2.3,1.9 c1.3,0,2.3-1,2.3-2.4C-4951.2,101.7-4952.3,100.7-4953.5,100.7z M-4953.5,97.5c1.3,0,2.5,0.5,3.5,1.3c0.2,0.2,0.4,0.4,0.7,0.5 c0.4,0.3,0.9,0.3,1.3,0c0.4-0.2,0.6-0.7,0.5-1.1c-0.1-0.3-0.2-0.6-0.5-0.8c-0.4-0.4-0.9-0.8-1.4-1.1c-1.3-0.8-2.6-1.2-4.1-1.1 c-1.9,0-3.6,0.6-5.1,1.8c-0.3,0.3-0.6,0.6-0.8,1c-0.2,0.3-0.2,0.7,0,1c0.3,0.6,1,0.8,1.6,0.5c0.3-0.1,0.5-0.3,0.8-0.5 C-4956.1,98-4954.9,97.6-4953.5,97.5z M-4954.5,92.2c0,0,0.1,0.1,0.1,0.1c0.4,0,0.8,0,1.1,0c0.1,0,0.2-0.1,0.3-0.1 c0.1,0,0.1,0,0.2,0c0.2,0.2,0.3,0.2,0.5,0c0,0,0.1,0,0.1,0c2.6,0.3,4.9,1.3,6.8,3.1c0.2,0.2,0.5,0.4,0.7,0.5 c0.7,0.4,1.5,0,1.7-0.8c0.2-0.7-0.1-1.2-0.6-1.7c-1.4-1.2-2.9-2.2-4.6-2.9c-1.7-0.7-3.5-1.1-5.4-1.1c-1.8,0-3.6,0.3-5.3,1 c-1.6,0.6-3,1.6-4.4,2.7c-0.2,0.2-0.4,0.3-0.5,0.5c-0.5,0.5-0.5,1.3-0.1,1.9c0.4,0.5,1,0.6,1.7,0.2c0.4-0.2,0.7-0.5,1.1-0.7 c0.8-0.5,1.5-1.1,2.3-1.6c1-0.6,2.1-1,3.3-1.1c0.1,0.1,0.2,0.1,0.3,0c0,0,0.1,0,0.1,0c0.2,0.2,0.3,0.1,0.4,0 C-4954.6,92.2-4954.6,92.2-4954.5,92.2z M-4952.6,83.5c-0.1,0-0.1-0.1-0.2-0.1c-0.5,0-0.9,0-1.4,0c-0.1,0-0.1,0.1-0.2,0.1 c-0.2,0-0.5,0-0.7,0.1c-3.2,0.2-6.2,1.1-9,2.6c-1.9,1-3.7,2.3-5.1,3.9c-0.1,0.1-0.2,0.3-0.2,0.4c-0.2,0.6,0,1.2,0.5,1.6 c0.5,0.4,1.1,0.4,1.6,0.1c0.4-0.2,0.7-0.5,1-0.8c2.5-2.3,5.4-3.8,8.8-4.5c1.3-0.3,2.6-0.4,4-0.4c0.8,0.1,1.6,0.1,2.4,0.2 c3.3,0.4,6.3,1.6,8.9,3.6c0.8,0.6,1.5,1.2,2.2,1.9c0.5,0.5,1.8,0.3,2.2-0.4c0.1-0.2,0.1-0.3,0.2-0.5c0-0.4-0.1-0.8-0.4-1.1 c-0.3-0.4-0.6-0.8-1-1.1c-2.4-2.2-5.3-3.7-8.4-4.7C-4949,83.9-4950.8,83.6-4952.6,83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4953.5,86.5c-1.3,0-2.7,0.1-4,0.4c-3.3,0.7-6.3,2.2-8.8,4.5c-0.3,0.3-0.7,0.6-1,0.8 c-0.5,0.3-1.1,0.4-1.6-0.1c-0.5-0.4-0.7-1-0.5-1.6c0-0.1,0.1-0.3,0.2-0.4c1.4-1.7,3.2-2.9,5.1-3.9c2.8-1.6,5.8-2.4,9-2.6 c0.2,0,0.5,0,0.7-0.1c0.3,0,0.5,0,0.8,0C-4953.5,84.5-4953.5,85.5-4953.5,86.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4953.5,86.5c0-1,0-2,0-3c0.3,0,0.6,0,1,0c1.8,0.1,3.5,0.3,5.2,0.9c3.1,1,6,2.4,8.4,4.7 c0.4,0.3,0.7,0.7,1,1.1c0.2,0.3,0.4,0.7,0.4,1.1c0,0.2-0.1,0.4-0.2,0.5c-0.4,0.7-1.7,0.9-2.2,0.4c-0.7-0.7-1.5-1.3-2.2-1.9 c-2.6-2-5.6-3.2-8.9-3.6C-4951.9,86.6-4952.7,86.6-4953.5,86.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4953.5,89.5c1.9,0,3.7,0.4,5.4,1.1c1.7,0.7,3.2,1.6,4.6,2.9c0.5,0.5,0.8,1,0.6,1.7c-0.2,0.8-1,1.2-1.7,0.8 c-0.3-0.1-0.5-0.3-0.7-0.5c-1.9-1.8-4.2-2.8-6.8-3.1c0,0-0.1,0-0.1,0c-0.2,0-0.3,0-0.5,0c-0.1,0-0.1,0-0.2,0c-0.2,0-0.3,0-0.5,0 C-4953.5,91.3-4953.5,90.4-4953.5,89.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4953.5,89.5c0,0.9,0,1.8,0,2.7c-0.3,0-0.7,0-1,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.3,0-0.4,0c0,0-0.1,0-0.1,0 c-0.1,0-0.2,0-0.3,0c-1.2,0.2-2.3,0.5-3.3,1.1c-0.8,0.5-1.5,1-2.3,1.6c-0.4,0.2-0.7,0.5-1.1,0.7c-0.7,0.4-1.3,0.3-1.7-0.2 c-0.4-0.5-0.4-1.4,0.1-1.9c0.2-0.2,0.4-0.3,0.5-0.5c1.3-1.1,2.8-2.1,4.4-2.7C-4957.1,89.8-4955.4,89.5-4953.5,89.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4953.5,95.2c1.5-0.1,2.9,0.3,4.1,1.1c0.5,0.3,1,0.7,1.4,1.1c0.2,0.2,0.4,0.5,0.5,0.8 c0.1,0.5-0.1,0.9-0.5,1.1c-0.4,0.2-1,0.2-1.3,0c-0.2-0.2-0.4-0.4-0.7-0.5c-1-0.8-2.2-1.3-3.5-1.3 C-4953.5,96.8-4953.5,96-4953.5,95.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4953.5,95.2c0,0.8,0,1.6,0,2.4c-1.4,0-2.5,0.5-3.6,1.4c-0.2,0.2-0.5,0.4-0.8,0.5c-0.6,0.3-1.3,0.1-1.6-0.5 c-0.2-0.3-0.2-0.7,0-1c0.2-0.4,0.5-0.7,0.8-1C-4957.1,95.8-4955.4,95.2-4953.5,95.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4953.5,105.4c-1.1,0.1-2.1-0.7-2.3-1.9c-0.3-1.5,0.8-2.8,2.3-2.8C-4953.5,102.3-4953.5,103.8-4953.5,105.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4953.5,105.4c0-1.6,0-3.1,0-4.7c1.3,0,2.3,1,2.3,2.3C-4951.2,104.3-4952.2,105.4-4953.5,105.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-4954.5,92.2c0.3,0,0.7,0,1,0c0.2,0,0.3,0,0.5,0c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0-0.8,0-1.1,0 C-4954.5,92.3-4954.5,92.2-4954.5,92.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-4952.6,83.5c-0.3,0-0.6,0-1,0c-0.3,0-0.5,0-0.8,0c0.1,0,0.1-0.1,0.2-0.1c0.5,0,0.9,0,1.4,0 C-4952.7,83.5-4952.6,83.5-4952.6,83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-4952.8,92.2c0.2,0,0.3,0,0.5,0C-4952.5,92.4-4952.7,92.4-4952.8,92.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-4955.1,92.2c0.1,0,0.3,0,0.4,0C-4954.8,92.3-4954.9,92.4-4955.1,92.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-4955.5,92.3c0.1,0,0.2,0,0.3,0C-4955.3,92.4-4955.4,92.4-4955.5,92.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: -4911.8,
    cy: 94.5,
    r: 18.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4904.1,104h-15.1c-0.6,0-1-0.5-1-1l0,0c0-0.6,0.5-1,1-1h15.1c0.6,0,1,0.5,1,1l0,0 C-4903.1,103.5-4903.5,104-4904.1,104z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4912.2,
    y: 99.2,
    className: "st9",
    width: 1.1,
    height: 4.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4901.9,87v11.9h-19.8V87H-4901.9 M-4901.7,84.9h-20.2c-1,0-1.8,0.8-1.8,1.8v12.4c0,1,0.8,1.8,1.8,1.8 h20.2c1,0,1.8-0.8,1.8-1.8V86.7C-4899.9,85.7-4900.7,84.9-4901.7,84.9L-4901.7,84.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: -4870.2,
    cy: 95.2,
    r: 18.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4858.7,105.7h-22.7c-1.6,0-2.9-1.3-2.9-2.9l0,0c0-0.1,0.1-0.2,0.2-0.2h27.8c0.1,0,0.2,0.1,0.2,0.2v0.2 C-4856,104.5-4857.2,105.7-4858.7,105.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4872.9,
    y: 101.9,
    className: "st15",
    width: 4.8,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4863.7,87.2c1.5,0,2.8,1.3,2.8,2.8v9.3h-19V90c0-1.5,1.3-2.8,2.8-2.8H-4863.7 M-4863.7,84.8h-13.4 c-2.9,0-5.2,2.3-5.2,5.2v11.6c0,0,0,0.1,0.1,0.1h23.6c0,0,0.1,0,0.1-0.1V90C-4858.5,87.1-4860.8,84.8-4863.7,84.8L-4863.7,84.8z "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: -4828.5,
    cy: 94.6,
    r: 18.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4838.7,91.3c-0.2-1.1-0.5-2.2-0.6-3.3c-0.2-1.1,0.6-1.9,1.8-1.9c5.1,0,10.2,0,15.3,0 c0.1,0.2,0.1,0.5,0.3,0.7c0.6,1.1,1.2,2.2,1.7,3.3c0.3,0.5,0.6,1,0.9,1.6c0,0.2,0,0.4-0.1,0.6c-0.3,1.8-0.6,3.6-1,5.4 c-0.1,0.7,0.1,0.8,0.7,0.8c1.8,0,3.6-1.6,3.7-3.5c0.1-1.8-0.9-3.1-3-3.9c0.1-0.6,0.3-1.1,0.4-1.7c2.2,0.2,4.3,2.5,4.5,4.8 c0.3,3.7-2.8,6.3-5.8,6c-0.2,0-0.5,0-0.8,0c-0.2,0.9-0.3,1.8-0.4,2.7c-0.1,0-0.2,0.1-0.3,0.1c-0.4-0.1-0.7-0.1-1.1-0.2 c-0.2-0.1-0.3-0.3-0.5-0.3c-4.6-1.8-8.6-4.6-12.2-8C-4836.6,93.6-4837.6,92.4-4838.7,91.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4838.7,91.3c1.1,1.1,2.1,2.2,3.2,3.3c3.5,3.4,7.5,6.2,12.2,8c0.2,0.1,0.3,0.2,0.5,0.3 c-4.6,0.1-9.2,0.1-13.8,0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.6-3.6-1.3-7.3-1.9-10.9C-4838.7,91.8-4838.7,91.6-4838.7,91.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4819.4,91.7c-0.3-0.5-0.6-1-0.9-1.6c-0.6-1.1-1.2-2.2-1.7-3.3c-0.1-0.2-0.2-0.5-0.3-0.7c0.6,0,1.1,0,1.7,0 c1.4,0,2.1,0.9,1.8,2.2c-0.1,0.4-0.1,0.8-0.1,1.1c-0.1,0.6-0.3,1.1-0.4,1.7C-4819.3,91.3-4819.3,91.5-4819.4,91.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4821.7,103.1c-0.2,0.8-0.8,0.9-1.5,0.9c-3.9,0-7.8,0-11.8,0c-0.6,0-1.1-0.6-1.6-0.9 c4.6-0.1,9.2-0.1,13.8-0.2C-4822.4,103-4822.1,103.1-4821.7,103.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4818.9,104.5h-20.1c-0.4,0-0.7-0.3-0.7-0.7l0,0c0-0.4,0.3-0.7,0.7-0.7h20.1c0.4,0,0.7,0.3,0.7,0.7l0,0 C-4818.1,104.2-4818.5,104.5-4818.9,104.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: -4786.8,
    cy: 95.3,
    r: 18.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-4778.7,90.4l-2.6,12.9c-0.1,0-0.3,0.1-0.5,0.1h-10.2c-0.2,0-0.4,0-0.5-0.1l-2.4-12.9H-4778.7  M-4777.2,88.2h-19.1c-0.6,0-1.1,0.6-1,1.2l2.8,14.7c0.2,0.8,1.3,1.5,2.6,1.5h10.2c1.3,0,2.5-0.6,2.6-1.5l2.9-14.7 C-4776.1,88.8-4776.6,88.2-4777.2,88.2L-4777.2,88.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -4793.9,
    y: 97.1,
    className: "st9",
    width: 14.3,
    height: 7.5
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: -4745.1,
    cy: 95.3,
    r: 18.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-4750.2,106.1c0-0.3-0.1-0.6-0.1-0.9c-0.1-0.9-0.2-1.8-0.2-2.6c0-0.2-0.1-0.3-0.3-0.2 c-1,0.1-1.9,0.3-2.9,0.4c-0.2,0-0.5,0-0.7,0.1c0.3-0.8,0.6-1.5,0.9-2.3c0.1-0.3,0.3-0.7,0.4-1c0.1-0.2,0-0.3-0.2-0.4 c-1.1-0.3-2.2-0.7-3.3-1.1c0,0-0.1,0-0.1-0.1c0.7-0.7,1.4-1.3,2.1-2c0.2-0.2,0.3-0.3,0.5-0.5c0.1-0.1,0.1-0.2,0-0.3 c-0.8-0.8-1.6-1.6-2.5-2.3c0,0-0.1-0.1-0.2-0.1c0.7-0.2,1.3-0.4,1.9-0.6c0.5-0.2,1.1-0.4,1.6-0.5c0.2-0.1,0.2-0.2,0.1-0.3 c-0.2-0.6-0.5-1.2-0.7-1.8c-0.2-0.5-0.4-1-0.6-1.6c0.5,0.1,0.9,0.1,1.3,0.2c0.8,0.1,1.5,0.2,2.3,0.3c0.2,0,0.3,0,0.3-0.2 c0.1-1,0.2-1.9,0.3-2.8c0-0.2,0-0.4,0-0.7c0.5,0.3,0.9,0.6,1.4,0.9c0.5,0.4,1.1,0.7,1.6,1.1c0.2,0.1,0.2,0.1,0.3-0.1 c0.6-1,1.1-1.9,1.7-2.9c0-0.1,0.1-0.1,0.2-0.2c0.2,0.3,0.3,0.5,0.4,0.7c0.5,0.8,1,1.6,1.4,2.4c0.1,0.2,0.2,0.2,0.3,0.1 c0.9-0.6,1.9-1.3,2.8-1.9c0,0,0.1,0,0.1-0.1c0,0.1,0,0.1,0,0.2c0.1,1.1,0.2,2.2,0.3,3.4c0,0.2,0.1,0.2,0.2,0.2 c0.6-0.1,1.2-0.2,1.8-0.2c0.6-0.1,1.1-0.2,1.7-0.3c-0.1,0.3-0.2,0.5-0.3,0.8c-0.3,0.8-0.6,1.7-1,2.5c-0.1,0.2-0.1,0.3,0.2,0.4 c1.1,0.3,2.2,0.7,3.3,1.1c-0.3,0.3-0.6,0.6-0.9,0.9c-0.6,0.5-1.1,1.1-1.7,1.6c-0.2,0.1-0.2,0.2,0,0.4c0.9,0.8,1.7,1.6,2.6,2.5 c-0.3,0.1-0.5,0.2-0.7,0.3c-0.9,0.3-1.7,0.6-2.6,0.8c-0.2,0.1-0.3,0.2-0.2,0.4c0.4,1,0.8,2.1,1.2,3.2c0,0,0,0.1,0,0.1 c-0.2,0-0.5,0-0.7-0.1c-0.6-0.1-1.2-0.2-1.9-0.3c-0.3,0-0.7-0.1-1-0.2c-0.2,0-0.3,0.1-0.3,0.3c-0.1,1.1-0.2,2.3-0.3,3.4 c0,0,0,0-0.1,0.1c-1.1-0.7-2.1-1.4-3.2-2.1c-0.7,1.1-1.3,2.2-2,3.3c-0.2-0.2-0.3-0.4-0.4-0.6c-0.5-0.8-1-1.6-1.4-2.4 c-0.1-0.2-0.2-0.2-0.4-0.1c-0.9,0.6-1.9,1.3-2.8,1.9C-4750.1,106-4750.2,106-4750.2,106.1z M-4745.4,95.3c0,2.3,0,4.7,0,7 c0,0.3,0,0.4,0.4,0.4c0.4-0.1,0.8-0.1,1.2-0.2c1-0.2,2-0.6,2.8-1.3c1.9-1.4,2.9-3.3,3-5.7c0.1-1.3-0.2-2.5-0.8-3.6 c-0.6-1.2-1.5-2.1-2.6-2.8c-1.1-0.7-2.3-1.1-3.6-1.1c-0.4,0-0.4,0-0.4,0.4C-4745.4,90.7-4745.4,93-4745.4,95.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: -4745.1,
    cy: 95.3,
    r: 7.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: -4745.1,
    cy: 95.3,
    r: 6.5
  }))))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -612.5784 -262.2463)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "24.0745px"
    }
  }, "Thursday, 23 September"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -617.7386 -313.0519)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Bold'",
      fontSize: "100.3104px"
    }
  }, "10:18"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M-533-158.7h-69.6c-2.9,0-5.3-2.4-5.3-5.3v-29.8c0-2.9,2.4-5.3,5.3-5.3h69.6c2.9,0,5.3,2.4,5.3,5.3v29.8 C-527.7-161.1-530.1-158.7-533-158.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -592.3804 -173.909)",
    style: {
      fill: "#4D4D4D",
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "15 Min"))), /*#__PURE__*/React.createElement("g", null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M-445.3-158.7h-69.6c-2.9,0-5.3-2.4-5.3-5.3v-29.8c0-2.9,2.4-5.3,5.3-5.3h69.6c2.9,0,5.3,2.4,5.3,5.3v29.8 C-440-161.1-442.3-158.7-445.3-158.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -504.6466 -173.9089)",
    style: {
      fill: "#4D4D4D",
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "30 Min"))), /*#__PURE__*/React.createElement("g", null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M-357.5-158.7h-69.6c-2.9,0-5.3-2.4-5.3-5.3v-29.8c0-2.9,2.4-5.3,5.3-5.3h69.6c2.9,0,5.3,2.4,5.3,5.3v29.8 C-352.2-161.1-354.6-158.7-357.5-158.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -416.9127 -173.9089)",
    style: {
      fill: "#4D4D4D",
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "60 Min")))), /*#__PURE__*/React.createElement("g", null, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M-427.1-79.9H-533c-3.5,0-6.4-2.9-6.4-6.4v-27.5c0-3.5,2.9-6.4,6.4-6.4h105.9c3.5,0,6.4,2.9,6.4,6.4v27.5 C-420.7-82.8-423.6-79.9-427.1-79.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -504.6466 -95.1147)",
    style: {
      fill: "#4D4D4D",
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "30 Min"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-451.9,118.8h-56.3c-5.7,0-10.3-4.6-10.3-10.3V52.1c0-5.7,4.6-10.3,10.3-10.3h56.3c5.7,0,10.3,4.6,10.3,10.3 v56.3C-441.6,114.2-446.2,118.8-451.9,118.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-487.1,70.8h-3c-0.7,0-1.3-0.6-1.3-1.3V58.1c0-0.7,0.6-1.3,1.3-1.3h3c0.7,0,1.3,0.6,1.3,1.3v11.5 C-485.8,70.2-486.4,70.8-487.1,70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-469.4,70.8h-3c-0.7,0-1.3-0.6-1.3-1.3V58.1c0-0.7,0.6-1.3,1.3-1.3h3c0.7,0,1.3,0.6,1.3,1.3v11.5 C-468.1,70.2-468.7,70.8-469.4,70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-498.9,72.1v-2.9c0-3,2.4-5.4,5.4-5.4h26.9c3,0,5.4,2.4,5.4,5.4v2.9H-498.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-498.9,98.4V74.1h37.7v24.3c0,3-2.4,5.4-5.4,5.4h-26.9C-496.5,103.8-498.9,101.4-498.9,98.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -498.9,
    y: 72.2,
    className: "st18",
    width: 37.7,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -498.9,
    y: 83.3,
    className: "st18",
    width: 37.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -498.9,
    y: 93.5,
    className: "st18",
    width: 37.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -494.8,
    y: 88.8,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -391.0103 569.1155)",
    className: "st18",
    width: 29.5,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -485.3,
    y: 88.8,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -381.472 559.5772)",
    className: "st18",
    width: 29.5,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -504.3,
    y: 88.8,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -400.5485 578.6538)",
    className: "st18",
    width: 29.5,
    height: 0.5
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M11.8,14h-3c-0.7,0-1.3-0.6-1.3-1.3V1.3C7.6,0.6,8.1,0,8.8,0h3c0.7,0,1.3,0.6,1.3,1.3v11.5 C13.1,13.4,12.5,14,11.8,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M29.5,14h-3c-0.7,0-1.3-0.6-1.3-1.3V1.3c0-0.7,0.6-1.3,1.3-1.3h3c0.7,0,1.3,0.6,1.3,1.3v11.5 C30.8,13.4,30.2,14,29.5,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M0,15.3v-2.9C0,9.4,2.4,7,5.4,7l26.9,0c3,0,5.4,2.4,5.4,5.4v2.9H0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.1,
    y: 26.9,
    className: "st9",
    width: 9.1,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 17.5,
    className: "st9",
    width: 9.1,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 26.9,
    className: "st9",
    width: 9.1,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.1,
    y: 17.5,
    className: "st9",
    width: 9.1,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    y: 26.9,
    className: "st9",
    width: 9.1,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 26.9,
    className: "st9",
    width: 9.1,
    height: 9.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M28.6,47h-0.5v-9.8h-9.1V47h-0.5v-9.8H9.5V47H9.1v-9.8H0v4.4c0,3,2.4,5.4,5.4,5.4h26.9c3,0,5.4-2.4,5.4-5.4 v-4.4h-9.1V47z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 17.5,
    className: "st9",
    width: 9.1,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 17.5,
    className: "st9",
    width: 9.1,
    height: 9
  }))))), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 2048,
    height: 1331,
    xlinkHref: "3B6BDB8B.jpg",
    transform: "matrix(0.9031 0 0 0.9031 -2898.3005 -3914.3469)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 2048,
    height: 1331,
    xlinkHref: "3B6BDB8D.jpg",
    transform: "matrix(0.9031 0 0 0.9031 1920.437 -48.6106)"
  }), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: -2746.3,
    y: -3896.2,
    className: "st19",
    width: 772.6,
    height: 1166.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: -1973.7,
    y: -3896.2,
    className: "st20",
    width: 777.4,
    height: 1166.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -2550.3003 -3509.3459)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "58.2555px"
    }
  }, "Meeting Room"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -2576.8335 -3437.2087)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Bold'",
      fontSize: "29.1277px"
    }
  }, "Booked For the next 30 minutes"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -2465.4663 -3353.1721)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.1277px"
    }
  }, "Current Meeting"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -2493.0815 -3315.2444)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st9",
    style: {
      fontFamily: "'Aileron-Light'",
      fontSize: "24.7586px"
    }
  }, "Quick meeting via 30 min"), /*#__PURE__*/React.createElement("tspan", {
    x: 65.8,
    y: 29.7,
    className: "st9",
    style: {
      fontFamily: "'Aileron-Light'",
      fontSize: "24.7586px"
    }
  }, "14:41 - 15:11"), /*#__PURE__*/React.createElement("tspan", {
    x: 15,
    y: 59.4,
    className: "st9",
    style: {
      fontFamily: "'Aileron-Light'",
      fontSize: "24.7586px"
    }
  }, "Organizer: tablet user1")), /*#__PURE__*/React.createElement("g", null, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M-2278.5-3128.5h-160.1c-3.5,0-6.4-2.9-6.4-6.4v-45.9c0-3.5,2.9-6.4,6.4-6.4h160.1c3.5,0,6.4,2.9,6.4,6.4 v45.9C-2272-3131.4-2274.9-3128.5-2278.5-3128.5z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -2406.2651 -3150.6458)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "23.3022px"
    }
  }, "End Now"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M-2507.9-2819.2c-1.6,0-3.1,0-4.7,0c0,0,0,0,0-0.1c0,0,0,0-0.1,0c-0.8-0.1-1.6-0.2-2.4-0.3 c-8.1-1.6-14.2-6-18.3-13.1c-1.8-3.2-2.9-6.6-3.2-10.3c0-0.1-0.1-0.2-0.1-0.3c0-1.6,0-3.1,0-4.7c0,0,0,0,0,0c0,0,0,0,0,0 c0-0.1,0.1-0.2,0.1-0.3c0.2-1,0.2-1.9,0.5-2.9c2.2-9.2,7.6-15.6,16.4-19.2c2.2-0.9,4.5-1.4,6.9-1.6c0.1,0,0.2-0.1,0.3-0.1 c1.6,0,3.1,0,4.7,0c0,0,0,0,0,0.1c0,0,0,0,0.1,0c0.8,0.1,1.6,0.2,2.4,0.3c8.1,1.6,14.3,6,18.4,13.2c1.8,3.2,2.8,6.6,3.2,10.2 c0,0.1,0.1,0.2,0.1,0.3c0,1.6,0,3.1,0,4.7c0,0,0,0-0.1,0c0,0,0,0,0,0.1c-0.1,0.8-0.2,1.6-0.3,2.4c-1.6,8.1-5.9,14.2-13.1,18.3 c-3.2,1.9-6.7,2.9-10.4,3.3C-2507.7-2819.3-2507.8-2819.3-2507.9-2819.2z M-2510.3-2836.6c-2.2-0.1-3.8,1.9-3.3,4 c0.4,1.8,1.7,2.9,3.4,2.8c1.9,0,3.4-1.5,3.4-3.4C-2506.9-2835.1-2508.4-2836.7-2510.3-2836.6z M-2510.3-2841.2 c1.9,0,3.6,0.7,5.1,1.9c0.3,0.3,0.6,0.5,1,0.8c0.5,0.4,1.4,0.4,1.9,0c0.6-0.4,0.9-1,0.7-1.7c-0.1-0.4-0.4-0.9-0.7-1.2 c-0.6-0.6-1.3-1.2-2.1-1.6c-1.8-1.1-3.9-1.7-6-1.6c-2.8,0-5.3,0.9-7.4,2.7c-0.5,0.4-0.9,0.9-1.2,1.4c-0.3,0.4-0.3,1,0,1.4 c0.5,0.8,1.5,1.1,2.3,0.7c0.4-0.2,0.8-0.5,1.1-0.8C-2514-2840.5-2512.2-2841.2-2510.3-2841.2z M-2511.7-2849 c0.1,0,0.1,0.1,0.2,0.1c0.6,0,1.1,0,1.7,0c0.1,0,0.2-0.1,0.4-0.2c0.1,0,0.2,0,0.3,0c0.2,0.2,0.5,0.3,0.7,0.1c0,0,0.1,0,0.1,0 c3.8,0.5,7.1,2,9.9,4.6c0.3,0.3,0.7,0.6,1,0.8c1.1,0.5,2.2,0,2.5-1.2c0.3-1-0.1-1.8-0.8-2.5c-2-1.8-4.2-3.2-6.7-4.2 c-2.5-1-5.1-1.6-7.9-1.5c-2.7,0-5.3,0.5-7.7,1.4c-2.4,0.9-4.4,2.4-6.4,4c-0.3,0.2-0.6,0.5-0.8,0.7c-0.7,0.7-0.7,2-0.1,2.7 c0.6,0.7,1.4,0.9,2.4,0.3c0.5-0.3,1.1-0.7,1.6-1.1c1.1-0.8,2.2-1.6,3.3-2.3c1.5-0.9,3.1-1.4,4.8-1.7c0.2,0.2,0.3,0.1,0.4-0.1 c0,0,0.1,0,0.1,0c0.2,0.3,0.4,0.1,0.6-0.1C-2511.9-2849-2511.8-2849-2511.7-2849z M-2508.9-2861.6c-0.1,0-0.2-0.1-0.3-0.1 c-0.7,0-1.3,0-2,0c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0-0.7,0.1-1.1,0.1c-4.6,0.3-9,1.6-13.1,3.8c-2.8,1.5-5.3,3.3-7.4,5.7 c-0.1,0.2-0.3,0.4-0.3,0.6c-0.2,0.9,0,1.8,0.7,2.4c0.7,0.6,1.5,0.5,2.3,0.1c0.5-0.3,1.1-0.7,1.5-1.1c3.7-3.4,7.9-5.5,12.8-6.6 c1.9-0.4,3.8-0.6,5.8-0.6c1.2,0.1,2.4,0.1,3.5,0.3c4.8,0.6,9.1,2.3,12.9,5.3c1.1,0.9,2.2,1.8,3.3,2.8c0.8,0.7,2.6,0.4,3.2-0.6 c0.1-0.2,0.2-0.5,0.2-0.8c0-0.6-0.2-1.1-0.6-1.6c-0.4-0.6-0.9-1.1-1.4-1.6c-3.5-3.3-7.7-5.4-12.2-6.8 C-2503.7-2861.1-2506.3-2861.5-2508.9-2861.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-2510.3-2857.3c-2,0-3.9,0.2-5.8,0.6c-4.8,1.1-9.1,3.2-12.8,6.6c-0.5,0.4-1,0.8-1.5,1.1 c-0.8,0.4-1.6,0.5-2.3-0.1c-0.7-0.6-0.9-1.5-0.7-2.4c0.1-0.2,0.2-0.4,0.3-0.6c2.1-2.4,4.6-4.2,7.4-5.7c4.1-2.3,8.5-3.5,13.1-3.8 c0.4,0,0.7-0.1,1.1-0.1c0.4,0,0.8,0,1.2,0C-2510.3-2860.2-2510.3-2858.7-2510.3-2857.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-2510.3-2857.3c0-1.4,0-2.9,0-4.3c0.5,0,0.9,0,1.4,0c2.6,0.1,5.1,0.5,7.6,1.3c4.5,1.4,8.7,3.5,12.2,6.8 c0.5,0.5,1,1,1.4,1.6c0.4,0.5,0.6,1,0.6,1.6c0,0.3-0.1,0.5-0.2,0.8c-0.6,1-2.5,1.3-3.2,0.6c-1.1-0.9-2.1-1.9-3.3-2.8 c-3.8-3-8.2-4.7-12.9-5.3C-2507.9-2857.2-2509.1-2857.2-2510.3-2857.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-2510.3-2853c2.7,0,5.4,0.5,7.9,1.5c2.5,1,4.7,2.4,6.7,4.2c0.7,0.7,1.1,1.5,0.8,2.5 c-0.3,1.2-1.4,1.7-2.5,1.2c-0.4-0.2-0.7-0.5-1-0.8c-2.8-2.6-6.1-4.1-9.9-4.6c0,0-0.1,0-0.1,0c-0.2,0-0.5,0-0.7-0.1 c-0.1,0-0.2,0-0.3,0c-0.2,0-0.5,0-0.7-0.1C-2510.3-2850.4-2510.3-2851.7-2510.3-2853z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-2510.3-2853c0,1.3,0,2.6,0,3.9c-0.5,0-1,0-1.5,0.1c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0-0.6,0.1 c0,0-0.1,0-0.1,0c-0.1,0-0.3,0-0.4,0.1c-1.7,0.2-3.3,0.8-4.8,1.7c-1.2,0.7-2.2,1.5-3.3,2.3c-0.5,0.4-1,0.8-1.6,1.1 c-1,0.6-1.9,0.5-2.4-0.3c-0.6-0.8-0.6-2,0.1-2.7c0.2-0.3,0.5-0.5,0.8-0.7c2-1.6,4-3,6.4-4C-2515.5-2852.5-2512.9-2853-2510.3-2853 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-2510.3-2844.7c2.2-0.1,4.2,0.5,6,1.6c0.7,0.5,1.4,1,2.1,1.6c0.3,0.3,0.6,0.8,0.7,1.2 c0.2,0.7-0.2,1.3-0.7,1.7c-0.6,0.4-1.4,0.4-1.9,0c-0.3-0.2-0.7-0.5-1-0.8c-1.5-1.2-3.2-1.9-5.1-1.9 C-2510.3-2842.4-2510.3-2843.5-2510.3-2844.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-2510.3-2844.7c0,1.1,0,2.3,0,3.4c-2,0.1-3.7,0.7-5.2,2c-0.3,0.3-0.7,0.5-1.1,0.8c-0.9,0.4-1.8,0.1-2.3-0.7 c-0.3-0.5-0.3-1,0-1.4c0.4-0.5,0.8-1,1.2-1.4C-2515.5-2843.8-2513-2844.6-2510.3-2844.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-2510.3-2829.8c-1.6,0.1-3-1-3.4-2.8c-0.4-2.1,1.2-4.1,3.3-4C-2510.3-2834.4-2510.3-2832.1-2510.3-2829.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-2510.3-2829.8c0-2.3,0-4.6,0-6.8c1.8-0.1,3.4,1.5,3.4,3.4C-2506.9-2831.3-2508.4-2829.8-2510.3-2829.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-2511.7-2849c0.5,0,1,0,1.5-0.1c0.2,0,0.5,0,0.7,0.1c-0.1,0.1-0.2,0.2-0.4,0.2c-0.6,0-1.1,0-1.7,0 C-2511.6-2848.9-2511.7-2849-2511.7-2849z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-2508.9-2861.6c-0.5,0-0.9,0-1.4,0c-0.4,0-0.8,0-1.2,0c0.1,0,0.2-0.1,0.3-0.1c0.7,0,1.3,0,2,0 C-2509.1-2861.7-2509-2861.7-2508.9-2861.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-2509.2-2849c0.2,0,0.5,0,0.7,0.1C-2508.8-2848.7-2509-2848.8-2509.2-2849z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-2512.5-2848.9c0.2,0,0.4,0,0.6-0.1C-2512.1-2848.8-2512.3-2848.7-2512.5-2848.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-2513.1-2848.9c0.1,0,0.3,0,0.4-0.1C-2512.8-2848.7-2513-2848.7-2513.1-2848.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: -2449.6,
    cy: -2845.7,
    r: 26.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-2437.8-2831.8h-22.9c-0.6,0-1-0.5-1-1v-0.9c0-0.6,0.5-1,1-1h22.9c0.6,0,1,0.5,1,1v0.9 C-2436.8-2832.3-2437.3-2831.8-2437.8-2831.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2450.1,
    y: -2838.9,
    className: "st9",
    width: 1.6,
    height: 6.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-2435.2-2856.7v17.3h-28.8v-17.3H-2435.2 M-2434-2859.6h-31.1c-1,0-1.8,0.8-1.8,1.8v19.6 c0,1,0.8,1.8,1.8,1.8h31.1c1,0,1.8-0.8,1.8-1.8v-19.6C-2432.2-2858.8-2433-2859.6-2434-2859.6L-2434-2859.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: -2388.8,
    cy: -2844.6,
    r: 26.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-2370.9-2829.3h-35.6c-1.6,0-2.9-1.3-2.9-2.9v-1.4c0-0.1,0.1-0.2,0.2-0.2h40.7c0.1,0,0.2,0.1,0.2,0.2v1.6 C-2368.3-2830.5-2369.5-2829.3-2370.9-2829.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2392.8,
    y: -2834.9,
    className: "st15",
    width: 7,
    height: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-2377.1-2856.4c0.9,0,1.7,0.8,1.7,1.7v15.9h-27.6v-15.9c0-0.9,0.8-1.7,1.7-1.7H-2377.1 M-2377.1-2859.9 h-24.2c-2.9,0-5.2,2.3-5.2,5.2v19.3c0,0,0,0.1,0.1,0.1h34.5c0,0,0.1,0,0.1-0.1v-19.3 C-2371.9-2857.5-2374.2-2859.9-2377.1-2859.9L-2377.1-2859.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: -2328.1,
    cy: -2845.5,
    r: 26.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-2343.1-2850.3c-0.3-1.6-0.7-3.2-0.9-4.8c-0.3-1.5,0.9-2.7,2.7-2.8c7.4,0,14.8,0,22.3,0 c0.1,0.4,0.2,0.7,0.4,1.1c0.8,1.6,1.7,3.2,2.5,4.8c0.4,0.8,0.8,1.5,1.2,2.3c0,0.3,0,0.6-0.1,0.9c-0.5,2.6-0.9,5.3-1.5,7.9 c-0.2,1,0.2,1.1,1,1.1c2.6,0.1,5.2-2.4,5.3-5c0.1-2.7-1.3-4.5-4.4-5.6c0.2-0.8,0.4-1.6,0.6-2.4c3.3,0.2,6.3,3.6,6.5,7 c0.4,5.3-4.1,9.1-8.4,8.7c-0.3,0-0.7,0-1.2,0c-0.2,1.4-0.4,2.7-0.6,4c-0.2,0.1-0.3,0.1-0.5,0.2c-0.5-0.1-1-0.2-1.6-0.2 c-0.2-0.2-0.5-0.4-0.8-0.5c-6.8-2.6-12.6-6.6-17.7-11.7C-2340-2847-2341.5-2848.7-2343.1-2850.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-2343.1-2850.3c1.6,1.6,3.1,3.3,4.7,4.8c5.2,5,11,9,17.7,11.7c0.3,0.1,0.5,0.3,0.8,0.5 c-6.7,0.1-13.4,0.2-20.1,0.2c-0.1-0.1-0.2-0.1-0.2-0.2c-0.9-5.3-1.9-10.6-2.8-15.9C-2343-2849.6-2343-2850-2343.1-2850.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-2314.9-2849.8c-0.4-0.8-0.8-1.5-1.2-2.3c-0.8-1.6-1.7-3.2-2.5-4.8c-0.2-0.3-0.3-0.7-0.4-1.1 c0.8,0,1.6,0,2.4,0c2,0,3.1,1.3,2.7,3.3c-0.1,0.5-0.1,1.1-0.1,1.6c-0.2,0.8-0.4,1.6-0.6,2.4 C-2314.7-2850.3-2314.8-2850-2314.9-2849.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-2318.3-2833.1c-0.3,1.1-1.2,1.3-2.1,1.3c-5.7,0-11.4,0.1-17.1,0c-0.8,0-1.6-0.8-2.4-1.3 c6.7-0.1,13.4-0.2,20.1-0.2C-2319.3-2833.3-2318.8-2833.2-2318.3-2833.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-2313.8-2831.1h-30c-0.4,0-0.7-0.3-0.7-0.7v-0.7c0-0.4,0.3-0.7,0.7-0.7h30c0.4,0,0.7,0.3,0.7,0.7v0.7 C-2313.1-2831.4-2313.4-2831.1-2313.8-2831.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: -2267.4,
    cy: -2844.5,
    r: 26.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-2255.6-2851.6l-3.7,18.7c-0.2,0.1-0.4,0.1-0.8,0.1h-14.8c-0.3,0-0.6-0.1-0.8-0.1l-3.5-18.7H-2255.6  M-2253.5-2854.8h-27.9c-0.9,0-1.6,0.8-1.5,1.8l4,21.4c0.2,1.2,1.9,2.1,3.8,2.1h14.8c1.9,0,3.6-0.9,3.8-2.1l4.3-21.4 C-2251.9-2853.9-2252.6-2854.8-2253.5-2854.8L-2253.5-2854.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -2277.8,
    y: -2841.9,
    className: "st9",
    width: 20.8,
    height: 10.9
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: -2206.7,
    cy: -2844.4,
    r: 26.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-2214.2-2828.8c0-0.5-0.1-0.9-0.1-1.3c-0.1-1.3-0.2-2.6-0.3-3.8c0-0.3-0.1-0.4-0.4-0.3 c-1.4,0.2-2.8,0.4-4.2,0.6c-0.3,0-0.7,0.1-1.1,0.1c0.4-1.1,0.8-2.2,1.3-3.3c0.2-0.5,0.4-1,0.6-1.5c0.1-0.3,0.1-0.4-0.3-0.5 c-1.6-0.5-3.2-1-4.8-1.5c0,0-0.1,0-0.2-0.1c1-1,2-1.9,3-2.9c0.3-0.2,0.5-0.5,0.8-0.7c0.2-0.2,0.2-0.3,0-0.5 c-1.2-1.1-2.4-2.3-3.6-3.4c-0.1-0.1-0.1-0.1-0.3-0.2c1-0.3,1.9-0.6,2.8-0.9c0.8-0.3,1.6-0.5,2.4-0.8c0.3-0.1,0.2-0.2,0.2-0.4 c-0.3-0.9-0.7-1.8-1-2.6c-0.3-0.7-0.6-1.5-0.9-2.3c0.7,0.1,1.3,0.2,1.9,0.3c1.1,0.2,2.2,0.3,3.3,0.5c0.3,0,0.4,0,0.4-0.3 c0.1-1.4,0.2-2.8,0.4-4.2c0-0.3,0-0.6,0.1-1c0.7,0.5,1.4,0.9,2,1.3c0.8,0.5,1.6,1.1,2.4,1.6c0.2,0.2,0.3,0.1,0.5-0.1 c0.8-1.4,1.6-2.8,2.5-4.2c0.1-0.1,0.1-0.2,0.2-0.3c0.2,0.4,0.4,0.7,0.6,1c0.7,1.2,1.4,2.3,2.1,3.5c0.1,0.2,0.3,0.2,0.5,0.1 c1.4-0.9,2.8-1.8,4.1-2.7c0.1,0,0.1-0.1,0.2-0.1c0,0.1,0.1,0.2,0.1,0.3c0.1,1.6,0.3,3.3,0.4,4.9c0,0.2,0.1,0.3,0.3,0.3 c0.9-0.1,1.8-0.2,2.7-0.4c0.8-0.1,1.7-0.2,2.5-0.4c-0.1,0.4-0.3,0.8-0.4,1.2c-0.5,1.2-0.9,2.4-1.4,3.6c-0.1,0.3-0.1,0.5,0.3,0.6 c1.6,0.5,3.2,1,4.9,1.6c-0.5,0.4-0.9,0.8-1.3,1.3c-0.8,0.8-1.6,1.6-2.5,2.3c-0.2,0.2-0.2,0.3,0,0.5c1.3,1.2,2.5,2.4,3.8,3.6 c-0.4,0.1-0.7,0.3-1.1,0.4c-1.3,0.4-2.5,0.8-3.8,1.2c-0.3,0.1-0.4,0.2-0.3,0.6c0.6,1.5,1.2,3.1,1.7,4.6c0,0,0,0.1,0.1,0.2 c-0.4,0-0.7,0-1-0.1c-0.9-0.1-1.8-0.3-2.7-0.4c-0.5-0.1-1-0.1-1.4-0.2c-0.3-0.1-0.4,0.1-0.4,0.4c-0.1,1.6-0.3,3.3-0.4,4.9 c0,0,0,0.1-0.1,0.2c-1.5-1-3.1-2-4.6-3.1c-1,1.6-1.9,3.2-2.9,4.8c-0.2-0.4-0.4-0.6-0.6-0.9c-0.7-1.2-1.4-2.3-2.1-3.5 c-0.2-0.3-0.3-0.3-0.5-0.1c-1.4,0.9-2.8,1.8-4.1,2.7C-2214-2828.9-2214.1-2828.9-2214.2-2828.8z M-2207.2-2844.5 c0,3.4,0,6.8,0,10.2c0,0.5,0.1,0.6,0.6,0.5c0.6-0.1,1.2-0.2,1.8-0.3c1.5-0.3,2.8-0.9,4.1-1.8c2.7-2.1,4.2-4.9,4.3-8.3 c0.1-1.8-0.4-3.6-1.2-5.2c-0.9-1.7-2.1-3.1-3.8-4.1c-1.6-1-3.3-1.5-5.2-1.7c-0.5,0-0.6,0-0.6,0.5 C-2207.2-2851.2-2207.2-2847.8-2207.2-2844.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: -2206.7,
    cy: -2844.4,
    r: 10.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: -2206.7,
    cy: -2844.4,
    r: 9.4
  }))))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -1776.4683 -3367.0693)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "35.0618px"
    }
  }, "Thursday, 23 September"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -1783.9829 -3441.062)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Bold'",
      fontSize: "146.0907px"
    }
  }, "10:18"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M-1658.1-3216.3h-106.2c-2.9,0-5.3-2.4-5.3-5.3v-48.2c0-2.9,2.4-5.3,5.3-5.3h106.2c2.9,0,5.3,2.4,5.3,5.3 v48.2C-1652.9-3218.6-1655.2-3216.3-1658.1-3216.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -1747.0513 -3238.4165)",
    style: {
      fill: "#B48C8D",
      fontFamily: "'Aileron-Regular'",
      fontSize: "23.3022px"
    }
  }, "15 Min"))), /*#__PURE__*/React.createElement("g", null, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M-1530.4-3216.3h-106.2c-2.9,0-5.3-2.4-5.3-5.3v-48.2c0-2.9,2.4-5.3,5.3-5.3h106.2c2.9,0,5.3,2.4,5.3,5.3 v48.2C-1525.1-3218.6-1527.5-3216.3-1530.4-3216.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -1619.2778 -3238.4165)",
    style: {
      fill: "#B48C8D",
      fontFamily: "'Aileron-Regular'",
      fontSize: "23.3022px"
    }
  }, "30 Min"))), /*#__PURE__*/React.createElement("g", null, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M-1402.6-3216.3h-106.2c-2.9,0-5.3-2.4-5.3-5.3v-48.2c0-2.9,2.4-5.3,5.3-5.3h106.2c2.9,0,5.3,2.4,5.3,5.3 v48.2C-1397.3-3218.6-1399.7-3216.3-1402.6-3216.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -1491.5034 -3238.4165)",
    style: {
      fill: "#B48C8D",
      fontFamily: "'Aileron-Regular'",
      fontSize: "23.3022px"
    }
  }, "60 Min")))), /*#__PURE__*/React.createElement("g", null, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M-1503.4-3101.5h-160.1c-3.5,0-6.4-2.9-6.4-6.4v-45.9c0-3.5,2.9-6.4,6.4-6.4h160.1c3.5,0,6.4,2.9,6.4,6.4 v45.9C-1497-3104.4-1499.9-3101.5-1503.4-3101.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -1619.2778 -3123.6611)",
    style: {
      fill: "#B48C8D",
      fontFamily: "'Aileron-Regular'",
      fontSize: "23.3022px"
    }
  }, "30 Min"))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M-1537.7-2812.1h-91.5c-5.7,0-10.3-4.6-10.3-10.3v-91.5c0-5.7,4.6-10.3,10.3-10.3h91.5 c5.7,0,10.3,4.6,10.3,10.3v91.5C-1527.4-2816.7-1532-2812.1-1537.7-2812.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-1593.2-2882h-5.5c-0.7,0-1.3-0.6-1.3-1.3v-17.8c0-0.7,0.6-1.3,1.3-1.3h5.5c0.7,0,1.3,0.6,1.3,1.3v17.8 C-1591.9-2882.6-1592.5-2882-1593.2-2882z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-1567.3-2882h-5.5c-0.7,0-1.3-0.6-1.3-1.3v-17.8c0-0.7,0.6-1.3,1.3-1.3h5.5c0.7,0,1.3,0.6,1.3,1.3v17.8 C-1566-2882.6-1566.6-2882-1567.3-2882z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-1610.9-2880.1v-6.8c0-3,2.4-5.4,5.4-5.4h44.1c3,0,5.4,2.4,5.4,5.4v6.8H-1610.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-1610.9-2839.4v-37.8h54.9v37.8c0,3-2.4,5.4-5.4,5.4h-44.1C-1608.5-2834-1610.9-2836.4-1610.9-2839.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1610.9,
    y: -2880,
    className: "st15",
    width: 54.9,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1613.7,
    y: -2863.8,
    className: "st15",
    width: 60.4,
    height: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1613.7,
    y: -2848.9,
    className: "st15",
    width: 60.4,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1606.5,
    y: -2857.4,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -4440.4951 -1273.5476)",
    className: "st15",
    width: 46.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1592.6,
    y: -2857.4,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -4426.6035 -1287.4391)",
    className: "st15",
    width: 46.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1620.4,
    y: -2857.4,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -4454.3862 -1259.6562)",
    className: "st15",
    width: 46.1,
    height: 0.7
  })))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: -1536.2,
    y: -2661.6,
    className: "st14",
    width: 205.3,
    height: 205.3
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: -1281.9,
    y: -2661.6,
    className: "st5",
    width: 205.3,
    height: 205.3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: -1536.2,
    y: -2389,
    className: "st22",
    width: 205.3,
    height: 205.3
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: -1281.9,
    y: -2389,
    className: "st23",
    width: 205.3,
    height: 205.3
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: -1027.6,
    y: -2661.6,
    className: "st24",
    width: 205.3,
    height: 205.3
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: -1027.6,
    y: -2389,
    className: "st25",
    width: 205.3,
    height: 205.3
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000036944796632151658300000003831107210126953402_",
    x: 790.7,
    y: 1316.6,
    width: 954.6,
    height: 503.1
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000036944796632151658300000003831107210126953402_",
    style: {
      overflow: "visible",
      fill: "#E84F1C"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000124144649765491973090000009832050592757021350_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000036944796632151658300000003831107210126953402_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#XMLID_00000124144649765491973090000009832050592757021350_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1024,
    height: 580,
    xlinkHref: "9696B916.png",
    transform: "matrix(1 0 0 1 756.0222 1278.3933)"
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000094604061441096360500000001677198445067276949_",
    x: -508.5,
    y: 1344.1,
    width: 954.9,
    height: 512.9
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000094604061441096360500000001677198445067276949_",
    style: {
      overflow: "visible",
      fill: "#4F80FF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000113324275623679229660000003428627865792704909_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000094604061441096360500000001677198445067276949_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#XMLID_00000113324275623679229660000003428627865792704909_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1032,
    height: 587,
    xlinkHref: "9696B911.png",
    transform: "matrix(1 0 0 1 -546.9781 1306.9077)"
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000109030491518168830360000007333526789909936015_",
    x: -1473.8,
    y: 1344.1,
    width: 954.9,
    height: 512.9
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000109030491518168830360000007333526789909936015_",
    style: {
      overflow: "visible",
      fill: "#4F80FF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000158000816463328836480000011571849400824308636_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000109030491518168830360000007333526789909936015_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#XMLID_00000158000816463328836480000011571849400824308636_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1032,
    height: 587,
    xlinkHref: "9696B912.png",
    transform: "matrix(1 0 0 1 -1512.2501 1306.9077)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -90.5,
    y: -1484.9,
    width: 299.5,
    height: 88.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000048483883602888403780000013500522607133903747_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000048483883602888403780000013500522607133903747_)"
    }
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000132054192235829149050000014437571469209180288_",
    x: -90.5,
    y: -1484.9,
    width: 299.5,
    height: 88.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106105888890919458750000004246193485053451187_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132054192235829149050000014437571469209180288_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000106105888890919458750000004246193485053451187_)",
      fill: "#FFFFFF"
    },
    d: "M-0.2-1457 c-4.5,0-7.1,2.8-7.1,7.6c0,4.9,2.6,7.6,7.1,7.6s7.1-2.8,7.1-7.6C6.8-1454.2,4.3-1457-0.2-1457 M4.2-1449.4c0,3-0.8,6.6-4.5,6.6 c-3.6,0-4.4-3.6-4.5-6.6c0-3,0.8-6.6,4.5-6.6C3.4-1456,4.2-1452.4,4.2-1449.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000106105888890919458750000004246193485053451187_)",
      fill: "#FFFFFF"
    },
    d: "M14.8-1450.7 l-0.7-0.2c-0.9-0.3-2.5-1.1-2.5-2.5c0-1.5,1-2.5,2.5-2.5c1.7,0,2.7,1,3,3l0,0.1h0.9v-3.1l-0.1,0c-0.7-0.6-2.1-0.9-3.6-0.9 c-2.3,0-4.9,1.1-4.9,4.2c0,2.5,2.3,3.6,4,4.2l0.4,0.1c1,0.4,2.8,1.3,2.8,3c0,1.7-1.1,2.7-2.9,2.7c-1.8,0-3.1-1.3-3.6-3.7l0-0.1 H9.2l0.2,3.5l0,0c1,0.9,2.9,1.3,4.2,1.3c3.9,0,5.3-2.3,5.3-4.4C18.9-1448.8,16.9-1449.9,14.8-1450.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000106105888890919458750000004246193485053451187_)",
      fill: "#FFFFFF"
    },
    d: "M20.9-1453h0.9l0-0.1 c0.2-2.2,0.7-2.6,3-2.6h1.1v11.6c0,1.1,0,1.1-2.2,1.2l-0.1,0v0.9h6.9v-0.9l-0.1,0c-2.2-0.1-2.2-0.1-2.2-1.2v-11.6h1.1 c2.3,0,2.7,0.4,3,2.6l0,0.1h0.9v-3.7H20.9V-1453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000106105888890919458750000004246193485053451187_)",
      fill: "#FFFFFF"
    },
    d: "M41.2-1450.7 l-0.7-0.2c-0.9-0.3-2.5-1.1-2.5-2.5c0-1.5,1-2.5,2.5-2.5c1.7,0,2.7,1,3,3l0,0.1h0.9v-3.1l-0.1,0c-0.7-0.6-2.1-0.9-3.6-0.9 c-2.3,0-4.9,1.1-4.9,4.2c0,2.5,2.3,3.6,4,4.2l0.4,0.1c1,0.4,2.8,1.3,2.8,3c0,1.7-1.1,2.7-2.9,2.7c-1.8,0-3.1-1.3-3.6-3.7l0-0.1 h-0.9l0.2,3.5l0,0c1,0.9,2.9,1.3,4.2,1.3c3.9,0,5.3-2.3,5.3-4.4C45.3-1448.8,43.3-1449.9,41.2-1450.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000106105888890919458750000004246193485053451187_)",
      fill: "#FFFFFF"
    },
    d: "M58.2-1445.8 c-0.5,2.4-1.2,2.8-3.9,2.8c-0.8,0-1.7,0-2.1-0.2c-0.4-0.2-0.4-0.4-0.4-1.4v-4.5h2.8c1.7,0,1.7,0.4,1.9,1.7l0,0.1h0.9v-4.7h-0.9 l0,0.1c-0.2,1.3-0.2,1.7-1.9,1.7h-2.8v-4.9c0-0.6,0-0.6,0.6-0.6h2c2.3,0,2.7,0.5,3,2.6l0,0.1h0.9v-3.7H47.6v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h11.3l0.3-3.9h-0.9L58.2-1445.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000106105888890919458750000004246193485053451187_)",
      fill: "#FFFFFF"
    },
    d: "M71.9-1445.9l0,0.1 c-0.5,2.4-1.2,2.8-3.9,2.8c-0.8,0-1.7,0-2.1-0.2c-0.4-0.2-0.4-0.4-0.4-1.4v-4.5h2.8c1.7,0,1.7,0.4,1.9,1.7l0,0.1H71v-4.7h-0.9 l0,0.1c-0.2,1.3-0.2,1.7-1.9,1.7h-2.8v-4.9c0-0.6,0-0.6,0.6-0.6h2c2.3,0,2.7,0.5,3,2.6l0,0.1H72v-3.7H61.2v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h11.3l0.3-3.9H71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000106105888890919458750000004246193485053451187_)",
      fill: "#FFFFFF"
    },
    d: "M94.6-1445.9 c-0.4,2.5-1.3,2.9-4.4,2.9h-3.9c2.9-4.3,5.9-8.5,9.1-13.2l0-0.1l-0.2-0.4H84.4v3.9h0.9l0-0.1c0.2-2.3,0.7-2.7,3.5-2.7h3.5 c-3.3,4.8-6.6,9.5-9.1,13.2l0,0.1l0.2,0.4h12.1l0.2-4h-0.9L94.6-1445.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000106105888890919458750000004246193485053451187_)",
      fill: "#FFFFFF"
    },
    d: "M108-1445.8 c-0.5,2.4-1.2,2.8-3.9,2.8c-0.8,0-1.7,0-2.1-0.2c-0.4-0.2-0.4-0.4-0.4-1.4v-4.5h2.8c1.7,0,1.7,0.4,1.9,1.7l0,0.1h0.9v-4.7h-0.9 l0,0.1c-0.2,1.3-0.2,1.7-1.9,1.7h-2.8v-4.9c0-0.6,0-0.6,0.6-0.6h2c2.3,0,2.7,0.5,3,2.6l0,0.1h0.9v-3.7H97.3v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h11.3l0.3-3.9H108L108-1445.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000106105888890919458750000004246193485053451187_)",
      fill: "#FFFFFF"
    },
    d: "M111.4-1455.8l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h6.1v-0.9l-0.1,0c-1.7-0.1-1.7-0.1-1.7-1.2v-10.5 c0-1.1,0-1.1,1.7-1.2l0.1,0v-0.9h-6.1V-1455.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000106105888890919458750000004246193485053451187_)",
      fill: "#FFFFFF"
    },
    d: "M119.8-1453h0.9 l0-0.1c0.2-2.2,0.7-2.6,3-2.6h1.1v11.6c0,1.1,0,1.1-2.2,1.2l-0.1,0v0.9h6.9v-0.9l-0.1,0c-2.2-0.1-2.2-0.1-2.2-1.2v-11.6h1.1 c2.3,0,2.7,0.4,3,2.6l0,0.1h0.9v-3.7h-12.3V-1453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000106105888890919458750000004246193485053451187_)",
      fill: "#FFFFFF"
    },
    d: "M143.4-1455.8l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v6.7c0,3.5-1.1,5.2-3.6,5.2c-3.2,0-3.5-2.9-3.5-5.2v-6.7c0-1.1,0-1.1,1.7-1.2l0.1,0v-0.9h-6.1v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v7.2c0.1,3.9,1.9,5.7,5.9,5.7c4,0,5.9-1.8,5.9-5.8v-7.1c0-1.1,0-1.1,1.7-1.2l0.1,0v-0.9h-6.1V-1455.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000106105888890919458750000004246193485053451187_)",
      fill: "#FFFFFF"
    },
    d: "M161.5-1455.8l0.1,0 c1.4,0.1,1.7,0.2,1.8,0.9c0.1,0.7,0.1,1.4,0.1,2.6v6.9c-2.7-3.7-5.3-7.5-7.9-11.2l0-0.1h-4.2v0.9l0.1,0c1.7,0.1,1.7,0.1,1.7,1.2 v8.2c0,1.1,0,1.9-0.1,2.6c-0.1,0.7-0.5,0.8-1.6,0.9l-0.1,0v0.9h5.2v-0.9l-0.1,0c-1.4-0.1-1.7-0.2-1.8-0.9 c-0.1-0.7-0.1-1.4-0.1-2.6v-7.9c3.2,4.5,5.9,8.3,8.6,12.2l0,0.1h1.6v-10.3c0-1.1,0-1.9,0.1-2.6c0.1-0.7,0.5-0.8,1.6-0.9l0.1,0 v-0.9h-5.2V-1455.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000106105888890919458750000004246193485053451187_)",
      fill: "#FFFFFF"
    },
    d: "M177-1448.8v0.9 l0.1,0c2.1,0.1,2.1,0.2,2.1,1.2v2.8c0,0.6-0.2,0.8-0.6,1c-0.5,0.2-1.1,0.3-1.8,0.3c-5,0-5.5-4.7-5.5-6.7c0-2,0.5-6.6,5.3-6.6 c2.3,0,3.5,1,3.9,3.3l0,0.1h0.9v-3.5l-0.1,0c-1.1-0.5-2.9-0.9-4.5-0.9c-5.2,0-8.1,2.8-8.1,7.9c0,2.6,1,4.8,2.6,6l0,0 c1.7,1.2,3.7,1.4,5.3,1.4c1.5,0,3.5-0.5,4.8-0.9l0.1,0v-4.2c0-0.9,0-1,1.4-1.2l0.1,0v-0.9H177z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.7,
    y: -1449.6,
    style: {
      clipPath: "url(#SVGID_00000106105888890919458750000004246193485053451187_)",
      fill: "#FFFFFF"
    },
    width: 5.4,
    height: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000106105888890919458750000004246193485053451187_)",
      fill: "#FFFFFF"
    },
    d: "M-6.3-1426.6 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-7.2h0l2.6,5.7c0.1,0.1,0.1,0.2,0.3,0.2h0.6c0.1,0,0.2,0,0.3-0.2l2.6-5.7h0v7.2 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-10.1c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0-0.2,0.2l-3,7h0l-3.1-7 c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2V-1426.6z M8.5-1426.3c1.3,0,2.3-0.5,2.9-1.2c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6 c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9c0-0.1,0-0.1,0.1-0.1h4.6 c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2c-0.2,0.4-0.2,1-0.2,1.8 c0,0.8,0.1,1.4,0.2,1.8C6-1427,7-1426.3,8.5-1426.3 M6.8-1430.7C6.7-1430.7,6.7-1430.8,6.8-1430.7c-0.1-0.4-0.1-0.7,0-0.9 c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H6.8z M20.4-1426.4 c0.1,0,0.2-0.1,0.2-0.2v-10.1c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v3.8h0c-0.3-0.6-1-1-2.1-1c-1.3,0-2.1,0.6-2.5,1.8 c-0.2,0.6-0.3,1.2-0.3,2.1c0,0.9,0.1,1.5,0.3,2.1c0.4,1.2,1.2,1.8,2.5,1.8c1.1,0,1.7-0.4,2.1-1h0v0.7c0,0.1,0.1,0.2,0.2,0.2H20.4 z M17.5-1427.5c-0.8,0-1.4-0.4-1.6-1.1c-0.1-0.4-0.2-0.9-0.2-1.5c0-0.7,0-1.1,0.2-1.5c0.2-0.7,0.8-1.1,1.6-1.1s1.4,0.4,1.6,1.1 c0.1,0.4,0.2,0.8,0.2,1.5c0,0.7,0,1.2-0.2,1.5C18.8-1427.8,18.3-1427.5,17.5-1427.5 M24.5-1435.4c0.1,0,0.2-0.1,0.2-0.2v-1.1 c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v1.1c0,0.1,0.1,0.2,0.2,0.2H24.5z M24.4-1426.4c0.1,0,0.2-0.1,0.2-0.2v-7 c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2H24.4z M30.7-1426.3c1.3,0,2.3-0.5,2.9-1.2 c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9 c0-0.1,0-0.1,0.1-0.1h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2 c-0.2,0.4-0.2,1-0.2,1.8c0,0.8,0.1,1.4,0.2,1.8C28.2-1427,29.3-1426.3,30.7-1426.3 M29-1430.7C28.9-1430.7,28.9-1430.8,29-1430.7 c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H29z  M42.1-1426.4c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1 c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3 c0,0.1,0.1,0.2,0.2,0.2H42.1z M45.1-1426.6c0,0.1,0.1,0.2,0.2,0.2h1.2c0.1,0,0.2-0.1,0.2-0.2v-1.3c0-0.1-0.1-0.2-0.2-0.2h-1.2 c-0.1,0-0.2,0.1-0.2,0.2V-1426.6z M51.9-1426.6c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-7.2h0l2.6,5.7 c0.1,0.1,0.1,0.2,0.3,0.2h0.6c0.1,0,0.2,0,0.3-0.2l2.6-5.7h0v7.2c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-10.1 c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0-0.2,0.2l-3,7h0l-3.1-7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2V-1426.6z  M66.8-1426.3c1.3,0,2.3-0.5,2.9-1.2c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8 c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9c0-0.1,0-0.1,0.1-0.1h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1 c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2c-0.2,0.4-0.2,1-0.2,1.8c0,0.8,0.1,1.4,0.2,1.8C64.2-1427,65.3-1426.3,66.8-1426.3  M65-1430.7C64.9-1430.7,64.9-1430.8,65-1430.7c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1 c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H65z M78.5-1426.4c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7 c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2 v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2H78.5z M84.2-1426.3c1.9,0,2.9-1,2.9-2.4 c0-1.2-0.7-1.9-2.2-2.1l-0.8-0.1c-1.1-0.1-1.4-0.4-1.4-1c0-0.6,0.5-1,1.4-1c0.7,0,1.5,0.3,2,0.6c0.1,0,0.2,0,0.2,0l0.5-0.7 c0-0.1,0-0.2,0-0.2c-0.6-0.5-1.5-0.8-2.6-0.8c-1.7,0-2.7,0.8-2.7,2.2c0,1.2,0.7,1.9,2.2,2.1l0.8,0.1c1.1,0.1,1.4,0.4,1.4,1 c0,0.7-0.5,1.1-1.6,1.1c-0.9,0-1.7-0.4-2.3-0.8c-0.1-0.1-0.2-0.1-0.2,0l-0.6,0.7c-0.1,0.1-0.1,0.2,0,0.2 C81.7-1426.8,82.7-1426.3,84.2-1426.3 M89.6-1430.1c0,0.8,0.1,1.4,0.2,1.9c0.4,1.3,1.5,2,2.9,2c1.1,0,2-0.5,2.5-1.2 c0-0.1,0-0.1,0-0.2l-0.7-0.5c-0.1-0.1-0.2-0.1-0.2,0c-0.4,0.5-0.8,0.8-1.6,0.8c-0.8,0-1.4-0.4-1.6-1.1c-0.1-0.4-0.2-0.8-0.2-1.5 c0-0.6,0-1.1,0.2-1.5c0.2-0.8,0.8-1.1,1.6-1.1c0.7,0,1.1,0.3,1.6,0.8c0.1,0.1,0.1,0.1,0.2,0l0.7-0.5c0.1-0.1,0.1-0.1,0-0.2 c-0.5-0.8-1.4-1.2-2.5-1.2c-1.4,0-2.5,0.7-2.9,2C89.7-1431.5,89.6-1430.9,89.6-1430.1 M103.9-1426.4c0.1,0,0.2-0.1,0.2-0.2v-4.6 c0-1.7-0.9-2.7-2.5-2.7c-1,0-1.7,0.4-2,1h0v-3.7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v10.1c0,0.1,0.1,0.2,0.2,0.2h1 c0.1,0,0.2-0.1,0.2-0.2v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2H103.9z M109.8-1426.3 c1.3,0,2.3-0.5,2.9-1.2c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3 c-0.1-0.2-0.1-0.5-0.1-0.9c0-0.1,0-0.1,0.1-0.1h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2 c-1.4,0-2.5,0.7-2.9,2c-0.2,0.4-0.2,1-0.2,1.8c0,0.8,0.1,1.4,0.2,1.8C107.2-1427,108.3-1426.3,109.8-1426.3 M108-1430.7 C107.9-1430.7,107.9-1430.8,108-1430.7c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1 c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H108z M121.2-1426.4c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7 c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2 v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2H121.2z M124.2-1426.6c0,0.1,0.1,0.2,0.2,0.2h1.2 c0.1,0,0.2-0.1,0.2-0.2v-1.3c0-0.1-0.1-0.2-0.2-0.2h-1.2c-0.1,0-0.2,0.1-0.2,0.2V-1426.6z M131-1426.6c0,0.1,0.1,0.2,0.2,0.2h1.1 c0.1,0,0.2-0.1,0.2-0.2v-4.4c0-0.1,0-0.1,0.1-0.1h4.5c0.1,0,0.1,0,0.1,0.1v4.4c0,0.1,0.1,0.2,0.2,0.2h1.1c0.1,0,0.2-0.1,0.2-0.2 v-10.1c0-0.1-0.1-0.2-0.2-0.2h-1.1c-0.1,0-0.2,0.1-0.2,0.2v4.3c0,0.1,0,0.1-0.1,0.1h-4.5c-0.1,0-0.1,0-0.1-0.1v-4.3 c0-0.1-0.1-0.2-0.2-0.2h-1.1c-0.1,0-0.2,0.1-0.2,0.2V-1426.6z M144.2-1426.3c1.3,0,2.3-0.5,2.9-1.2c0.1-0.1,0.1-0.2,0-0.2 l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9c0-0.1,0-0.1,0.1-0.1 h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2c-0.2,0.4-0.2,1-0.2,1.8 c0,0.8,0.1,1.4,0.2,1.8C141.7-1427,142.7-1426.3,144.2-1426.3 M142.5-1430.7C142.4-1430.7,142.4-1430.8,142.5-1430.7 c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H142.5z  M151.1-1435.4c0.1,0,0.2-0.1,0.2-0.2v-1.1c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v1.1c0,0.1,0.1,0.2,0.2,0.2H151.1z  M151-1426.4c0.1,0,0.2-0.1,0.2-0.2v-7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2H151z  M164.3-1426.4c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.6-2.7c-1.1,0-1.9,0.4-2.4,1.1h0c-0.4-0.7-1.1-1.1-2.1-1.1 c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2 v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-4.3 c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2H164.3z M172.8-1426.4c0.1,0,0.2-0.1,0.2-0.2v-4.8 c0-1.8-0.8-2.5-2.9-2.5c-1.1,0-1.9,0.3-2.5,0.7c-0.1,0.1-0.1,0.1,0,0.2l0.4,0.7c0,0.1,0.1,0.1,0.2,0c0.4-0.3,0.9-0.5,1.8-0.5 c1.4,0,1.8,0.4,1.8,1.4v0.5c0,0.1,0,0.1-0.1,0.1H170c-1.8,0-2.9,0.7-2.9,2.3c0,1.5,1.1,2.2,2.5,2.2c1.1,0,1.8-0.4,2.2-1h0v0.6 c0,0.1,0.1,0.2,0.2,0.2H172.8z M169.9-1427.4c-1,0-1.5-0.4-1.5-1.1c0-0.8,0.5-1.2,1.8-1.2h1.5c0.1,0,0.1,0,0.1,0.1v0.8 C171.7-1427.9,171-1427.4,169.9-1427.4 M178.7-1426.4c0.1,0,0.2-0.1,0.2-0.2v-0.9c0-0.1-0.1-0.2-0.2-0.2h-0.3 c-0.7,0-0.9-0.2-0.9-0.9v-4.1c0-0.1,0-0.1,0.1-0.1h1.2c0.1,0,0.2-0.1,0.2-0.2v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1.2 c-0.1,0-0.1,0-0.1-0.1v-2.1c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v2.1c0,0.1,0,0.1-0.1,0.1h-0.6 c-0.1,0-0.2,0.1-0.2,0.2v0.7c0,0.1,0.1,0.2,0.2,0.2h0.6c0.1,0,0.1,0,0.1,0.1v4.2c0,1.4,0.5,2.1,2,2.1H178.7z M181.6-1426.6 c0,0.1,0.1,0.2,0.2,0.2h1.2c0.1,0,0.2-0.1,0.2-0.2v-1.3c0-0.1-0.1-0.2-0.2-0.2h-1.2c-0.1,0-0.2,0.1-0.2,0.2V-1426.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -65.3,
    y: -1462.1,
    style: {
      clipPath: "url(#SVGID_00000106105888890919458750000004246193485053451187_)",
      fill: "#FFFFFF"
    },
    width: 48.1,
    height: 40.1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000106105888890919458750000004246193485053451187_)",
      fill: "#005CA9"
    },
    d: "M-50.5-1426.8 c-5.1,0-9.3-4.6-9.3-10.2c0-1.4,0.2-3.1,0.6-4.3c1.4-3.6,4.8-5.9,8.7-5.9c3.8,0,7.2,2.3,8.7,5.9c0.5,1.3,0.7,2.9,0.7,4.3 C-41.2-1431.3-45.4-1426.8-50.5-1426.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000106105888890919458750000004246193485053451187_)",
      fill: "#005CA9"
    },
    points: " -41.8,-1445.9 -42.8,-1451.6 -47.8,-1452.7 -42.8,-1453.7 -41.8,-1458.8 -40.9,-1453.7 -35.8,-1452.7 -40.7,-1451.6  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000106105888890919458750000004246193485053451187_)",
      fill: "#005CA9"
    },
    d: "M-23.4-1427.2h-16.8 v-0.7l10.4-17.2l0-0.4H-34c-1.6,0-2.3,0.5-3,1.1c-0.7,0.5-1,1.2-1.3,1.9c-0.2,0.6-0.3,1.3-0.3,1.3h-0.7l0.4-5.4h15.6l-10.9,18 v0.2c0,0,2.5,0.1,3.6,0.1c1-0.1,3.9-0.2,5.3-1.8c1.1-1.3,1.5-2.5,1.8-3.7c0-0.1,0.1-0.3,0.1-0.3l0.7,0L-23.4-1427.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000106105888890919458750000004246193485053451187_)",
      fill: "#FFFFFF"
    },
    d: "M-50.5-1445.7 c-1.2,0-2.5,0.9-3.3,2.6c-0.7,1.6-0.9,3.8-1,6.1c-0.1,5.9,1.8,8.7,4.2,8.7c2.4,0,4.1-2.8,4.2-8.7c0-2.3-0.1-4.6-0.8-6.1 C-48-1444.8-49.2-1445.7-50.5-1445.7"
  })))), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 2048,
    height: 1331,
    xlinkHref: "9696B912.jpg",
    transform: "matrix(0.6215 0 0 0.631 -1438.1608 -1521.5685)"
  }), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: -1435.8,
    y: -1503.6,
    className: "st25",
    width: 634,
    height: 804
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: -801.8,
    y: -1503.6,
    className: "st23",
    width: 634,
    height: 804
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -615.7269 -1133.4379)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "24.0745px"
    }
  }, "Thursday, 23 September"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -620.887 -1184.2434)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Bold'",
      fontSize: "100.3104px"
    }
  }, "10:18"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M-536.1-1029.9h-69.6c-2.9,0-5.3-2.4-5.3-5.3v-29.8c0-2.9,2.4-5.3,5.3-5.3h69.6c2.9,0,5.3,2.4,5.3,5.3v29.8 C-530.9-1032.3-533.2-1029.9-536.1-1029.9z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -595.5291 -1045.1005)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "15 Min")), /*#__PURE__*/React.createElement("g", null, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-448.4-1029.9H-518c-2.9,0-5.3-2.4-5.3-5.3v-29.8c0-2.9,2.4-5.3,5.3-5.3h69.6c2.9,0,5.3,2.4,5.3,5.3v29.8 C-443.1-1032.3-445.5-1029.9-448.4-1029.9z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -507.7953 -1045.0999)",
    style: {
      opacity: 0.7,
      fill: "#4D4D4D",
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "30 Min")), /*#__PURE__*/React.createElement("g", null, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-360.7-1029.9h-69.6c-2.9,0-5.3-2.4-5.3-5.3v-29.8c0-2.9,2.4-5.3,5.3-5.3h69.6c2.9,0,5.3,2.4,5.3,5.3v29.8 C-355.4-1032.3-357.8-1029.9-360.7-1029.9z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -420.0614 -1045.101)",
    style: {
      opacity: 0.7,
      fill: "#4D4D4D",
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "60 Min"))), /*#__PURE__*/React.createElement("g", null, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M-430.3-951.1h-105.9c-3.5,0-6.4-2.9-6.4-6.4V-985c0-3.5,2.9-6.4,6.4-6.4h105.9c3.5,0,6.4,2.9,6.4,6.4v27.5 C-423.9-954-426.7-951.1-430.3-951.1z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -507.7953 -966.3062)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "30 Min"))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M-455-752.4h-56.3c-5.7,0-10.3-4.6-10.3-10.3v-56.3c0-5.7,4.6-10.3,10.3-10.3h56.3c5.7,0,10.3,4.6,10.3,10.3 v56.3C-444.7-757-449.3-752.4-455-752.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-490.3-800.4h-3c-0.7,0-1.3-0.6-1.3-1.3v-11.5c0-0.7,0.6-1.3,1.3-1.3h3c0.7,0,1.3,0.6,1.3,1.3v11.5 C-489-801-489.6-800.4-490.3-800.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-472.5-800.4h-3c-0.7,0-1.3-0.6-1.3-1.3v-11.5c0-0.7,0.6-1.3,1.3-1.3h3c0.7,0,1.3,0.6,1.3,1.3v11.5 C-471.2-801-471.8-800.4-472.5-800.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-502.1-799v-2.9c0-3,2.4-5.4,5.4-5.4h26.9c3,0,5.4,2.4,5.4,5.4v2.9H-502.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-502.1-772.8v-24.3h37.7v24.3c0,3-2.4,5.4-5.4,5.4h-26.9C-499.6-767.4-502.1-769.8-502.1-772.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -502.1,
    y: -799,
    className: "st7",
    width: 37.7,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -502.1,
    y: -787.9,
    className: "st7",
    width: 37.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -502.1,
    y: -777.7,
    className: "st7",
    width: 37.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -497.9,
    y: -782.4,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -1265.3507 -298.927)",
    className: "st7",
    width: 29.5,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -488.4,
    y: -782.4,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -1255.8124 -308.4653)",
    className: "st7",
    width: 29.5,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -507.5,
    y: -782.4,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -1274.8889 -289.3887)",
    className: "st7",
    width: 29.5,
    height: 0.5
  })))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -1251.2108 -1126.3727)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 40
    }
  }, "Meeting Room"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -1233.7504 -1076.8408)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Bold'",
      fontSize: 20
    }
  }, "Available for 15 minutes"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000155125701760143015590000000551643875136480410_",
    x: -1417.1,
    y: -1484.9,
    width: 299.5,
    height: 88.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178921432899076085880000005910833482611124912_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155125701760143015590000000551643875136480410_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178921432899076085880000005910833482611124912_)"
    }
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000142169002645488929770000013829197591086050218_",
    x: -1417.1,
    y: -1484.9,
    width: 299.5,
    height: 88.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011748657380841074290000008031168978497782691_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142169002645488929770000013829197591086050218_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011748657380841074290000008031168978497782691_)",
      fill: "#FFFFFF"
    },
    d: "M-1326.9-1457 c-4.5,0-7.1,2.8-7.1,7.6c0,4.9,2.6,7.6,7.1,7.6c4.5,0,7.1-2.8,7.1-7.6C-1319.8-1454.2-1322.4-1457-1326.9-1457 M-1322.4-1449.4 c0,3-0.8,6.6-4.5,6.6c-3.6,0-4.4-3.6-4.5-6.6c0-3,0.8-6.6,4.5-6.6C-1323.2-1456-1322.4-1452.4-1322.4-1449.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011748657380841074290000008031168978497782691_)",
      fill: "#FFFFFF"
    },
    d: "M-1311.9-1450.7 l-0.7-0.2c-0.9-0.3-2.5-1.1-2.5-2.5c0-1.5,1-2.5,2.5-2.5c1.7,0,2.7,1,3,3l0,0.1h0.9v-3.1l-0.1,0c-0.7-0.6-2.1-0.9-3.6-0.9 c-2.3,0-4.9,1.1-4.9,4.2c0,2.5,2.3,3.6,4,4.2l0.4,0.1c1,0.4,2.8,1.3,2.8,3c0,1.7-1.1,2.7-2.9,2.7c-1.8,0-3.1-1.3-3.6-3.7l0-0.1 h-0.9l0.2,3.5l0,0c1,0.9,2.9,1.3,4.2,1.3c3.9,0,5.3-2.3,5.3-4.4C-1307.7-1448.8-1309.7-1449.9-1311.9-1450.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011748657380841074290000008031168978497782691_)",
      fill: "#FFFFFF"
    },
    d: "M-1305.7-1453h0.9 l0-0.1c0.2-2.2,0.7-2.6,3-2.6h1.1v11.6c0,1.1,0,1.1-2.2,1.2l-0.1,0v0.9h6.9v-0.9l-0.1,0c-2.2-0.1-2.2-0.1-2.2-1.2v-11.6h1.1 c2.3,0,2.7,0.4,3,2.6l0,0.1h0.9v-3.7h-12.3V-1453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011748657380841074290000008031168978497782691_)",
      fill: "#FFFFFF"
    },
    d: "M-1285.5-1450.7 l-0.7-0.2c-0.9-0.3-2.5-1.1-2.5-2.5c0-1.5,1-2.5,2.5-2.5c1.7,0,2.7,1,3,3l0,0.1h0.9v-3.1l-0.1,0c-0.7-0.6-2.1-0.9-3.6-0.9 c-2.3,0-4.9,1.1-4.9,4.2c0,2.5,2.3,3.6,4,4.2l0.4,0.1c1,0.4,2.8,1.3,2.8,3c0,1.7-1.1,2.7-2.9,2.7c-1.8,0-3.1-1.3-3.6-3.7l0-0.1 h-0.9l0.2,3.5l0,0c1,0.9,2.9,1.3,4.2,1.3c3.9,0,5.3-2.3,5.3-4.4C-1281.3-1448.8-1283.3-1449.9-1285.5-1450.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011748657380841074290000008031168978497782691_)",
      fill: "#FFFFFF"
    },
    d: "M-1268.4-1445.8 c-0.5,2.4-1.2,2.8-3.9,2.8c-0.8,0-1.7,0-2.1-0.2c-0.4-0.2-0.4-0.4-0.4-1.4v-4.5h2.8c1.7,0,1.7,0.4,1.9,1.7l0,0.1h0.9v-4.7h-0.9 l0,0.1c-0.2,1.3-0.2,1.7-1.9,1.7h-2.8v-4.9c0-0.6,0-0.6,0.6-0.6h2c2.3,0,2.7,0.5,3,2.6l0,0.1h0.9v-3.7h-10.8v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h11.3l0.3-3.9h-0.9L-1268.4-1445.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011748657380841074290000008031168978497782691_)",
      fill: "#FFFFFF"
    },
    d: "M-1254.7-1445.9 l0,0.1c-0.5,2.4-1.2,2.8-3.9,2.8c-0.8,0-1.7,0-2.1-0.2c-0.4-0.2-0.4-0.4-0.4-1.4v-4.5h2.8c1.7,0,1.7,0.4,1.9,1.7l0,0.1h0.9v-4.7 h-0.9l0,0.1c-0.2,1.3-0.2,1.7-1.9,1.7h-2.8v-4.9c0-0.6,0-0.6,0.6-0.6h2c2.3,0,2.7,0.5,3,2.6l0,0.1h0.9v-3.7h-10.8v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h11.3l0.3-3.9H-1254.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011748657380841074290000008031168978497782691_)",
      fill: "#FFFFFF"
    },
    d: "M-1232.1-1445.9 c-0.4,2.5-1.3,2.9-4.4,2.9h-3.9c2.9-4.3,5.9-8.5,9.1-13.2l0-0.1l-0.2-0.4h-10.8v3.9h0.9l0-0.1c0.2-2.3,0.7-2.7,3.5-2.7h3.5 c-3.3,4.8-6.6,9.5-9.1,13.2l0,0.1l0.2,0.4h12.1l0.2-4h-0.9L-1232.1-1445.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011748657380841074290000008031168978497782691_)",
      fill: "#FFFFFF"
    },
    d: "M-1218.6-1445.8 c-0.5,2.4-1.2,2.8-3.9,2.8c-0.8,0-1.7,0-2.1-0.2c-0.4-0.2-0.4-0.4-0.4-1.4v-4.5h2.8c1.7,0,1.7,0.4,1.9,1.7l0,0.1h0.9v-4.7h-0.9 l0,0.1c-0.2,1.3-0.2,1.7-1.9,1.7h-2.8v-4.9c0-0.6,0-0.6,0.6-0.6h2c2.3,0,2.7,0.5,3,2.6l0,0.1h0.9v-3.7h-10.8v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h11.3l0.3-3.9h-0.9L-1218.6-1445.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011748657380841074290000008031168978497782691_)",
      fill: "#FFFFFF"
    },
    d: "M-1215.2-1455.8 l0.1,0c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h6.1v-0.9l-0.1,0c-1.7-0.1-1.7-0.1-1.7-1.2v-10.5 c0-1.1,0-1.1,1.7-1.2l0.1,0v-0.9h-6.1V-1455.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011748657380841074290000008031168978497782691_)",
      fill: "#FFFFFF"
    },
    d: "M-1206.8-1453h0.9 l0-0.1c0.2-2.2,0.7-2.6,3-2.6h1.1v11.6c0,1.1,0,1.1-2.2,1.2l-0.1,0v0.9h6.9v-0.9l-0.1,0c-2.2-0.1-2.2-0.1-2.2-1.2v-11.6h1.1 c2.3,0,2.7,0.4,3,2.6l0,0.1h0.9v-3.7h-12.3V-1453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011748657380841074290000008031168978497782691_)",
      fill: "#FFFFFF"
    },
    d: "M-1183.3-1455.8 l0.1,0c1.7,0.1,1.7,0.1,1.7,1.2v6.7c0,3.5-1.1,5.2-3.6,5.2c-3.2,0-3.5-2.9-3.5-5.2v-6.7c0-1.1,0-1.1,1.7-1.2l0.1,0v-0.9h-6.1v0.9 l0.1,0c1.7,0.1,1.7,0.1,1.7,1.2v7.2c0.1,3.9,1.9,5.7,5.9,5.7c4,0,5.9-1.8,5.9-5.8v-7.1c0-1.1,0-1.1,1.7-1.2l0.1,0v-0.9h-6.1 V-1455.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011748657380841074290000008031168978497782691_)",
      fill: "#FFFFFF"
    },
    d: "M-1165.1-1455.8 l0.1,0c1.4,0.1,1.7,0.2,1.8,0.9c0.1,0.7,0.1,1.4,0.1,2.6v6.9c-2.7-3.7-5.3-7.5-7.9-11.2l0-0.1h-4.2v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v8.2c0,1.1,0,1.9-0.1,2.6c-0.1,0.7-0.5,0.8-1.6,0.9l-0.1,0v0.9h5.2v-0.9l-0.1,0 c-1.4-0.1-1.7-0.2-1.8-0.9c-0.1-0.7-0.1-1.4-0.1-2.6v-7.9c3.2,4.5,5.9,8.3,8.6,12.2l0,0.1h1.6v-10.3c0-1.1,0-1.9,0.1-2.6 c0.1-0.7,0.5-0.8,1.6-0.9l0.1,0v-0.9h-5.2V-1455.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011748657380841074290000008031168978497782691_)",
      fill: "#FFFFFF"
    },
    d: "M-1149.7-1448.8v0.9 l0.1,0c2.1,0.1,2.1,0.2,2.1,1.2v2.8c0,0.6-0.2,0.8-0.6,1c-0.5,0.2-1.1,0.3-1.8,0.3c-5,0-5.5-4.7-5.5-6.7c0-2,0.5-6.6,5.3-6.6 c2.3,0,3.5,1,3.9,3.3l0,0.1h0.9v-3.5l-0.1,0c-1.1-0.5-2.9-0.9-4.5-0.9c-5.2,0-8.1,2.8-8.1,7.9c0,2.6,1,4.8,2.6,6l0,0 c1.7,1.2,3.7,1.4,5.3,1.4c1.5,0,3.5-0.5,4.8-0.9l0.1,0v-4.2c0-0.9,0-1,1.4-1.2l0.1,0v-0.9H-1149.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1251,
    y: -1449.6,
    style: {
      clipPath: "url(#SVGID_00000011748657380841074290000008031168978497782691_)",
      fill: "#FFFFFF"
    },
    width: 5.4,
    height: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011748657380841074290000008031168978497782691_)",
      fill: "#FFFFFF"
    },
    d: "M-1332.9-1426.6 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-7.2h0l2.6,5.7c0.1,0.1,0.1,0.2,0.3,0.2h0.6c0.1,0,0.2,0,0.3-0.2l2.6-5.7h0v7.2 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-10.1c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0-0.2,0.2l-3,7h0l-3.1-7 c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2V-1426.6z M-1318.1-1426.3c1.3,0,2.3-0.5,2.9-1.2c0.1-0.1,0.1-0.2,0-0.2 l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9c0-0.1,0-0.1,0.1-0.1 h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2c-0.2,0.4-0.2,1-0.2,1.8 c0,0.8,0.1,1.4,0.2,1.8C-1320.6-1427-1319.6-1426.3-1318.1-1426.3 M-1319.9-1430.7C-1319.9-1430.7-1320-1430.8-1319.9-1430.7 c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-1319.9z  M-1306.3-1426.4c0.1,0,0.2-0.1,0.2-0.2v-10.1c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v3.8h0c-0.3-0.6-1-1-2.1-1 c-1.3,0-2.1,0.6-2.5,1.8c-0.2,0.6-0.3,1.2-0.3,2.1c0,0.9,0.1,1.5,0.3,2.1c0.4,1.2,1.2,1.8,2.5,1.8c1.1,0,1.7-0.4,2.1-1h0v0.7 c0,0.1,0.1,0.2,0.2,0.2H-1306.3z M-1309.2-1427.5c-0.8,0-1.4-0.4-1.6-1.1c-0.1-0.4-0.2-0.9-0.2-1.5c0-0.7,0-1.1,0.2-1.5 c0.2-0.7,0.8-1.1,1.6-1.1c0.8,0,1.4,0.4,1.6,1.1c0.1,0.4,0.2,0.8,0.2,1.5c0,0.7,0,1.2-0.2,1.5 C-1307.8-1427.8-1308.4-1427.5-1309.2-1427.5 M-1302.2-1435.4c0.1,0,0.2-0.1,0.2-0.2v-1.1c0-0.1-0.1-0.2-0.2-0.2h-1 c-0.1,0-0.2,0.1-0.2,0.2v1.1c0,0.1,0.1,0.2,0.2,0.2H-1302.2z M-1302.2-1426.4c0.1,0,0.2-0.1,0.2-0.2v-7c0-0.1-0.1-0.2-0.2-0.2h-1 c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2H-1302.2z M-1295.9-1426.3c1.3,0,2.3-0.5,2.9-1.2c0.1-0.1,0.1-0.2,0-0.2 l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9c0-0.1,0-0.1,0.1-0.1 h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2c-0.2,0.4-0.2,1-0.2,1.8 c0,0.8,0.1,1.4,0.2,1.8C-1298.4-1427-1297.4-1426.3-1295.9-1426.3 M-1297.7-1430.7C-1297.7-1430.7-1297.8-1430.8-1297.7-1430.7 c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-1297.7z  M-1284.5-1426.4c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1 c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3 c0,0.1,0.1,0.2,0.2,0.2H-1284.5z M-1281.5-1426.6c0,0.1,0.1,0.2,0.2,0.2h1.2c0.1,0,0.2-0.1,0.2-0.2v-1.3c0-0.1-0.1-0.2-0.2-0.2 h-1.2c-0.1,0-0.2,0.1-0.2,0.2V-1426.6z M-1274.7-1426.6c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-7.2h0l2.6,5.7 c0.1,0.1,0.1,0.2,0.3,0.2h0.6c0.1,0,0.2,0,0.3-0.2l2.6-5.7h0v7.2c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-10.1 c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0-0.2,0.2l-3,7h0l-3.1-7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2V-1426.6z  M-1259.9-1426.3c1.3,0,2.3-0.5,2.9-1.2c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8 c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9c0-0.1,0-0.1,0.1-0.1h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1 c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2c-0.2,0.4-0.2,1-0.2,1.8c0,0.8,0.1,1.4,0.2,1.8 C-1262.4-1427-1261.4-1426.3-1259.9-1426.3 M-1261.7-1430.7C-1261.7-1430.7-1261.7-1430.8-1261.7-1430.7c-0.1-0.4-0.1-0.7,0-0.9 c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-1261.7z M-1248.2-1426.4 c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v7 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2 H-1248.2z M-1242.5-1426.3c1.9,0,2.9-1,2.9-2.4c0-1.2-0.7-1.9-2.2-2.1l-0.8-0.1c-1.1-0.1-1.4-0.4-1.4-1c0-0.6,0.5-1,1.4-1 c0.7,0,1.5,0.3,2,0.6c0.1,0,0.2,0,0.2,0l0.5-0.7c0-0.1,0-0.2,0-0.2c-0.6-0.5-1.5-0.8-2.6-0.8c-1.7,0-2.7,0.8-2.7,2.2 c0,1.2,0.7,1.9,2.2,2.1l0.8,0.1c1.1,0.1,1.4,0.4,1.4,1c0,0.7-0.5,1.1-1.6,1.1c-0.9,0-1.7-0.4-2.3-0.8c-0.1-0.1-0.2-0.1-0.2,0 l-0.6,0.7c-0.1,0.1-0.1,0.2,0,0.2C-1244.9-1426.8-1243.9-1426.3-1242.5-1426.3 M-1237.1-1430.1c0,0.8,0.1,1.4,0.2,1.9 c0.4,1.3,1.5,2,2.9,2c1.1,0,2-0.5,2.5-1.2c0-0.1,0-0.1,0-0.2l-0.7-0.5c-0.1-0.1-0.2-0.1-0.2,0c-0.4,0.5-0.8,0.8-1.6,0.8 c-0.8,0-1.4-0.4-1.6-1.1c-0.1-0.4-0.2-0.8-0.2-1.5c0-0.6,0-1.1,0.2-1.5c0.2-0.8,0.8-1.1,1.6-1.1c0.7,0,1.1,0.3,1.6,0.8 c0.1,0.1,0.1,0.1,0.2,0l0.7-0.5c0.1-0.1,0.1-0.1,0-0.2c-0.5-0.8-1.4-1.2-2.5-1.2c-1.4,0-2.5,0.7-2.9,2 C-1237-1431.5-1237.1-1430.9-1237.1-1430.1 M-1222.8-1426.4c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7c-1,0-1.7,0.4-2,1 h0v-3.7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v10.1c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-4.3 c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2H-1222.8z M-1216.9-1426.3c1.3,0,2.3-0.5,2.9-1.2 c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9 c0-0.1,0-0.1,0.1-0.1h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2 c-0.2,0.4-0.2,1-0.2,1.8c0,0.8,0.1,1.4,0.2,1.8C-1219.4-1427-1218.4-1426.3-1216.9-1426.3 M-1218.6-1430.7 C-1218.7-1430.7-1218.7-1430.8-1218.6-1430.7c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1 c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-1218.6z M-1205.5-1426.4c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7 c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2 v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2H-1205.5z M-1202.5-1426.6c0,0.1,0.1,0.2,0.2,0.2 h1.2c0.1,0,0.2-0.1,0.2-0.2v-1.3c0-0.1-0.1-0.2-0.2-0.2h-1.2c-0.1,0-0.2,0.1-0.2,0.2V-1426.6z M-1195.7-1426.6 c0,0.1,0.1,0.2,0.2,0.2h1.1c0.1,0,0.2-0.1,0.2-0.2v-4.4c0-0.1,0-0.1,0.1-0.1h4.5c0.1,0,0.1,0,0.1,0.1v4.4c0,0.1,0.1,0.2,0.2,0.2 h1.1c0.1,0,0.2-0.1,0.2-0.2v-10.1c0-0.1-0.1-0.2-0.2-0.2h-1.1c-0.1,0-0.2,0.1-0.2,0.2v4.3c0,0.1,0,0.1-0.1,0.1h-4.5 c-0.1,0-0.1,0-0.1-0.1v-4.3c0-0.1-0.1-0.2-0.2-0.2h-1.1c-0.1,0-0.2,0.1-0.2,0.2V-1426.6z M-1182.4-1426.3c1.3,0,2.3-0.5,2.9-1.2 c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9 c0-0.1,0-0.1,0.1-0.1h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2 c-0.2,0.4-0.2,1-0.2,1.8c0,0.8,0.1,1.4,0.2,1.8C-1184.9-1427-1183.9-1426.3-1182.4-1426.3 M-1184.2-1430.7 C-1184.2-1430.7-1184.3-1430.8-1184.2-1430.7c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1 c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-1184.2z M-1175.6-1435.4c0.1,0,0.2-0.1,0.2-0.2v-1.1c0-0.1-0.1-0.2-0.2-0.2h-1 c-0.1,0-0.2,0.1-0.2,0.2v1.1c0,0.1,0.1,0.2,0.2,0.2H-1175.6z M-1175.6-1426.4c0.1,0,0.2-0.1,0.2-0.2v-7c0-0.1-0.1-0.2-0.2-0.2h-1 c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2H-1175.6z M-1162.3-1426.4c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.6-2.7 c-1.1,0-1.9,0.4-2.4,1.1h0c-0.4-0.7-1.1-1.1-2.1-1.1c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v7 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2h1 c0.1,0,0.2-0.1,0.2-0.2v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2H-1162.3z M-1153.8-1426.4 c0.1,0,0.2-0.1,0.2-0.2v-4.8c0-1.8-0.8-2.5-2.9-2.5c-1.1,0-1.9,0.3-2.5,0.7c-0.1,0.1-0.1,0.1,0,0.2l0.4,0.7c0,0.1,0.1,0.1,0.2,0 c0.4-0.3,0.9-0.5,1.8-0.5c1.4,0,1.8,0.4,1.8,1.4v0.5c0,0.1,0,0.1-0.1,0.1h-1.7c-1.8,0-2.9,0.7-2.9,2.3c0,1.5,1.1,2.2,2.5,2.2 c1.1,0,1.8-0.4,2.2-1h0v0.6c0,0.1,0.1,0.2,0.2,0.2H-1153.8z M-1156.8-1427.4c-1,0-1.5-0.4-1.5-1.1c0-0.8,0.5-1.2,1.8-1.2h1.5 c0.1,0,0.1,0,0.1,0.1v0.8C-1154.9-1427.9-1155.6-1427.4-1156.8-1427.4 M-1148-1426.4c0.1,0,0.2-0.1,0.2-0.2v-0.9 c0-0.1-0.1-0.2-0.2-0.2h-0.3c-0.7,0-0.9-0.2-0.9-0.9v-4.1c0-0.1,0-0.1,0.1-0.1h1.2c0.1,0,0.2-0.1,0.2-0.2v-0.7 c0-0.1-0.1-0.2-0.2-0.2h-1.2c-0.1,0-0.1,0-0.1-0.1v-2.1c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v2.1 c0,0.1,0,0.1-0.1,0.1h-0.6c-0.1,0-0.2,0.1-0.2,0.2v0.7c0,0.1,0.1,0.2,0.2,0.2h0.6c0.1,0,0.1,0,0.1,0.1v4.2c0,1.4,0.5,2.1,2,2.1 H-1148z M-1145-1426.6c0,0.1,0.1,0.2,0.2,0.2h1.2c0.1,0,0.2-0.1,0.2-0.2v-1.3c0-0.1-0.1-0.2-0.2-0.2h-1.2c-0.1,0-0.2,0.1-0.2,0.2 V-1426.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1391.9,
    y: -1462.1,
    style: {
      clipPath: "url(#SVGID_00000011748657380841074290000008031168978497782691_)",
      fill: "#FFFFFF"
    },
    width: 48.1,
    height: 40.1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011748657380841074290000008031168978497782691_)",
      fill: "#005CA9"
    },
    d: "M-1377.2-1426.8 c-5.1,0-9.3-4.6-9.3-10.2c0-1.4,0.2-3.1,0.6-4.3c1.4-3.6,4.8-5.9,8.7-5.9c3.8,0,7.2,2.3,8.7,5.9c0.5,1.3,0.7,2.9,0.7,4.3 C-1367.8-1431.3-1372-1426.8-1377.2-1426.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000011748657380841074290000008031168978497782691_)",
      fill: "#005CA9"
    },
    points: " -1368.4,-1445.9 -1369.5,-1451.6 -1374.4,-1452.7 -1369.5,-1453.7 -1368.4,-1458.8 -1367.6,-1453.7 -1362.4,-1452.7  -1367.4,-1451.6  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011748657380841074290000008031168978497782691_)",
      fill: "#005CA9"
    },
    d: "M-1350-1427.2h-16.8 v-0.7l10.4-17.2l0-0.4h-4.2c-1.6,0-2.3,0.5-3,1.1c-0.7,0.5-1,1.2-1.3,1.9c-0.2,0.6-0.3,1.3-0.3,1.3h-0.7l0.4-5.4h15.6l-10.9,18 v0.2c0,0,2.5,0.1,3.6,0.1c1-0.1,3.9-0.2,5.3-1.8c1.1-1.3,1.5-2.5,1.8-3.7c0-0.1,0.1-0.3,0.1-0.3l0.7,0L-1350-1427.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011748657380841074290000008031168978497782691_)",
      fill: "#FFFFFF"
    },
    d: "M-1377.1-1445.7 c-1.2,0-2.5,0.9-3.3,2.6c-0.7,1.6-0.9,3.8-1,6.1c-0.1,5.9,1.8,8.7,4.2,8.7c2.4,0,4.1-2.8,4.2-8.7c0-2.3-0.1-4.6-0.8-6.1 C-1374.6-1444.8-1375.9-1445.7-1377.1-1445.7"
  })))), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 2048,
    height: 1331,
    xlinkHref: "9696B92E.jpg",
    transform: "matrix(0.6215 0 0 0.631 -3358.1609 215.0974)"
  }), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: -3355.8,
    y: 233.1,
    className: "st35",
    width: 634,
    height: 804
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: -2721.8,
    y: 233.1,
    className: "st36",
    width: 634,
    height: 804
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -2535.7275 603.228)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "24.0745px"
    }
  }, "Thursday, 23 September"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -2540.8877 552.4226)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Bold'",
      fontSize: "100.3104px"
    }
  }, "10:18"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M-2456.1,706.8h-69.6c-2.9,0-5.3-2.4-5.3-5.3v-29.8c0-2.9,2.4-5.3,5.3-5.3h69.6c2.9,0,5.3,2.4,5.3,5.3v29.8 C-2450.9,704.4-2453.2,706.8-2456.1,706.8z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -2515.5295 691.5654)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "15 Min")), /*#__PURE__*/React.createElement("g", null, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-2368.4,706.8h-69.6c-2.9,0-5.3-2.4-5.3-5.3v-29.8c0-2.9,2.4-5.3,5.3-5.3h69.6c2.9,0,5.3,2.4,5.3,5.3v29.8 C-2363.1,704.4-2365.5,706.8-2368.4,706.8z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -2427.7957 691.5659)",
    style: {
      opacity: 0.7,
      fill: "#4D4D4D",
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "30 Min")), /*#__PURE__*/React.createElement("g", null, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-2280.7,706.8h-69.6c-2.9,0-5.3-2.4-5.3-5.3v-29.8c0-2.9,2.4-5.3,5.3-5.3h69.6c2.9,0,5.3,2.4,5.3,5.3v29.8 C-2275.4,704.4-2277.8,706.8-2280.7,706.8z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -2340.0618 691.5649)",
    style: {
      opacity: 0.7,
      fill: "#4D4D4D",
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "60 Min"))), /*#__PURE__*/React.createElement("g", null, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M-2350.3,785.6h-105.9c-3.5,0-6.4-2.9-6.4-6.4v-27.5c0-3.5,2.9-6.4,6.4-6.4h105.9c3.5,0,6.4,2.9,6.4,6.4v27.5 C-2343.9,782.7-2346.7,785.6-2350.3,785.6z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -2427.7957 770.3596)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "30 Min"))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M-2375,984.3h-56.3c-5.7,0-10.3-4.6-10.3-10.3v-56.3c0-5.7,4.6-10.3,10.3-10.3h56.3c5.7,0,10.3,4.6,10.3,10.3 V974C-2364.7,979.7-2369.3,984.3-2375,984.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-2410.3,936.3h-3c-0.7,0-1.3-0.6-1.3-1.3v-11.5c0-0.7,0.6-1.3,1.3-1.3h3c0.7,0,1.3,0.6,1.3,1.3V935 C-2409,935.7-2409.6,936.3-2410.3,936.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-2392.5,936.3h-3c-0.7,0-1.3-0.6-1.3-1.3v-11.5c0-0.7,0.6-1.3,1.3-1.3h3c0.7,0,1.3,0.6,1.3,1.3V935 C-2391.2,935.7-2391.8,936.3-2392.5,936.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-2422.1,937.6v-2.9c0-3,2.4-5.4,5.4-5.4h26.9c3,0,5.4,2.4,5.4,5.4v2.9H-2422.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-2422.1,963.9v-24.3h37.7v24.3c0,3-2.4,5.4-5.4,5.4h-26.9C-2419.6,969.3-2422.1,966.9-2422.1,963.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2422.1,
    y: 937.6,
    className: "st7",
    width: 37.7,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2422.1,
    y: 948.8,
    className: "st7",
    width: 37.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2422.1,
    y: 959,
    className: "st7",
    width: 37.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2417.9,
    y: 954.3,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -1448.6848 3357.7388)",
    className: "st7",
    width: 29.5,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2408.4,
    y: 954.3,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -1439.1466 3348.2004)",
    className: "st7",
    width: 29.5,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2427.5,
    y: 954.3,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -1458.2231 3367.2771)",
    className: "st7",
    width: 29.5,
    height: 0.5
  })))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -3171.2107 610.2932)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 40
    }
  }, "Meeting Room"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -3153.7502 659.8252)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Bold'",
      fontSize: 20
    }
  }, "Available for 15 minutes"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000019643176690350757780000010537386086012287144_",
    x: -3337.1,
    y: 251.7,
    width: 299.5,
    height: 88.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016782133726500279550000014293283522438704265_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019643176690350757780000010537386086012287144_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000016782133726500279550000014293283522438704265_)"
    }
  }, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000115486674492207382260000017527620057810989699_",
    x: -3337.1,
    y: 251.7,
    width: 299.5,
    height: 88.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000115478958645754101060000005593174696276574142_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000115486674492207382260000017527620057810989699_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000115478958645754101060000005593174696276574142_)",
      fill: "#FFFFFF"
    },
    d: "M-3246.9,279.7 c-4.5,0-7.1,2.8-7.1,7.6c0,4.9,2.6,7.6,7.1,7.6c4.5,0,7.1-2.8,7.1-7.6C-3239.8,282.5-3242.4,279.7-3246.9,279.7 M-3242.4,287.3 c0,3-0.8,6.6-4.5,6.6c-3.6,0-4.4-3.6-4.5-6.6c0-3,0.8-6.6,4.5-6.6C-3243.2,280.7-3242.4,284.3-3242.4,287.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000115478958645754101060000005593174696276574142_)",
      fill: "#FFFFFF"
    },
    d: "M-3231.9,286 l-0.7-0.2c-0.9-0.3-2.5-1.1-2.5-2.5c0-1.5,1-2.5,2.5-2.5c1.7,0,2.7,1,3,3l0,0.1h0.9v-3.1l-0.1,0c-0.7-0.6-2.1-0.9-3.6-0.9 c-2.3,0-4.9,1.1-4.9,4.1c0,2.5,2.3,3.6,4,4.2l0.4,0.1c1,0.4,2.8,1.3,2.8,3c0,1.7-1.1,2.7-2.9,2.7c-1.8,0-3.1-1.3-3.6-3.7l0-0.1 h-0.9l0.2,3.5l0,0c1,0.9,2.9,1.3,4.2,1.3c3.9,0,5.3-2.3,5.3-4.4C-3227.7,287.9-3229.7,286.8-3231.9,286"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000115478958645754101060000005593174696276574142_)",
      fill: "#FFFFFF"
    },
    d: "M-3225.7,283.7h0.9 l0-0.1c0.2-2.2,0.7-2.6,3-2.6h1.1v11.6c0,1.1,0,1.1-2.2,1.2l-0.1,0v0.9h6.9v-0.9l-0.1,0c-2.2-0.1-2.2-0.1-2.2-1.2V281h1.1 c2.3,0,2.7,0.4,3,2.6l0,0.1h0.9V280h-12.3V283.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000115478958645754101060000005593174696276574142_)",
      fill: "#FFFFFF"
    },
    d: "M-3205.5,286 l-0.7-0.2c-0.9-0.3-2.5-1.1-2.5-2.5c0-1.5,1-2.5,2.5-2.5c1.7,0,2.7,1,3,3l0,0.1h0.9v-3.1l-0.1,0c-0.7-0.6-2.1-0.9-3.6-0.9 c-2.3,0-4.9,1.1-4.9,4.1c0,2.5,2.3,3.6,4,4.2l0.4,0.1c1,0.4,2.8,1.3,2.8,3c0,1.7-1.1,2.7-2.9,2.7c-1.8,0-3.1-1.3-3.6-3.7l0-0.1 h-0.9l0.2,3.5l0,0c1,0.9,2.9,1.3,4.2,1.3c3.9,0,5.3-2.3,5.3-4.4C-3201.3,287.9-3203.3,286.8-3205.5,286"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000115478958645754101060000005593174696276574142_)",
      fill: "#FFFFFF"
    },
    d: "M-3188.4,290.9 c-0.5,2.4-1.2,2.8-3.9,2.8c-0.8,0-1.7,0-2.1-0.2c-0.4-0.2-0.4-0.4-0.4-1.4v-4.5h2.8c1.7,0,1.7,0.4,1.9,1.7l0,0.1h0.9v-4.7h-0.9 l0,0.1c-0.2,1.3-0.2,1.7-1.9,1.7h-2.8v-4.9c0-0.6,0-0.6,0.6-0.6h2c2.3,0,2.7,0.5,3,2.6l0,0.1h0.9V280h-10.8v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h11.3l0.3-3.9h-0.9L-3188.4,290.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000115478958645754101060000005593174696276574142_)",
      fill: "#FFFFFF"
    },
    d: "M-3174.7,290.8l0,0.1 c-0.5,2.4-1.2,2.8-3.9,2.8c-0.8,0-1.7,0-2.1-0.2c-0.4-0.2-0.4-0.4-0.4-1.4v-4.5h2.8c1.7,0,1.7,0.4,1.9,1.7l0,0.1h0.9v-4.7h-0.9 l0,0.1c-0.2,1.3-0.2,1.7-1.9,1.7h-2.8v-4.9c0-0.6,0-0.6,0.6-0.6h2c2.3,0,2.7,0.5,3,2.6l0,0.1h0.9V280h-10.8v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h11.3l0.3-3.9H-3174.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000115478958645754101060000005593174696276574142_)",
      fill: "#FFFFFF"
    },
    d: "M-3152.1,290.8 c-0.4,2.5-1.3,2.9-4.4,2.9h-3.9c2.9-4.3,5.9-8.5,9.1-13.2l0-0.1l-0.2-0.4h-10.8v3.9h0.9l0-0.1c0.2-2.3,0.7-2.7,3.5-2.7h3.5 c-3.3,4.8-6.6,9.5-9.1,13.2l0,0.1l0.2,0.4h12.1l0.2-4h-0.9L-3152.1,290.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000115478958645754101060000005593174696276574142_)",
      fill: "#FFFFFF"
    },
    d: "M-3138.6,290.9 c-0.5,2.4-1.2,2.8-3.9,2.8c-0.8,0-1.7,0-2.1-0.2c-0.4-0.2-0.4-0.4-0.4-1.4v-4.5h2.8c1.7,0,1.7,0.4,1.9,1.7l0,0.1h0.9v-4.7h-0.9 l0,0.1c-0.2,1.3-0.2,1.7-1.9,1.7h-2.8v-4.9c0-0.6,0-0.6,0.6-0.6h2c2.3,0,2.7,0.5,3,2.6l0,0.1h0.9V280h-10.8v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h11.3l0.3-3.9h-0.9L-3138.6,290.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000115478958645754101060000005593174696276574142_)",
      fill: "#FFFFFF"
    },
    d: "M-3135.2,280.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h6.1v-0.9l-0.1,0c-1.7-0.1-1.7-0.1-1.7-1.2v-10.5 c0-1.1,0-1.1,1.7-1.2l0.1,0V280h-6.1V280.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000115478958645754101060000005593174696276574142_)",
      fill: "#FFFFFF"
    },
    d: "M-3126.8,283.7h0.9 l0-0.1c0.2-2.2,0.7-2.6,3-2.6h1.1v11.6c0,1.1,0,1.1-2.2,1.2l-0.1,0v0.9h6.9v-0.9l-0.1,0c-2.2-0.1-2.2-0.1-2.2-1.2V281h1.1 c2.3,0,2.7,0.4,3,2.6l0,0.1h0.9V280h-12.3V283.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000115478958645754101060000005593174696276574142_)",
      fill: "#FFFFFF"
    },
    d: "M-3103.3,280.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v6.7c0,3.5-1.1,5.2-3.6,5.2c-3.2,0-3.5-2.9-3.5-5.2v-6.7c0-1.1,0-1.1,1.7-1.2l0.1,0V280h-6.1v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v7.2c0.1,3.9,1.9,5.7,5.9,5.7c4,0,5.9-1.8,5.9-5.8v-7.1c0-1.1,0-1.1,1.7-1.2l0.1,0V280h-6.1V280.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000115478958645754101060000005593174696276574142_)",
      fill: "#FFFFFF"
    },
    d: "M-3085.1,280.9l0.1,0 c1.4,0.1,1.7,0.2,1.8,0.9c0.1,0.7,0.1,1.4,0.1,2.6v6.9c-2.7-3.7-5.3-7.5-7.9-11.2l0-0.1h-4.2v0.9l0.1,0c1.7,0.1,1.7,0.1,1.7,1.2 v8.2c0,1.1,0,1.9-0.1,2.6c-0.1,0.7-0.5,0.8-1.6,0.9l-0.1,0v0.9h5.2v-0.9l-0.1,0c-1.4-0.1-1.7-0.2-1.8-0.9 c-0.1-0.7-0.1-1.4-0.1-2.6v-7.9c3.2,4.5,5.9,8.3,8.6,12.2l0,0.1h1.6v-10.3c0-1.1,0-1.9,0.1-2.6c0.1-0.7,0.5-0.8,1.6-0.9l0.1,0 V280h-5.2V280.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000115478958645754101060000005593174696276574142_)",
      fill: "#FFFFFF"
    },
    d: "M-3069.7,287.8v0.9 l0.1,0c2.1,0.1,2.1,0.2,2.1,1.2v2.8c0,0.6-0.2,0.8-0.6,1c-0.5,0.2-1.1,0.3-1.8,0.3c-5,0-5.5-4.7-5.5-6.7c0-2,0.5-6.6,5.3-6.6 c2.3,0,3.5,1,3.9,3.3l0,0.1h0.9v-3.5l-0.1,0c-1.1-0.5-2.9-0.9-4.5-0.9c-5.2,0-8.1,2.8-8.1,7.9c0,2.6,1,4.8,2.6,6l0,0 c1.7,1.2,3.7,1.4,5.3,1.4c1.5,0,3.5-0.5,4.8-0.9l0.1,0v-4.2c0-0.9,0-1,1.4-1.2l0.1,0v-0.9H-3069.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3171,
    y: 287,
    style: {
      clipPath: "url(#SVGID_00000115478958645754101060000005593174696276574142_)",
      fill: "#FFFFFF"
    },
    width: 5.4,
    height: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000115478958645754101060000005593174696276574142_)",
      fill: "#FFFFFF"
    },
    d: "M-3252.9,310.1 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-7.2h0l2.6,5.7c0.1,0.1,0.1,0.2,0.3,0.2h0.6c0.1,0,0.2,0,0.3-0.2l2.6-5.7h0v7.2 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2V300c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0-0.2,0.2l-3,7h0l-3.1-7 c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2V310.1z M-3238.1,310.4c1.3,0,2.3-0.5,2.9-1.2c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6 c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9c0-0.1,0-0.1,0.1-0.1h4.6 c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2c-0.2,0.4-0.2,1-0.2,1.8 c0,0.8,0.1,1.4,0.2,1.8C-3240.6,309.7-3239.6,310.4-3238.1,310.4 M-3239.9,305.9C-3239.9,305.9-3240,305.9-3239.9,305.9 c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1s1.4,0.4,1.7,1.1c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-3239.9z  M-3226.3,310.2c0.1,0,0.2-0.1,0.2-0.2V300c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v3.8h0c-0.3-0.6-1-1-2.1-1 c-1.3,0-2.1,0.6-2.5,1.8c-0.2,0.6-0.3,1.2-0.3,2.1c0,0.9,0.1,1.5,0.3,2.1c0.4,1.2,1.2,1.8,2.5,1.8c1.1,0,1.7-0.4,2.1-1h0v0.7 c0,0.1,0.1,0.2,0.2,0.2H-3226.3z M-3229.2,309.2c-0.8,0-1.4-0.4-1.6-1.1c-0.1-0.4-0.2-0.9-0.2-1.5c0-0.7,0-1.1,0.2-1.5 c0.2-0.7,0.8-1.1,1.6-1.1c0.8,0,1.4,0.4,1.6,1.1c0.1,0.4,0.2,0.8,0.2,1.5c0,0.7,0,1.2-0.2,1.5 C-3227.8,308.8-3228.4,309.2-3229.2,309.2 M-3222.2,301.3c0.1,0,0.2-0.1,0.2-0.2V300c0-0.1-0.1-0.2-0.2-0.2h-1 c-0.1,0-0.2,0.1-0.2,0.2v1.1c0,0.1,0.1,0.2,0.2,0.2H-3222.2z M-3222.2,310.2c0.1,0,0.2-0.1,0.2-0.2v-7c0-0.1-0.1-0.2-0.2-0.2h-1 c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2H-3222.2z M-3215.9,310.4c1.3,0,2.3-0.5,2.9-1.2c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6 c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9c0-0.1,0-0.1,0.1-0.1h4.6 c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2c-0.2,0.4-0.2,1-0.2,1.8 c0,0.8,0.1,1.4,0.2,1.8C-3218.4,309.7-3217.4,310.4-3215.9,310.4 M-3217.7,305.9C-3217.7,305.9-3217.8,305.9-3217.7,305.9 c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-3217.7z  M-3204.5,310.2c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1 c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3 c0,0.1,0.1,0.2,0.2,0.2H-3204.5z M-3201.5,310.1c0,0.1,0.1,0.2,0.2,0.2h1.2c0.1,0,0.2-0.1,0.2-0.2v-1.3c0-0.1-0.1-0.2-0.2-0.2 h-1.2c-0.1,0-0.2,0.1-0.2,0.2V310.1z M-3194.7,310.1c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-7.2h0l2.6,5.7 c0.1,0.1,0.1,0.2,0.3,0.2h0.6c0.1,0,0.2,0,0.3-0.2l2.6-5.7h0v7.2c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2V300 c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0-0.2,0.2l-3,7h0l-3.1-7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2V310.1z  M-3179.9,310.4c1.3,0,2.3-0.5,2.9-1.2c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8 c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9c0-0.1,0-0.1,0.1-0.1h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1 c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2c-0.2,0.4-0.2,1-0.2,1.8c0,0.8,0.1,1.4,0.2,1.8 C-3182.4,309.7-3181.4,310.4-3179.9,310.4 M-3181.7,305.9C-3181.7,305.9-3181.7,305.9-3181.7,305.9c-0.1-0.4-0.1-0.7,0-0.9 c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-3181.7z M-3168.2,310.2 c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v7 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2 H-3168.2z M-3162.5,310.4c1.9,0,2.9-1,2.9-2.4c0-1.2-0.7-1.9-2.2-2.1l-0.8-0.1c-1.1-0.1-1.4-0.4-1.4-1c0-0.6,0.5-1,1.4-1 c0.7,0,1.5,0.3,2,0.6c0.1,0,0.2,0,0.2,0l0.5-0.7c0-0.1,0-0.2,0-0.2c-0.6-0.5-1.5-0.8-2.6-0.8c-1.7,0-2.7,0.8-2.7,2.2 c0,1.2,0.7,1.9,2.2,2.1l0.8,0.1c1.1,0.1,1.4,0.4,1.4,1c0,0.7-0.5,1.1-1.6,1.1c-0.9,0-1.7-0.4-2.3-0.8c-0.1-0.1-0.2-0.1-0.2,0 l-0.6,0.7c-0.1,0.1-0.1,0.2,0,0.2C-3164.9,309.8-3163.9,310.4-3162.5,310.4 M-3157.1,306.6c0,0.8,0.1,1.4,0.2,1.9 c0.4,1.3,1.5,2,2.9,2c1.1,0,2-0.5,2.5-1.2c0-0.1,0-0.1,0-0.2l-0.7-0.5c-0.1-0.1-0.2-0.1-0.2,0c-0.4,0.5-0.8,0.8-1.6,0.8 c-0.8,0-1.4-0.4-1.6-1.1c-0.1-0.4-0.2-0.8-0.2-1.5c0-0.6,0-1.1,0.2-1.5c0.2-0.8,0.8-1.1,1.6-1.1c0.7,0,1.1,0.3,1.6,0.8 c0.1,0.1,0.1,0.1,0.2,0l0.7-0.5c0.1-0.1,0.1-0.1,0-0.2c-0.5-0.8-1.4-1.2-2.5-1.2c-1.4,0-2.5,0.7-2.9,2 C-3157,305.2-3157.1,305.8-3157.1,306.6 M-3142.8,310.2c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7c-1,0-1.7,0.4-2,1h0 V300c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v10.1c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-4.3 c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2H-3142.8z M-3136.9,310.4c1.3,0,2.3-0.5,2.9-1.2 c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9 c0-0.1,0-0.1,0.1-0.1h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2 c-0.2,0.4-0.2,1-0.2,1.8c0,0.8,0.1,1.4,0.2,1.8C-3139.4,309.7-3138.4,310.4-3136.9,310.4 M-3138.6,305.9 C-3138.7,305.9-3138.7,305.9-3138.6,305.9c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1 c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-3138.6z M-3125.5,310.2c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7 c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2 v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2H-3125.5z M-3122.5,310.1c0,0.1,0.1,0.2,0.2,0.2 h1.2c0.1,0,0.2-0.1,0.2-0.2v-1.3c0-0.1-0.1-0.2-0.2-0.2h-1.2c-0.1,0-0.2,0.1-0.2,0.2V310.1z M-3115.7,310.1 c0,0.1,0.1,0.2,0.2,0.2h1.1c0.1,0,0.2-0.1,0.2-0.2v-4.4c0-0.1,0-0.1,0.1-0.1h4.5c0.1,0,0.1,0,0.1,0.1v4.4c0,0.1,0.1,0.2,0.2,0.2 h1.1c0.1,0,0.2-0.1,0.2-0.2V300c0-0.1-0.1-0.2-0.2-0.2h-1.1c-0.1,0-0.2,0.1-0.2,0.2v4.3c0,0.1,0,0.1-0.1,0.1h-4.5 c-0.1,0-0.1,0-0.1-0.1V300c0-0.1-0.1-0.2-0.2-0.2h-1.1c-0.1,0-0.2,0.1-0.2,0.2V310.1z M-3102.4,310.4c1.3,0,2.3-0.5,2.9-1.2 c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9 c0-0.1,0-0.1,0.1-0.1h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2 c-0.2,0.4-0.2,1-0.2,1.8c0,0.8,0.1,1.4,0.2,1.8C-3104.9,309.7-3103.9,310.4-3102.4,310.4 M-3104.2,305.9 C-3104.2,305.9-3104.3,305.9-3104.2,305.9c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1 c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-3104.2z M-3095.6,301.3c0.1,0,0.2-0.1,0.2-0.2V300c0-0.1-0.1-0.2-0.2-0.2h-1 c-0.1,0-0.2,0.1-0.2,0.2v1.1c0,0.1,0.1,0.2,0.2,0.2H-3095.6z M-3095.6,310.2c0.1,0,0.2-0.1,0.2-0.2v-7c0-0.1-0.1-0.2-0.2-0.2h-1 c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2H-3095.6z M-3082.3,310.2c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.6-2.7 c-1.1,0-1.9,0.4-2.4,1.1h0c-0.4-0.7-1.1-1.1-2.1-1.1c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v7 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2h1 c0.1,0,0.2-0.1,0.2-0.2v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2H-3082.3z M-3073.8,310.2 c0.1,0,0.2-0.1,0.2-0.2v-4.8c0-1.8-0.8-2.5-2.9-2.5c-1.1,0-1.9,0.3-2.5,0.7c-0.1,0.1-0.1,0.1,0,0.2l0.4,0.7c0,0.1,0.1,0.1,0.2,0 c0.4-0.3,0.9-0.5,1.8-0.5c1.4,0,1.8,0.4,1.8,1.4v0.5c0,0.1,0,0.1-0.1,0.1h-1.7c-1.8,0-2.9,0.7-2.9,2.3c0,1.5,1.1,2.2,2.5,2.2 c1.1,0,1.8-0.4,2.2-1h0v0.6c0,0.1,0.1,0.2,0.2,0.2H-3073.8z M-3076.8,309.3c-1,0-1.5-0.4-1.5-1.1c0-0.8,0.5-1.2,1.8-1.2h1.5 c0.1,0,0.1,0,0.1,0.1v0.8C-3074.9,308.8-3075.6,309.3-3076.8,309.3 M-3068,310.3c0.1,0,0.2-0.1,0.2-0.2v-0.9 c0-0.1-0.1-0.2-0.2-0.2h-0.3c-0.7,0-0.9-0.2-0.9-0.9v-4.1c0-0.1,0-0.1,0.1-0.1h1.2c0.1,0,0.2-0.1,0.2-0.2v-0.7 c0-0.1-0.1-0.2-0.2-0.2h-1.2c-0.1,0-0.1,0-0.1-0.1v-2.1c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v2.1 c0,0.1,0,0.1-0.1,0.1h-0.6c-0.1,0-0.2,0.1-0.2,0.2v0.7c0,0.1,0.1,0.2,0.2,0.2h0.6c0.1,0,0.1,0,0.1,0.1v4.2c0,1.4,0.5,2.1,2,2.1 H-3068z M-3065,310.1c0,0.1,0.1,0.2,0.2,0.2h1.2c0.1,0,0.2-0.1,0.2-0.2v-1.3c0-0.1-0.1-0.2-0.2-0.2h-1.2c-0.1,0-0.2,0.1-0.2,0.2 V310.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3311.9,
    y: 274.6,
    style: {
      clipPath: "url(#SVGID_00000115478958645754101060000005593174696276574142_)",
      fill: "#FFFFFF"
    },
    width: 48.1,
    height: 40.1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000115478958645754101060000005593174696276574142_)",
      fill: "#005CA9"
    },
    d: "M-3297.2,309.9 c-5.1,0-9.3-4.6-9.3-10.2c0-1.4,0.2-3.1,0.6-4.3c1.4-3.6,4.8-5.9,8.7-5.9c3.8,0,7.2,2.3,8.7,5.9c0.5,1.3,0.7,2.9,0.7,4.3 C-3287.8,305.3-3292,309.9-3297.2,309.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000115478958645754101060000005593174696276574142_)",
      fill: "#005CA9"
    },
    points: " -3288.4,290.7 -3289.5,285.1 -3294.4,284 -3289.5,282.9 -3288.4,277.8 -3287.6,282.9 -3282.4,284 -3287.4,285.1  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000115478958645754101060000005593174696276574142_)",
      fill: "#005CA9"
    },
    d: "M-3270,309.4h-16.8 v-0.7l10.4-17.2l0-0.4h-4.2c-1.6,0-2.3,0.5-3,1.1c-0.7,0.5-1,1.2-1.3,1.9c-0.2,0.6-0.3,1.3-0.3,1.3h-0.7l0.4-5.4h15.6l-10.9,18 v0.2c0,0,2.5,0.1,3.6,0.1c1-0.1,3.9-0.2,5.3-1.8c1.1-1.3,1.5-2.5,1.8-3.7c0-0.1,0.1-0.3,0.1-0.3l0.7,0L-3270,309.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000115478958645754101060000005593174696276574142_)",
      fill: "#FFFFFF"
    },
    d: "M-3297.1,291 c-1.2,0-2.5,0.9-3.3,2.6c-0.7,1.6-0.9,3.8-1,6.1c-0.1,5.9,1.8,8.7,4.2,8.7c2.4,0,4.1-2.8,4.2-8.7c0-2.3-0.1-4.6-0.8-6.1 C-3294.6,291.9-3295.9,291-3297.1,291"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000134933230786314185560000010661469094591872422_",
    x: -1418.1,
    y: -612.3,
    width: 299.5,
    height: 88.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000064332994082981102940000012406726588104265903_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134933230786314185560000010661469094591872422_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000064332994082981102940000012406726588104265903_)"
    }
  }, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000122707656541798968400000010833204032432631181_",
    x: -1418.1,
    y: -612.3,
    width: 299.5,
    height: 88.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119099428711857361490000012242518667703425176_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000122707656541798968400000010833204032432631181_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119099428711857361490000012242518667703425176_)",
      fill: "#FFFFFF"
    },
    d: "M-1327.9-584.3 c-4.5,0-7.1,2.8-7.1,7.6c0,4.9,2.6,7.6,7.1,7.6c4.5,0,7.1-2.8,7.1-7.6C-1320.8-581.5-1323.4-584.3-1327.9-584.3 M-1323.4-576.7 c0,3-0.8,6.6-4.5,6.6c-3.6,0-4.4-3.6-4.5-6.6c0-3,0.8-6.6,4.5-6.6C-1324.2-583.3-1323.4-579.7-1323.4-576.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119099428711857361490000012242518667703425176_)",
      fill: "#FFFFFF"
    },
    d: "M-1312.9-578 l-0.7-0.2c-0.9-0.3-2.5-1.1-2.5-2.5c0-1.5,1-2.5,2.5-2.5c1.7,0,2.7,1,3,3l0,0.1h0.9v-3.1l-0.1,0c-0.7-0.6-2.1-0.9-3.6-0.9 c-2.3,0-4.9,1.1-4.9,4.1c0,2.5,2.3,3.6,4,4.2l0.4,0.1c1,0.4,2.8,1.3,2.8,3c0,1.7-1.1,2.7-2.9,2.7c-1.8,0-3.1-1.3-3.6-3.7l0-0.1 h-0.9l0.2,3.5l0,0c1,0.9,2.9,1.3,4.2,1.3c3.9,0,5.3-2.3,5.3-4.4C-1308.7-576.1-1310.7-577.2-1312.9-578"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119099428711857361490000012242518667703425176_)",
      fill: "#FFFFFF"
    },
    d: "M-1306.7-580.3h0.9 l0-0.1c0.2-2.2,0.7-2.6,3-2.6h1.1v11.6c0,1.1,0,1.1-2.2,1.2l-0.1,0v0.9h6.9v-0.9l-0.1,0c-2.2-0.1-2.2-0.1-2.2-1.2V-583h1.1 c2.3,0,2.7,0.4,3,2.6l0,0.1h0.9v-3.7h-12.3V-580.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119099428711857361490000012242518667703425176_)",
      fill: "#FFFFFF"
    },
    d: "M-1286.5-578 l-0.7-0.2c-0.9-0.3-2.5-1.1-2.5-2.5c0-1.5,1-2.5,2.5-2.5c1.7,0,2.7,1,3,3l0,0.1h0.9v-3.1l-0.1,0c-0.7-0.6-2.1-0.9-3.6-0.9 c-2.3,0-4.9,1.1-4.9,4.1c0,2.5,2.3,3.6,4,4.2l0.4,0.1c1,0.4,2.8,1.3,2.8,3c0,1.7-1.1,2.7-2.9,2.7c-1.8,0-3.1-1.3-3.6-3.7l0-0.1 h-0.9l0.2,3.5l0,0c1,0.9,2.9,1.3,4.2,1.3c3.9,0,5.3-2.3,5.3-4.4C-1282.3-576.1-1284.3-577.2-1286.5-578"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119099428711857361490000012242518667703425176_)",
      fill: "#FFFFFF"
    },
    d: "M-1269.4-573.1 c-0.5,2.4-1.2,2.8-3.9,2.8c-0.8,0-1.7,0-2.1-0.2c-0.4-0.2-0.4-0.4-0.4-1.4v-4.5h2.8c1.7,0,1.7,0.4,1.9,1.7l0,0.1h0.9v-4.7h-0.9 l0,0.1c-0.2,1.3-0.2,1.7-1.9,1.7h-2.8v-4.9c0-0.6,0-0.6,0.6-0.6h2c2.3,0,2.7,0.5,3,2.6l0,0.1h0.9v-3.7h-10.8v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h11.3l0.3-3.9h-0.9L-1269.4-573.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119099428711857361490000012242518667703425176_)",
      fill: "#FFFFFF"
    },
    d: "M-1255.7-573.2l0,0.1 c-0.5,2.4-1.2,2.8-3.9,2.8c-0.8,0-1.7,0-2.1-0.2c-0.4-0.2-0.4-0.4-0.4-1.4v-4.5h2.8c1.7,0,1.7,0.4,1.9,1.7l0,0.1h0.9v-4.7h-0.9 l0,0.1c-0.2,1.3-0.2,1.7-1.9,1.7h-2.8v-4.9c0-0.6,0-0.6,0.6-0.6h2c2.3,0,2.7,0.5,3,2.6l0,0.1h0.9v-3.7h-10.8v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h11.3l0.3-3.9H-1255.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119099428711857361490000012242518667703425176_)",
      fill: "#FFFFFF"
    },
    d: "M-1233.1-573.2 c-0.4,2.5-1.3,2.9-4.4,2.9h-3.9c2.9-4.3,5.9-8.5,9.1-13.2l0-0.1l-0.2-0.4h-10.8v3.9h0.9l0-0.1c0.2-2.3,0.7-2.7,3.5-2.7h3.5 c-3.3,4.8-6.6,9.5-9.1,13.2l0,0.1l0.2,0.4h12.1l0.2-4h-0.9L-1233.1-573.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119099428711857361490000012242518667703425176_)",
      fill: "#FFFFFF"
    },
    d: "M-1219.6-573.1 c-0.5,2.4-1.2,2.8-3.9,2.8c-0.8,0-1.7,0-2.1-0.2c-0.4-0.2-0.4-0.4-0.4-1.4v-4.5h2.8c1.7,0,1.7,0.4,1.9,1.7l0,0.1h0.9v-4.7h-0.9 l0,0.1c-0.2,1.3-0.2,1.7-1.9,1.7h-2.8v-4.9c0-0.6,0-0.6,0.6-0.6h2c2.3,0,2.7,0.5,3,2.6l0,0.1h0.9v-3.7h-10.8v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h11.3l0.3-3.9h-0.9L-1219.6-573.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119099428711857361490000012242518667703425176_)",
      fill: "#FFFFFF"
    },
    d: "M-1216.2-583.1l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h6.1v-0.9l-0.1,0c-1.7-0.1-1.7-0.1-1.7-1.2v-10.5 c0-1.1,0-1.1,1.7-1.2l0.1,0v-0.9h-6.1V-583.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119099428711857361490000012242518667703425176_)",
      fill: "#FFFFFF"
    },
    d: "M-1207.8-580.3h0.9 l0-0.1c0.2-2.2,0.7-2.6,3-2.6h1.1v11.6c0,1.1,0,1.1-2.2,1.2l-0.1,0v0.9h6.9v-0.9l-0.1,0c-2.2-0.1-2.2-0.1-2.2-1.2V-583h1.1 c2.3,0,2.7,0.4,3,2.6l0,0.1h0.9v-3.7h-12.3V-580.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119099428711857361490000012242518667703425176_)",
      fill: "#FFFFFF"
    },
    d: "M-1184.3-583.1l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v6.7c0,3.5-1.1,5.2-3.6,5.2c-3.2,0-3.5-2.9-3.5-5.2v-6.7c0-1.1,0-1.1,1.7-1.2l0.1,0v-0.9h-6.1v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v7.2c0.1,3.9,1.9,5.7,5.9,5.7c4,0,5.9-1.8,5.9-5.8v-7.1c0-1.1,0-1.1,1.7-1.2l0.1,0v-0.9h-6.1V-583.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119099428711857361490000012242518667703425176_)",
      fill: "#FFFFFF"
    },
    d: "M-1166.1-583.1l0.1,0 c1.4,0.1,1.7,0.2,1.8,0.9c0.1,0.7,0.1,1.4,0.1,2.6v6.9c-2.7-3.7-5.3-7.5-7.9-11.2l0-0.1h-4.2v0.9l0.1,0c1.7,0.1,1.7,0.1,1.7,1.2 v8.2c0,1.1,0,1.9-0.1,2.6c-0.1,0.7-0.5,0.8-1.6,0.9l-0.1,0v0.9h5.2v-0.9l-0.1,0c-1.4-0.1-1.7-0.2-1.8-0.9 c-0.1-0.7-0.1-1.4-0.1-2.6v-7.9c3.2,4.5,5.9,8.3,8.6,12.2l0,0.1h1.6v-10.3c0-1.1,0-1.9,0.1-2.6c0.1-0.7,0.5-0.8,1.6-0.9l0.1,0 v-0.9h-5.2V-583.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119099428711857361490000012242518667703425176_)",
      fill: "#FFFFFF"
    },
    d: "M-1150.7-576.2v0.9 l0.1,0c2.1,0.1,2.1,0.2,2.1,1.2v2.8c0,0.6-0.2,0.8-0.6,1c-0.5,0.2-1.1,0.3-1.8,0.3c-5,0-5.5-4.7-5.5-6.7c0-2,0.5-6.6,5.3-6.6 c2.3,0,3.5,1,3.9,3.3l0,0.1h0.9v-3.5l-0.1,0c-1.1-0.5-2.9-0.9-4.5-0.9c-5.2,0-8.1,2.8-8.1,7.9c0,2.6,1,4.8,2.6,6l0,0 c1.7,1.2,3.7,1.4,5.3,1.4c1.5,0,3.5-0.5,4.8-0.9l0.1,0v-4.2c0-0.9,0-1,1.4-1.2l0.1,0v-0.9H-1150.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1252,
    y: -576.9,
    style: {
      clipPath: "url(#SVGID_00000119099428711857361490000012242518667703425176_)",
      fill: "#FFFFFF"
    },
    width: 5.4,
    height: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119099428711857361490000012242518667703425176_)",
      fill: "#FFFFFF"
    },
    d: "M-1333.9-553.9 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-7.2h0l2.6,5.7c0.1,0.1,0.1,0.2,0.3,0.2h0.6c0.1,0,0.2,0,0.3-0.2l2.6-5.7h0v7.2 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2V-564c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0-0.2,0.2l-3,7h0l-3.1-7 c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2V-553.9z M-1319.1-553.6c1.3,0,2.3-0.5,2.9-1.2c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6 c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9c0-0.1,0-0.1,0.1-0.1h4.6 c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2c-0.2,0.4-0.2,1-0.2,1.8 s0.1,1.4,0.2,1.8C-1321.6-554.3-1320.6-553.6-1319.1-553.6 M-1320.9-558C-1320.9-558-1321-558.1-1320.9-558 c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-1320.9z  M-1307.3-553.8c0.1,0,0.2-0.1,0.2-0.2V-564c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v3.8h0c-0.3-0.6-1-1-2.1-1 c-1.3,0-2.1,0.6-2.5,1.8c-0.2,0.6-0.3,1.2-0.3,2.1c0,0.9,0.1,1.5,0.3,2.1c0.4,1.2,1.2,1.8,2.5,1.8c1.1,0,1.7-0.4,2.1-1h0v0.7 c0,0.1,0.1,0.2,0.2,0.2H-1307.3z M-1310.2-554.8c-0.8,0-1.4-0.4-1.6-1.1c-0.1-0.4-0.2-0.9-0.2-1.5c0-0.7,0-1.1,0.2-1.5 c0.2-0.7,0.8-1.1,1.6-1.1s1.4,0.4,1.6,1.1c0.1,0.4,0.2,0.8,0.2,1.5s0,1.2-0.2,1.5C-1308.8-555.2-1309.4-554.8-1310.2-554.8  M-1303.2-562.7c0.1,0,0.2-0.1,0.2-0.2v-1.1c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v1.1c0,0.1,0.1,0.2,0.2,0.2H-1303.2 z M-1303.2-553.8c0.1,0,0.2-0.1,0.2-0.2v-7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2H-1303.2z  M-1296.9-553.6c1.3,0,2.3-0.5,2.9-1.2c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8 c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9c0-0.1,0-0.1,0.1-0.1h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1 c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2c-0.2,0.4-0.2,1-0.2,1.8s0.1,1.4,0.2,1.8C-1299.4-554.3-1298.4-553.6-1296.9-553.6  M-1298.7-558C-1298.7-558-1298.8-558.1-1298.7-558c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1 c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-1298.7z M-1285.5-553.8c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7 c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2 v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2H-1285.5z M-1282.5-553.9c0,0.1,0.1,0.2,0.2,0.2 h1.2c0.1,0,0.2-0.1,0.2-0.2v-1.3c0-0.1-0.1-0.2-0.2-0.2h-1.2c-0.1,0-0.2,0.1-0.2,0.2V-553.9z M-1275.7-553.9 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-7.2h0l2.6,5.7c0.1,0.1,0.1,0.2,0.3,0.2h0.6c0.1,0,0.2,0,0.3-0.2l2.6-5.7h0v7.2 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2V-564c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0-0.2,0.2l-3,7h0l-3.1-7 c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2V-553.9z M-1260.9-553.6c1.3,0,2.3-0.5,2.9-1.2c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6 c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9c0-0.1,0-0.1,0.1-0.1h4.6 c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2c-0.2,0.4-0.2,1-0.2,1.8 s0.1,1.4,0.2,1.8C-1263.4-554.3-1262.4-553.6-1260.9-553.6 M-1262.7-558C-1262.7-558-1262.7-558.1-1262.7-558 c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-1262.7z  M-1249.2-553.8c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1 c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3 c0,0.1,0.1,0.2,0.2,0.2H-1249.2z M-1243.5-553.6c1.9,0,2.9-1,2.9-2.4c0-1.2-0.7-1.9-2.2-2.1l-0.8-0.1c-1.1-0.1-1.4-0.4-1.4-1 c0-0.6,0.5-1,1.4-1c0.7,0,1.5,0.3,2,0.6c0.1,0,0.2,0,0.2,0l0.5-0.7c0-0.1,0-0.2,0-0.2c-0.6-0.5-1.5-0.8-2.6-0.8 c-1.7,0-2.7,0.8-2.7,2.2c0,1.2,0.7,1.9,2.2,2.1l0.8,0.1c1.1,0.1,1.4,0.4,1.4,1c0,0.7-0.5,1.1-1.6,1.1c-0.9,0-1.7-0.4-2.3-0.8 c-0.1-0.1-0.2-0.1-0.2,0l-0.6,0.7c-0.1,0.1-0.1,0.2,0,0.2C-1245.9-554.2-1244.9-553.6-1243.5-553.6 M-1238.1-557.4 c0,0.8,0.1,1.4,0.2,1.9c0.4,1.3,1.5,2,2.9,2c1.1,0,2-0.5,2.5-1.2c0-0.1,0-0.1,0-0.2l-0.7-0.5c-0.1-0.1-0.2-0.1-0.2,0 c-0.4,0.5-0.8,0.8-1.6,0.8c-0.8,0-1.4-0.4-1.6-1.1c-0.1-0.4-0.2-0.8-0.2-1.5c0-0.6,0-1.1,0.2-1.5c0.2-0.8,0.8-1.1,1.6-1.1 c0.7,0,1.1,0.3,1.6,0.8c0.1,0.1,0.1,0.1,0.2,0l0.7-0.5c0.1-0.1,0.1-0.1,0-0.2c-0.5-0.8-1.4-1.2-2.5-1.2c-1.4,0-2.5,0.7-2.9,2 C-1238-558.8-1238.1-558.2-1238.1-557.4 M-1223.8-553.8c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7c-1,0-1.7,0.4-2,1h0 v-3.7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v10.1c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-4.3 c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2H-1223.8z M-1217.9-553.6c1.3,0,2.3-0.5,2.9-1.2 c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9 c0-0.1,0-0.1,0.1-0.1h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2 c-0.2,0.4-0.2,1-0.2,1.8s0.1,1.4,0.2,1.8C-1220.4-554.3-1219.4-553.6-1217.9-553.6 M-1219.6-558 C-1219.7-558-1219.7-558.1-1219.6-558c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1 c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-1219.6z M-1206.5-553.8c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7 c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2 v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2H-1206.5z M-1203.5-553.9c0,0.1,0.1,0.2,0.2,0.2 h1.2c0.1,0,0.2-0.1,0.2-0.2v-1.3c0-0.1-0.1-0.2-0.2-0.2h-1.2c-0.1,0-0.2,0.1-0.2,0.2V-553.9z M-1196.7-553.9 c0,0.1,0.1,0.2,0.2,0.2h1.1c0.1,0,0.2-0.1,0.2-0.2v-4.4c0-0.1,0-0.1,0.1-0.1h4.5c0.1,0,0.1,0,0.1,0.1v4.4c0,0.1,0.1,0.2,0.2,0.2 h1.1c0.1,0,0.2-0.1,0.2-0.2V-564c0-0.1-0.1-0.2-0.2-0.2h-1.1c-0.1,0-0.2,0.1-0.2,0.2v4.3c0,0.1,0,0.1-0.1,0.1h-4.5 c-0.1,0-0.1,0-0.1-0.1v-4.3c0-0.1-0.1-0.2-0.2-0.2h-1.1c-0.1,0-0.2,0.1-0.2,0.2V-553.9z M-1183.4-553.6c1.3,0,2.3-0.5,2.9-1.2 c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9 c0-0.1,0-0.1,0.1-0.1h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2 c-0.2,0.4-0.2,1-0.2,1.8s0.1,1.4,0.2,1.8C-1185.9-554.3-1184.9-553.6-1183.4-553.6 M-1185.2-558 C-1185.2-558-1185.3-558.1-1185.2-558c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1 c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-1185.2z M-1176.6-562.7c0.1,0,0.2-0.1,0.2-0.2v-1.1c0-0.1-0.1-0.2-0.2-0.2h-1 c-0.1,0-0.2,0.1-0.2,0.2v1.1c0,0.1,0.1,0.2,0.2,0.2H-1176.6z M-1176.6-553.8c0.1,0,0.2-0.1,0.2-0.2v-7c0-0.1-0.1-0.2-0.2-0.2h-1 c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2H-1176.6z M-1163.3-553.8c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.6-2.7 c-1.1,0-1.9,0.4-2.4,1.1h0c-0.4-0.7-1.1-1.1-2.1-1.1c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v7 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2h1 c0.1,0,0.2-0.1,0.2-0.2v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2H-1163.3z M-1154.8-553.8 c0.1,0,0.2-0.1,0.2-0.2v-4.8c0-1.8-0.8-2.5-2.9-2.5c-1.1,0-1.9,0.3-2.5,0.7c-0.1,0.1-0.1,0.1,0,0.2l0.4,0.7c0,0.1,0.1,0.1,0.2,0 c0.4-0.3,0.9-0.5,1.8-0.5c1.4,0,1.8,0.4,1.8,1.4v0.5c0,0.1,0,0.1-0.1,0.1h-1.7c-1.8,0-2.9,0.7-2.9,2.3c0,1.5,1.1,2.2,2.5,2.2 c1.1,0,1.8-0.4,2.2-1h0v0.6c0,0.1,0.1,0.2,0.2,0.2H-1154.8z M-1157.8-554.7c-1,0-1.5-0.4-1.5-1.1c0-0.8,0.5-1.2,1.8-1.2h1.5 c0.1,0,0.1,0,0.1,0.1v0.8C-1155.9-555.2-1156.6-554.7-1157.8-554.7 M-1149-553.7c0.1,0,0.2-0.1,0.2-0.2v-0.9 c0-0.1-0.1-0.2-0.2-0.2h-0.3c-0.7,0-0.9-0.2-0.9-0.9v-4.1c0-0.1,0-0.1,0.1-0.1h1.2c0.1,0,0.2-0.1,0.2-0.2v-0.7 c0-0.1-0.1-0.2-0.2-0.2h-1.2c-0.1,0-0.1,0-0.1-0.1v-2.1c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v2.1 c0,0.1,0,0.1-0.1,0.1h-0.6c-0.1,0-0.2,0.1-0.2,0.2v0.7c0,0.1,0.1,0.2,0.2,0.2h0.6c0.1,0,0.1,0,0.1,0.1v4.2c0,1.4,0.5,2.1,2,2.1 H-1149z M-1146-553.9c0,0.1,0.1,0.2,0.2,0.2h1.2c0.1,0,0.2-0.1,0.2-0.2v-1.3c0-0.1-0.1-0.2-0.2-0.2h-1.2c-0.1,0-0.2,0.1-0.2,0.2 V-553.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1392.9,
    y: -589.4,
    style: {
      clipPath: "url(#SVGID_00000119099428711857361490000012242518667703425176_)",
      fill: "#FFFFFF"
    },
    width: 48.1,
    height: 40.1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119099428711857361490000012242518667703425176_)",
      fill: "#005CA9"
    },
    d: "M-1378.2-554.1 c-5.1,0-9.3-4.6-9.3-10.2c0-1.4,0.2-3.1,0.6-4.3c1.4-3.6,4.8-5.9,8.7-5.9c3.8,0,7.2,2.3,8.7,5.9c0.5,1.3,0.7,2.9,0.7,4.3 C-1368.8-558.7-1373-554.1-1378.2-554.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000119099428711857361490000012242518667703425176_)",
      fill: "#005CA9"
    },
    points: " -1369.4,-573.2 -1370.5,-578.9 -1375.4,-580 -1370.5,-581 -1369.4,-586.1 -1368.6,-581 -1363.4,-580 -1368.4,-578.9  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119099428711857361490000012242518667703425176_)",
      fill: "#005CA9"
    },
    d: "M-1351-554.6h-16.8 v-0.7l10.4-17.2l0-0.4h-4.2c-1.6,0-2.3,0.5-3,1.1c-0.7,0.5-1,1.2-1.3,1.9c-0.2,0.6-0.3,1.3-0.3,1.3h-0.7l0.4-5.4h15.6l-10.9,18 v0.2c0,0,2.5,0.1,3.6,0.1c1-0.1,3.9-0.2,5.3-1.8c1.1-1.3,1.5-2.5,1.8-3.7c0-0.1,0.1-0.3,0.1-0.3l0.7,0L-1351-554.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119099428711857361490000012242518667703425176_)",
      fill: "#FFFFFF"
    },
    d: "M-1378.1-573 c-1.2,0-2.5,0.9-3.3,2.6c-0.7,1.6-0.9,3.8-1,6.1c-0.1,5.9,1.8,8.7,4.2,8.7c2.4,0,4.1-2.8,4.2-8.7c0-2.3-0.1-4.6-0.8-6.1 C-1375.6-572.1-1376.9-573-1378.1-573"
  })))), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 2048,
    height: 1331,
    xlinkHref: "9696B931.jpg",
    transform: "matrix(0.6215 0 0 0.631 -4555.0972 -1521.5685)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 2048,
    height: 1331,
    xlinkHref: "9696B932.jpg",
    transform: "matrix(0.6215 0 0 0.631 -4555.0972 -650.377)"
  }), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: -4552.7,
    y: -1503.6,
    className: "st35",
    width: 634,
    height: 804
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: -3918.7,
    y: -1503.6,
    className: "st36",
    width: 634,
    height: 804
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: -4554.7,
    y: -630.6,
    className: "st43",
    width: 635.9,
    height: 800.7
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: -3918.9,
    y: -630.7,
    className: "st44",
    width: 636.1,
    height: 800.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -3732.6636 -1133.4379)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "24.0745px"
    }
  }, "Thursday, 23 September"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -3737.8237 -1184.2434)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Bold'",
      fontSize: "100.3104px"
    }
  }, "10:18"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M-3653.1-1029.9h-69.6c-2.9,0-5.3-2.4-5.3-5.3v-29.8c0-2.9,2.4-5.3,5.3-5.3h69.6c2.9,0,5.3,2.4,5.3,5.3v29.8 C-3647.8-1032.3-3650.2-1029.9-3653.1-1029.9z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -3712.4656 -1045.1005)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "15 Min")), /*#__PURE__*/React.createElement("g", null, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-3565.3-1029.9h-69.6c-2.9,0-5.3-2.4-5.3-5.3v-29.8c0-2.9,2.4-5.3,5.3-5.3h69.6c2.9,0,5.3,2.4,5.3,5.3v29.8 C-3560.1-1032.3-3562.4-1029.9-3565.3-1029.9z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -3624.7317 -1045.0999)",
    style: {
      opacity: 0.7,
      fill: "#4D4D4D",
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "30 Min")), /*#__PURE__*/React.createElement("g", null, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-3477.6-1029.9h-69.6c-2.9,0-5.3-2.4-5.3-5.3v-29.8c0-2.9,2.4-5.3,5.3-5.3h69.6c2.9,0,5.3,2.4,5.3,5.3v29.8 C-3472.3-1032.3-3474.7-1029.9-3477.6-1029.9z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -3536.998 -1045.101)",
    style: {
      opacity: 0.7,
      fill: "#4D4D4D",
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "60 Min"))), /*#__PURE__*/React.createElement("g", null, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M-3547.2-951.1h-105.9c-3.5,0-6.4-2.9-6.4-6.4V-985c0-3.5,2.9-6.4,6.4-6.4h105.9c3.5,0,6.4,2.9,6.4,6.4v27.5 C-3540.8-954-3543.7-951.1-3547.2-951.1z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -3624.7317 -966.3062)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "30 Min"))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M-3572-752.4h-56.3c-5.7,0-10.3-4.6-10.3-10.3v-56.3c0-5.7,4.6-10.3,10.3-10.3h56.3c5.7,0,10.3,4.6,10.3,10.3 v56.3C-3561.6-757-3566.3-752.4-3572-752.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-3607.2-800.4h-3c-0.7,0-1.3-0.6-1.3-1.3v-11.5c0-0.7,0.6-1.3,1.3-1.3h3c0.7,0,1.3,0.6,1.3,1.3v11.5 C-3605.9-801-3606.5-800.4-3607.2-800.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-3589.4-800.4h-3c-0.7,0-1.3-0.6-1.3-1.3v-11.5c0-0.7,0.6-1.3,1.3-1.3h3c0.7,0,1.3,0.6,1.3,1.3v11.5 C-3588.2-801-3588.7-800.4-3589.4-800.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-3619-799v-2.9c0-3,2.4-5.4,5.4-5.4h26.9c3,0,5.4,2.4,5.4,5.4v2.9H-3619z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-3619-772.8v-24.3h37.7v24.3c0,3-2.4,5.4-5.4,5.4h-26.9C-3616.6-767.4-3619-769.8-3619-772.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3619,
    y: -799,
    className: "st7",
    width: 37.7,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3619,
    y: -787.9,
    className: "st7",
    width: 37.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3619,
    y: -777.7,
    className: "st7",
    width: 37.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3614.9,
    y: -782.4,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -4382.2866 2818.009)",
    className: "st7",
    width: 29.5,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3605.3,
    y: -782.4,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -4372.7485 2808.4709)",
    className: "st7",
    width: 29.5,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3624.4,
    y: -782.4,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -4391.8252 2827.5474)",
    className: "st7",
    width: 29.5,
    height: 0.5
  })))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -4368.147 -1126.3727)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 40
    }
  }, "Meeting Room"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -4350.6865 -1076.8408)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Bold'",
      fontSize: 20
    }
  }, "Available for 15 minutes"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -4368.147 -358.6028)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 40
    }
  }, "Meeting Room"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -4386.3657 -309.0709)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Bold'",
      fontSize: 20
    }
  }, "Booked For the next 30 minutes"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -4309.8975 -251.3688)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 20
    }
  }, "Current Meeting"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -4328.8589 -225.3263)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st0",
    style: {
      fontFamily: "'Aileron-Light'",
      fontSize: 17
    }
  }, "Quick meeting via 30 min"), /*#__PURE__*/React.createElement("tspan", {
    x: 45.2,
    y: 20.4,
    className: "st0",
    style: {
      fontFamily: "'Aileron-Light'",
      fontSize: 17
    }
  }, "14:41 - 15:11"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.3,
    y: 40.8,
    className: "st0",
    style: {
      fontFamily: "'Aileron-Light'",
      fontSize: 17
    }
  }, "Organizer: tablet user1")), /*#__PURE__*/React.createElement("g", null, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M-4183.5-97.1h-105.9c-3.5,0-6.4-2.9-6.4-6.4V-131c0-3.5,2.9-6.4,6.4-6.4h105.9c3.5,0,6.4,2.9,6.4,6.4v27.5 C-4177.1-100-4180-97.1-4183.5-97.1z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -4269.248 -112.3076)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "End Now"))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -3729.5146 -262.2463)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "24.0745px"
    }
  }, "Thursday, 23 September"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -3734.6748 -313.0519)",
    className: "st9",
    style: {
      fontFamily: "'Aileron-Bold'",
      fontSize: "100.3104px"
    }
  }, "10:18"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M-3649.9-158.7h-69.6c-2.9,0-5.3-2.4-5.3-5.3v-29.8c0-2.9,2.4-5.3,5.3-5.3h69.6c2.9,0,5.3,2.4,5.3,5.3v29.8 C-3644.6-161.1-3647-158.7-3649.9-158.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -3709.3167 -173.909)",
    style: {
      fill: "#4D4D4D",
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "15 Min"))), /*#__PURE__*/React.createElement("g", null, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M-3562.2-158.7h-69.6c-2.9,0-5.3-2.4-5.3-5.3v-29.8c0-2.9,2.4-5.3,5.3-5.3h69.6c2.9,0,5.3,2.4,5.3,5.3v29.8 C-3556.9-161.1-3559.3-158.7-3562.2-158.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -3621.5828 -173.9089)",
    style: {
      fill: "#4D4D4D",
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "30 Min"))), /*#__PURE__*/React.createElement("g", null, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M-3474.5-158.7h-69.6c-2.9,0-5.3-2.4-5.3-5.3v-29.8c0-2.9,2.4-5.3,5.3-5.3h69.6c2.9,0,5.3,2.4,5.3,5.3v29.8 C-3469.2-161.1-3471.5-158.7-3474.5-158.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -3533.8489 -173.9089)",
    style: {
      fill: "#4D4D4D",
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "60 Min")))), /*#__PURE__*/React.createElement("g", null, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M-3544.1-79.9h-105.9c-3.5,0-6.4-2.9-6.4-6.4v-27.5c0-3.5,2.9-6.4,6.4-6.4h105.9c3.5,0,6.4,2.9,6.4,6.4v27.5 C-3537.6-82.8-3540.5-79.9-3544.1-79.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -3621.5828 -95.1147)",
    style: {
      fill: "#4D4D4D",
      fontFamily: "'Aileron-Regular'",
      fontSize: 16
    }
  }, "30 Min"))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-3568.8,118.8h-56.3c-5.7,0-10.3-4.6-10.3-10.3V52.1c0-5.7,4.6-10.3,10.3-10.3h56.3 c5.7,0,10.3,4.6,10.3,10.3v56.3C-3558.5,114.2-3563.1,118.8-3568.8,118.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-3604,70.8h-3c-0.7,0-1.3-0.6-1.3-1.3V58.1c0-0.7,0.6-1.3,1.3-1.3h3c0.7,0,1.3,0.6,1.3,1.3v11.5 C-3602.8,70.2-3603.3,70.8-3604,70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-3586.3,70.8h-3c-0.7,0-1.3-0.6-1.3-1.3V58.1c0-0.7,0.6-1.3,1.3-1.3h3c0.7,0,1.3,0.6,1.3,1.3v11.5 C-3585,70.2-3585.6,70.8-3586.3,70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-3615.8,72.1v-2.9c0-3,2.4-5.4,5.4-5.4h26.9c3,0,5.4,2.4,5.4,5.4v2.9H-3615.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-3615.8,98.4V74.1h37.7v24.3c0,3-2.4,5.4-5.4,5.4h-26.9C-3613.4,103.8-3615.8,101.4-3615.8,98.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3615.8,
    y: 72.2,
    className: "st18",
    width: 37.7,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3615.8,
    y: 83.3,
    className: "st18",
    width: 37.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3615.8,
    y: 93.5,
    className: "st18",
    width: 37.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3611.7,
    y: 88.8,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -3507.9463 3686.0518)",
    className: "st18",
    width: 29.5,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3602.2,
    y: 88.8,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -3498.4082 3676.5134)",
    className: "st18",
    width: 29.5,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3621.3,
    y: 88.8,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 -3517.4846 3695.5901)",
    className: "st18",
    width: 29.5,
    height: 0.5
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000124870056313822615160000000707705352573046426_",
    x: -4534.1,
    y: -1484.9,
    width: 299.5,
    height: 88.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091005271797932985460000012047859643869262744_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124870056313822615160000000707705352573046426_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000091005271797932985460000012047859643869262744_)"
    }
  }, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000056424498667390197730000006688207895347871406_",
    x: -4534.1,
    y: -1484.9,
    width: 299.5,
    height: 88.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132075386121179545910000012999104976948967048_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000056424498667390197730000006688207895347871406_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000132075386121179545910000012999104976948967048_)",
      fill: "#FFFFFF"
    },
    d: "M-4443.8-1457 c-4.5,0-7.1,2.8-7.1,7.6c0,4.9,2.6,7.6,7.1,7.6s7.1-2.8,7.1-7.6C-4436.7-1454.2-4439.3-1457-4443.8-1457 M-4439.3-1449.4 c0,3-0.8,6.6-4.5,6.6s-4.4-3.6-4.5-6.6c0-3,0.8-6.6,4.5-6.6S-4439.4-1452.4-4439.3-1449.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000132075386121179545910000012999104976948967048_)",
      fill: "#FFFFFF"
    },
    d: "M-4428.8-1450.7 l-0.7-0.2c-0.9-0.3-2.5-1.1-2.5-2.5c0-1.5,1-2.5,2.5-2.5c1.7,0,2.7,1,3,3l0,0.1h0.9v-3.1l-0.1,0c-0.7-0.6-2.1-0.9-3.6-0.9 c-2.3,0-4.9,1.1-4.9,4.2c0,2.5,2.3,3.6,4,4.2l0.4,0.1c1,0.4,2.8,1.3,2.8,3c0,1.7-1.1,2.7-2.9,2.7c-1.8,0-3.1-1.3-3.6-3.7l0-0.1 h-0.9l0.2,3.5l0,0c1,0.9,2.9,1.3,4.2,1.3c3.9,0,5.3-2.3,5.3-4.4C-4424.6-1448.8-4426.6-1449.9-4428.8-1450.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000132075386121179545910000012999104976948967048_)",
      fill: "#FFFFFF"
    },
    d: "M-4422.6-1453h0.9 l0-0.1c0.2-2.2,0.7-2.6,3-2.6h1.1v11.6c0,1.1,0,1.1-2.2,1.2l-0.1,0v0.9h6.9v-0.9l-0.1,0c-2.2-0.1-2.2-0.1-2.2-1.2v-11.6h1.1 c2.3,0,2.7,0.4,3,2.6l0,0.1h0.9v-3.7h-12.3V-1453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000132075386121179545910000012999104976948967048_)",
      fill: "#FFFFFF"
    },
    d: "M-4402.4-1450.7 l-0.7-0.2c-0.9-0.3-2.5-1.1-2.5-2.5c0-1.5,1-2.5,2.5-2.5c1.7,0,2.7,1,3,3l0,0.1h0.9v-3.1l-0.1,0c-0.7-0.6-2.1-0.9-3.6-0.9 c-2.3,0-4.9,1.1-4.9,4.2c0,2.5,2.3,3.6,4,4.2l0.4,0.1c1,0.4,2.8,1.3,2.8,3c0,1.7-1.1,2.7-2.9,2.7c-1.8,0-3.1-1.3-3.6-3.7l0-0.1 h-0.9l0.2,3.5l0,0c1,0.9,2.9,1.3,4.2,1.3c3.9,0,5.3-2.3,5.3-4.4C-4398.2-1448.8-4400.3-1449.9-4402.4-1450.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000132075386121179545910000012999104976948967048_)",
      fill: "#FFFFFF"
    },
    d: "M-4385.3-1445.8 c-0.5,2.4-1.2,2.8-3.9,2.8c-0.8,0-1.7,0-2.1-0.2c-0.4-0.2-0.4-0.4-0.4-1.4v-4.5h2.8c1.7,0,1.7,0.4,1.9,1.7l0,0.1h0.9v-4.7h-0.9 l0,0.1c-0.2,1.3-0.2,1.7-1.9,1.7h-2.8v-4.9c0-0.6,0-0.6,0.6-0.6h2c2.3,0,2.7,0.5,3,2.6l0,0.1h0.9v-3.7h-10.8v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h11.3l0.3-3.9h-0.9L-4385.3-1445.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000132075386121179545910000012999104976948967048_)",
      fill: "#FFFFFF"
    },
    d: "M-4371.7-1445.9 l0,0.1c-0.5,2.4-1.2,2.8-3.9,2.8c-0.8,0-1.7,0-2.1-0.2c-0.4-0.2-0.4-0.4-0.4-1.4v-4.5h2.8c1.7,0,1.7,0.4,1.9,1.7l0,0.1h0.9v-4.7 h-0.9l0,0.1c-0.2,1.3-0.2,1.7-1.9,1.7h-2.8v-4.9c0-0.6,0-0.6,0.6-0.6h2c2.3,0,2.7,0.5,3,2.6l0,0.1h0.9v-3.7h-10.8v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h11.3l0.3-3.9H-4371.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000132075386121179545910000012999104976948967048_)",
      fill: "#FFFFFF"
    },
    d: "M-4349-1445.9 c-0.4,2.5-1.3,2.9-4.4,2.9h-3.9c2.9-4.3,5.9-8.5,9.1-13.2l0-0.1l-0.2-0.4h-10.8v3.9h0.9l0-0.1c0.2-2.3,0.7-2.7,3.5-2.7h3.5 c-3.3,4.8-6.6,9.5-9.1,13.2l0,0.1l0.2,0.4h12.1l0.2-4h-0.9L-4349-1445.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000132075386121179545910000012999104976948967048_)",
      fill: "#FFFFFF"
    },
    d: "M-4335.6-1445.8 c-0.5,2.4-1.2,2.8-3.9,2.8c-0.8,0-1.7,0-2.1-0.2c-0.4-0.2-0.4-0.4-0.4-1.4v-4.5h2.8c1.7,0,1.7,0.4,1.9,1.7l0,0.1h0.9v-4.7h-0.9 l0,0.1c-0.2,1.3-0.2,1.7-1.9,1.7h-2.8v-4.9c0-0.6,0-0.6,0.6-0.6h2c2.3,0,2.7,0.5,3,2.6l0,0.1h0.9v-3.7h-10.8v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h11.3l0.3-3.9h-0.9L-4335.6-1445.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000132075386121179545910000012999104976948967048_)",
      fill: "#FFFFFF"
    },
    d: "M-4332.2-1455.8 l0.1,0c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h6.1v-0.9l-0.1,0c-1.7-0.1-1.7-0.1-1.7-1.2v-10.5 c0-1.1,0-1.1,1.7-1.2l0.1,0v-0.9h-6.1V-1455.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000132075386121179545910000012999104976948967048_)",
      fill: "#FFFFFF"
    },
    d: "M-4323.7-1453h0.9 l0-0.1c0.2-2.2,0.7-2.6,3-2.6h1.1v11.6c0,1.1,0,1.1-2.2,1.2l-0.1,0v0.9h6.9v-0.9l-0.1,0c-2.2-0.1-2.2-0.1-2.2-1.2v-11.6h1.1 c2.3,0,2.7,0.4,3,2.6l0,0.1h0.9v-3.7h-12.3V-1453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000132075386121179545910000012999104976948967048_)",
      fill: "#FFFFFF"
    },
    d: "M-4300.2-1455.8 l0.1,0c1.7,0.1,1.7,0.1,1.7,1.2v6.7c0,3.5-1.1,5.2-3.6,5.2c-3.2,0-3.5-2.9-3.5-5.2v-6.7c0-1.1,0-1.1,1.7-1.2l0.1,0v-0.9h-6.1v0.9 l0.1,0c1.7,0.1,1.7,0.1,1.7,1.2v7.2c0.1,3.9,1.9,5.7,5.9,5.7c4,0,5.9-1.8,5.9-5.8v-7.1c0-1.1,0-1.1,1.7-1.2l0.1,0v-0.9h-6.1 V-1455.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000132075386121179545910000012999104976948967048_)",
      fill: "#FFFFFF"
    },
    d: "M-4282-1455.8l0.1,0 c1.4,0.1,1.7,0.2,1.8,0.9c0.1,0.7,0.1,1.4,0.1,2.6v6.9c-2.7-3.7-5.3-7.5-7.9-11.2l0-0.1h-4.2v0.9l0.1,0c1.7,0.1,1.7,0.1,1.7,1.2 v8.2c0,1.1,0,1.9-0.1,2.6c-0.1,0.7-0.5,0.8-1.6,0.9l-0.1,0v0.9h5.2v-0.9l-0.1,0c-1.4-0.1-1.7-0.2-1.8-0.9 c-0.1-0.7-0.1-1.4-0.1-2.6v-7.9c3.2,4.5,5.9,8.3,8.6,12.2l0,0.1h1.6v-10.3c0-1.1,0-1.9,0.1-2.6c0.1-0.7,0.5-0.8,1.6-0.9l0.1,0 v-0.9h-5.2V-1455.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000132075386121179545910000012999104976948967048_)",
      fill: "#FFFFFF"
    },
    d: "M-4266.6-1448.8v0.9 l0.1,0c2.1,0.1,2.1,0.2,2.1,1.2v2.8c0,0.6-0.2,0.8-0.6,1c-0.5,0.2-1.1,0.3-1.8,0.3c-5,0-5.5-4.7-5.5-6.7c0-2,0.5-6.6,5.3-6.6 c2.3,0,3.5,1,3.9,3.3l0,0.1h0.9v-3.5l-0.1,0c-1.1-0.5-2.9-0.9-4.5-0.9c-5.2,0-8.1,2.8-8.1,7.9c0,2.6,1,4.8,2.6,6l0,0 c1.7,1.2,3.7,1.4,5.3,1.4c1.5,0,3.5-0.5,4.8-0.9l0.1,0v-4.2c0-0.9,0-1,1.4-1.2l0.1,0v-0.9H-4266.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4367.9,
    y: -1449.6,
    style: {
      clipPath: "url(#SVGID_00000132075386121179545910000012999104976948967048_)",
      fill: "#FFFFFF"
    },
    width: 5.4,
    height: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000132075386121179545910000012999104976948967048_)",
      fill: "#FFFFFF"
    },
    d: "M-4449.9-1426.6 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-7.2h0l2.6,5.7c0.1,0.1,0.1,0.2,0.3,0.2h0.6c0.1,0,0.2,0,0.3-0.2l2.6-5.7h0v7.2 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-10.1c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0-0.2,0.2l-3,7h0l-3.1-7 c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2V-1426.6z M-4435.1-1426.3c1.3,0,2.3-0.5,2.9-1.2c0.1-0.1,0.1-0.2,0-0.2 l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9c0-0.1,0-0.1,0.1-0.1 h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2c-0.2,0.4-0.2,1-0.2,1.8 c0,0.8,0.1,1.4,0.2,1.8C-4437.6-1427-4436.5-1426.3-4435.1-1426.3 M-4436.8-1430.7C-4436.9-1430.7-4436.9-1430.8-4436.8-1430.7 c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-4436.8z  M-4423.2-1426.4c0.1,0,0.2-0.1,0.2-0.2v-10.1c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v3.8h0c-0.4-0.6-1-1-2.1-1 c-1.3,0-2.1,0.6-2.5,1.8c-0.2,0.6-0.3,1.2-0.3,2.1c0,0.9,0.1,1.5,0.3,2.1c0.4,1.2,1.2,1.8,2.5,1.8c1.1,0,1.7-0.4,2.1-1h0v0.7 c0,0.1,0.1,0.2,0.2,0.2H-4423.2z M-4426.1-1427.5c-0.8,0-1.4-0.4-1.6-1.1c-0.1-0.4-0.2-0.9-0.2-1.5c0-0.7,0-1.1,0.2-1.5 c0.2-0.7,0.8-1.1,1.6-1.1s1.4,0.4,1.6,1.1c0.1,0.4,0.2,0.8,0.2,1.5c0,0.7,0,1.2-0.2,1.5 C-4424.8-1427.8-4425.3-1427.5-4426.1-1427.5 M-4419.1-1435.4c0.1,0,0.2-0.1,0.2-0.2v-1.1c0-0.1-0.1-0.2-0.2-0.2h-1 c-0.1,0-0.2,0.1-0.2,0.2v1.1c0,0.1,0.1,0.2,0.2,0.2H-4419.1z M-4419.1-1426.4c0.1,0,0.2-0.1,0.2-0.2v-7c0-0.1-0.1-0.2-0.2-0.2h-1 c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2H-4419.1z M-4412.8-1426.3c1.3,0,2.3-0.5,2.9-1.2c0.1-0.1,0.1-0.2,0-0.2 l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9c0-0.1,0-0.1,0.1-0.1 h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2c-0.2,0.4-0.2,1-0.2,1.8 c0,0.8,0.1,1.4,0.2,1.8C-4415.4-1427-4414.3-1426.3-4412.8-1426.3 M-4414.6-1430.7C-4414.7-1430.7-4414.7-1430.8-4414.6-1430.7 c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-4414.6z  M-4401.4-1426.4c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1 c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3 c0,0.1,0.1,0.2,0.2,0.2H-4401.4z M-4398.4-1426.6c0,0.1,0.1,0.2,0.2,0.2h1.2c0.1,0,0.2-0.1,0.2-0.2v-1.3c0-0.1-0.1-0.2-0.2-0.2 h-1.2c-0.1,0-0.2,0.1-0.2,0.2V-1426.6z M-4391.6-1426.6c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-7.2h0l2.6,5.7 c0.1,0.1,0.1,0.2,0.3,0.2h0.6c0.1,0,0.2,0,0.3-0.2l2.6-5.7h0v7.2c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-10.1 c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0-0.2,0.2l-3,7h0l-3.1-7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2V-1426.6z  M-4376.8-1426.3c1.3,0,2.3-0.5,2.9-1.2c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8 c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9c0-0.1,0-0.1,0.1-0.1h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1 c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2c-0.2,0.4-0.2,1-0.2,1.8c0,0.8,0.1,1.4,0.2,1.8 C-4379.4-1427-4378.3-1426.3-4376.8-1426.3 M-4378.6-1430.7C-4378.6-1430.7-4378.7-1430.8-4378.6-1430.7c-0.1-0.4-0.1-0.7,0-0.9 c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-4378.6z M-4365.1-1426.4 c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v7 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2 H-4365.1z M-4359.4-1426.3c1.9,0,2.9-1,2.9-2.4c0-1.2-0.7-1.9-2.2-2.1l-0.8-0.1c-1.1-0.1-1.4-0.4-1.4-1c0-0.6,0.5-1,1.4-1 c0.7,0,1.5,0.3,2,0.6c0.1,0,0.2,0,0.2,0l0.5-0.7c0-0.1,0-0.2,0-0.2c-0.6-0.5-1.5-0.8-2.6-0.8c-1.7,0-2.7,0.8-2.7,2.2 c0,1.2,0.7,1.9,2.2,2.1l0.8,0.1c1.1,0.1,1.4,0.4,1.4,1c0,0.7-0.5,1.1-1.6,1.1c-0.9,0-1.7-0.4-2.3-0.8c-0.1-0.1-0.2-0.1-0.2,0 l-0.6,0.7c-0.1,0.1-0.1,0.2,0,0.2C-4361.8-1426.8-4360.8-1426.3-4359.4-1426.3 M-4354-1430.1c0,0.8,0.1,1.4,0.2,1.9 c0.4,1.3,1.5,2,2.9,2c1.1,0,2-0.5,2.5-1.2c0-0.1,0-0.1,0-0.2l-0.7-0.5c-0.1-0.1-0.2-0.1-0.2,0c-0.4,0.5-0.8,0.8-1.6,0.8 c-0.8,0-1.4-0.4-1.6-1.1c-0.1-0.4-0.2-0.8-0.2-1.5c0-0.6,0-1.1,0.2-1.5c0.2-0.8,0.8-1.1,1.6-1.1c0.7,0,1.1,0.3,1.6,0.8 c0.1,0.1,0.1,0.1,0.2,0l0.7-0.5c0.1-0.1,0.1-0.1,0-0.2c-0.5-0.8-1.4-1.2-2.5-1.2c-1.4,0-2.5,0.7-2.9,2 C-4353.9-1431.5-4354-1430.9-4354-1430.1 M-4339.7-1426.4c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7c-1,0-1.7,0.4-2,1h0 v-3.7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v10.1c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-4.3 c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2H-4339.7z M-4333.8-1426.3c1.3,0,2.3-0.5,2.9-1.2 c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9 c0-0.1,0-0.1,0.1-0.1h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2 c-0.2,0.4-0.2,1-0.2,1.8c0,0.8,0.1,1.4,0.2,1.8C-4336.3-1427-4335.3-1426.3-4333.8-1426.3 M-4335.6-1430.7 C-4335.6-1430.7-4335.7-1430.8-4335.6-1430.7c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1 c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-4335.6z M-4322.4-1426.4c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7 c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2 v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2H-4322.4z M-4319.4-1426.6c0,0.1,0.1,0.2,0.2,0.2 h1.2c0.1,0,0.2-0.1,0.2-0.2v-1.3c0-0.1-0.1-0.2-0.2-0.2h-1.2c-0.1,0-0.2,0.1-0.2,0.2V-1426.6z M-4312.6-1426.6 c0,0.1,0.1,0.2,0.2,0.2h1.1c0.1,0,0.2-0.1,0.2-0.2v-4.4c0-0.1,0-0.1,0.1-0.1h4.5c0.1,0,0.1,0,0.1,0.1v4.4c0,0.1,0.1,0.2,0.2,0.2 h1.1c0.1,0,0.2-0.1,0.2-0.2v-10.1c0-0.1-0.1-0.2-0.2-0.2h-1.1c-0.1,0-0.2,0.1-0.2,0.2v4.3c0,0.1,0,0.1-0.1,0.1h-4.5 c-0.1,0-0.1,0-0.1-0.1v-4.3c0-0.1-0.1-0.2-0.2-0.2h-1.1c-0.1,0-0.2,0.1-0.2,0.2V-1426.6z M-4299.4-1426.3c1.3,0,2.3-0.5,2.9-1.2 c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9 c0-0.1,0-0.1,0.1-0.1h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2 c-0.2,0.4-0.2,1-0.2,1.8c0,0.8,0.1,1.4,0.2,1.8C-4301.9-1427-4300.8-1426.3-4299.4-1426.3 M-4301.1-1430.7 C-4301.2-1430.7-4301.2-1430.8-4301.1-1430.7c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1 c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-4301.1z M-4292.5-1435.4c0.1,0,0.2-0.1,0.2-0.2v-1.1c0-0.1-0.1-0.2-0.2-0.2h-1 c-0.1,0-0.2,0.1-0.2,0.2v1.1c0,0.1,0.1,0.2,0.2,0.2H-4292.5z M-4292.5-1426.4c0.1,0,0.2-0.1,0.2-0.2v-7c0-0.1-0.1-0.2-0.2-0.2h-1 c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2H-4292.5z M-4279.3-1426.4c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.6-2.7 c-1.1,0-1.9,0.4-2.4,1.1h0c-0.4-0.7-1.1-1.1-2.1-1.1c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v7 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2h1 c0.1,0,0.2-0.1,0.2-0.2v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2H-4279.3z M-4270.8-1426.4 c0.1,0,0.2-0.1,0.2-0.2v-4.8c0-1.8-0.8-2.5-2.9-2.5c-1.1,0-1.9,0.3-2.5,0.7c-0.1,0.1-0.1,0.1,0,0.2l0.4,0.7c0,0.1,0.1,0.1,0.2,0 c0.4-0.3,0.9-0.5,1.8-0.5c1.4,0,1.8,0.4,1.8,1.4v0.5c0,0.1,0,0.1-0.1,0.1h-1.7c-1.8,0-2.9,0.7-2.9,2.3c0,1.5,1.1,2.2,2.5,2.2 c1.1,0,1.8-0.4,2.2-1h0v0.6c0,0.1,0.1,0.2,0.2,0.2H-4270.8z M-4273.7-1427.4c-1,0-1.5-0.4-1.5-1.1c0-0.8,0.5-1.2,1.8-1.2h1.5 c0.1,0,0.1,0,0.1,0.1v0.8C-4271.9-1427.9-4272.6-1427.4-4273.7-1427.4 M-4264.9-1426.4c0.1,0,0.2-0.1,0.2-0.2v-0.9 c0-0.1-0.1-0.2-0.2-0.2h-0.3c-0.7,0-0.9-0.2-0.9-0.9v-4.1c0-0.1,0-0.1,0.1-0.1h1.2c0.1,0,0.2-0.1,0.2-0.2v-0.7 c0-0.1-0.1-0.2-0.2-0.2h-1.2c-0.1,0-0.1,0-0.1-0.1v-2.1c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v2.1 c0,0.1,0,0.1-0.1,0.1h-0.6c-0.1,0-0.2,0.1-0.2,0.2v0.7c0,0.1,0.1,0.2,0.2,0.2h0.6c0.1,0,0.1,0,0.1,0.1v4.2c0,1.4,0.5,2.1,2,2.1 H-4264.9z M-4261.9-1426.6c0,0.1,0.1,0.2,0.2,0.2h1.2c0.1,0,0.2-0.1,0.2-0.2v-1.3c0-0.1-0.1-0.2-0.2-0.2h-1.2 c-0.1,0-0.2,0.1-0.2,0.2V-1426.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4508.9,
    y: -1462.1,
    style: {
      clipPath: "url(#SVGID_00000132075386121179545910000012999104976948967048_)",
      fill: "#FFFFFF"
    },
    width: 48.1,
    height: 40.1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000132075386121179545910000012999104976948967048_)",
      fill: "#005CA9"
    },
    d: "M-4494.1-1426.8 c-5.1,0-9.3-4.6-9.3-10.2c0-1.4,0.2-3.1,0.6-4.3c1.4-3.6,4.8-5.9,8.7-5.9c3.8,0,7.2,2.3,8.7,5.9c0.5,1.3,0.7,2.9,0.7,4.3 C-4484.8-1431.3-4489-1426.8-4494.1-1426.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000132075386121179545910000012999104976948967048_)",
      fill: "#005CA9"
    },
    points: " -4485.4,-1445.9 -4486.4,-1451.6 -4491.4,-1452.7 -4486.4,-1453.7 -4485.4,-1458.8 -4484.5,-1453.7 -4479.4,-1452.7  -4484.3,-1451.6  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000132075386121179545910000012999104976948967048_)",
      fill: "#005CA9"
    },
    d: "M-4467-1427.2h-16.8 v-0.7l10.4-17.2l0-0.4h-4.2c-1.6,0-2.3,0.5-3,1.1c-0.7,0.5-1,1.2-1.3,1.9c-0.2,0.6-0.3,1.3-0.3,1.3h-0.7l0.4-5.4h15.6l-10.9,18 v0.2c0,0,2.5,0.1,3.6,0.1c1-0.1,3.9-0.2,5.3-1.8c1.1-1.3,1.5-2.5,1.8-3.7c0-0.1,0.1-0.3,0.1-0.3l0.7,0L-4467-1427.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000132075386121179545910000012999104976948967048_)",
      fill: "#FFFFFF"
    },
    d: "M-4494.1-1445.7 c-1.2,0-2.5,0.9-3.3,2.6c-0.7,1.6-0.9,3.8-1,6.1c-0.1,5.9,1.8,8.7,4.2,8.7c2.4,0,4.1-2.8,4.2-8.7c0-2.3-0.1-4.6-0.8-6.1 C-4491.5-1444.8-4492.8-1445.7-4494.1-1445.7"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000069391799652019318240000010946689292035616403_",
    x: -4535.1,
    y: -612.3,
    width: 299.5,
    height: 88.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026846152224648993570000007687991532635304067_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069391799652019318240000010946689292035616403_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000026846152224648993570000007687991532635304067_)"
    }
  }, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000143582745454910960620000004828765065741398408_",
    x: -4535.1,
    y: -612.3,
    width: 299.5,
    height: 88.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000035496841239919574010000005085070023048345023_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000143582745454910960620000004828765065741398408_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000035496841239919574010000005085070023048345023_)",
      fill: "#FFFFFF"
    },
    d: "M-4444.8-584.3 c-4.5,0-7.1,2.8-7.1,7.6c0,4.9,2.6,7.6,7.1,7.6s7.1-2.8,7.1-7.6C-4437.7-581.5-4440.3-584.3-4444.8-584.3 M-4440.3-576.7 c0,3-0.8,6.6-4.5,6.6s-4.4-3.6-4.5-6.6c0-3,0.8-6.6,4.5-6.6S-4440.4-579.7-4440.3-576.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000035496841239919574010000005085070023048345023_)",
      fill: "#FFFFFF"
    },
    d: "M-4429.8-578 l-0.7-0.2c-0.9-0.3-2.5-1.1-2.5-2.5c0-1.5,1-2.5,2.5-2.5c1.7,0,2.7,1,3,3l0,0.1h0.9v-3.1l-0.1,0c-0.7-0.6-2.1-0.9-3.6-0.9 c-2.3,0-4.9,1.1-4.9,4.1c0,2.5,2.3,3.6,4,4.2l0.4,0.1c1,0.4,2.8,1.3,2.8,3c0,1.7-1.1,2.7-2.9,2.7c-1.8,0-3.1-1.3-3.6-3.7l0-0.1 h-0.9l0.2,3.5l0,0c1,0.9,2.9,1.3,4.2,1.3c3.9,0,5.3-2.3,5.3-4.4C-4425.6-576.1-4427.6-577.2-4429.8-578"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000035496841239919574010000005085070023048345023_)",
      fill: "#FFFFFF"
    },
    d: "M-4423.6-580.3h0.9 l0-0.1c0.2-2.2,0.7-2.6,3-2.6h1.1v11.6c0,1.1,0,1.1-2.2,1.2l-0.1,0v0.9h6.9v-0.9l-0.1,0c-2.2-0.1-2.2-0.1-2.2-1.2V-583h1.1 c2.3,0,2.7,0.4,3,2.6l0,0.1h0.9v-3.7h-12.3V-580.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000035496841239919574010000005085070023048345023_)",
      fill: "#FFFFFF"
    },
    d: "M-4403.4-578 l-0.7-0.2c-0.9-0.3-2.5-1.1-2.5-2.5c0-1.5,1-2.5,2.5-2.5c1.7,0,2.7,1,3,3l0,0.1h0.9v-3.1l-0.1,0c-0.7-0.6-2.1-0.9-3.6-0.9 c-2.3,0-4.9,1.1-4.9,4.1c0,2.5,2.3,3.6,4,4.2l0.4,0.1c1,0.4,2.8,1.3,2.8,3c0,1.7-1.1,2.7-2.9,2.7c-1.8,0-3.1-1.3-3.6-3.7l0-0.1 h-0.9l0.2,3.5l0,0c1,0.9,2.9,1.3,4.2,1.3c3.9,0,5.3-2.3,5.3-4.4C-4399.2-576.1-4401.3-577.2-4403.4-578"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000035496841239919574010000005085070023048345023_)",
      fill: "#FFFFFF"
    },
    d: "M-4386.3-573.1 c-0.5,2.4-1.2,2.8-3.9,2.8c-0.8,0-1.7,0-2.1-0.2c-0.4-0.2-0.4-0.4-0.4-1.4v-4.5h2.8c1.7,0,1.7,0.4,1.9,1.7l0,0.1h0.9v-4.7h-0.9 l0,0.1c-0.2,1.3-0.2,1.7-1.9,1.7h-2.8v-4.9c0-0.6,0-0.6,0.6-0.6h2c2.3,0,2.7,0.5,3,2.6l0,0.1h0.9v-3.7h-10.8v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h11.3l0.3-3.9h-0.9L-4386.3-573.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000035496841239919574010000005085070023048345023_)",
      fill: "#FFFFFF"
    },
    d: "M-4372.7-573.2l0,0.1 c-0.5,2.4-1.2,2.8-3.9,2.8c-0.8,0-1.7,0-2.1-0.2c-0.4-0.2-0.4-0.4-0.4-1.4v-4.5h2.8c1.7,0,1.7,0.4,1.9,1.7l0,0.1h0.9v-4.7h-0.9 l0,0.1c-0.2,1.3-0.2,1.7-1.9,1.7h-2.8v-4.9c0-0.6,0-0.6,0.6-0.6h2c2.3,0,2.7,0.5,3,2.6l0,0.1h0.9v-3.7h-10.8v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h11.3l0.3-3.9H-4372.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000035496841239919574010000005085070023048345023_)",
      fill: "#FFFFFF"
    },
    d: "M-4350-573.2 c-0.4,2.5-1.3,2.9-4.4,2.9h-3.9c2.9-4.3,5.9-8.5,9.1-13.2l0-0.1l-0.2-0.4h-10.8v3.9h0.9l0-0.1c0.2-2.3,0.7-2.7,3.5-2.7h3.5 c-3.3,4.8-6.6,9.5-9.1,13.2l0,0.1l0.2,0.4h12.1l0.2-4h-0.9L-4350-573.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000035496841239919574010000005085070023048345023_)",
      fill: "#FFFFFF"
    },
    d: "M-4336.6-573.1 c-0.5,2.4-1.2,2.8-3.9,2.8c-0.8,0-1.7,0-2.1-0.2c-0.4-0.2-0.4-0.4-0.4-1.4v-4.5h2.8c1.7,0,1.7,0.4,1.9,1.7l0,0.1h0.9v-4.7h-0.9 l0,0.1c-0.2,1.3-0.2,1.7-1.9,1.7h-2.8v-4.9c0-0.6,0-0.6,0.6-0.6h2c2.3,0,2.7,0.5,3,2.6l0,0.1h0.9v-3.7h-10.8v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h11.3l0.3-3.9h-0.9L-4336.6-573.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000035496841239919574010000005085070023048345023_)",
      fill: "#FFFFFF"
    },
    d: "M-4333.2-583.1l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v10.5c0,1.1,0,1.1-1.7,1.2l-0.1,0v0.9h6.1v-0.9l-0.1,0c-1.7-0.1-1.7-0.1-1.7-1.2v-10.5 c0-1.1,0-1.1,1.7-1.2l0.1,0v-0.9h-6.1V-583.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000035496841239919574010000005085070023048345023_)",
      fill: "#FFFFFF"
    },
    d: "M-4324.7-580.3h0.9 l0-0.1c0.2-2.2,0.7-2.6,3-2.6h1.1v11.6c0,1.1,0,1.1-2.2,1.2l-0.1,0v0.9h6.9v-0.9l-0.1,0c-2.2-0.1-2.2-0.1-2.2-1.2V-583h1.1 c2.3,0,2.7,0.4,3,2.6l0,0.1h0.9v-3.7h-12.3V-580.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000035496841239919574010000005085070023048345023_)",
      fill: "#FFFFFF"
    },
    d: "M-4301.2-583.1l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v6.7c0,3.5-1.1,5.2-3.6,5.2c-3.2,0-3.5-2.9-3.5-5.2v-6.7c0-1.1,0-1.1,1.7-1.2l0.1,0v-0.9h-6.1v0.9l0.1,0 c1.7,0.1,1.7,0.1,1.7,1.2v7.2c0.1,3.9,1.9,5.7,5.9,5.7c4,0,5.9-1.8,5.9-5.8v-7.1c0-1.1,0-1.1,1.7-1.2l0.1,0v-0.9h-6.1V-583.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000035496841239919574010000005085070023048345023_)",
      fill: "#FFFFFF"
    },
    d: "M-4283-583.1l0.1,0 c1.4,0.1,1.7,0.2,1.8,0.9c0.1,0.7,0.1,1.4,0.1,2.6v6.9c-2.7-3.7-5.3-7.5-7.9-11.2l0-0.1h-4.2v0.9l0.1,0c1.7,0.1,1.7,0.1,1.7,1.2 v8.2c0,1.1,0,1.9-0.1,2.6c-0.1,0.7-0.5,0.8-1.6,0.9l-0.1,0v0.9h5.2v-0.9l-0.1,0c-1.4-0.1-1.7-0.2-1.8-0.9 c-0.1-0.7-0.1-1.4-0.1-2.6v-7.9c3.2,4.5,5.9,8.3,8.6,12.2l0,0.1h1.6v-10.3c0-1.1,0-1.9,0.1-2.6c0.1-0.7,0.5-0.8,1.6-0.9l0.1,0 v-0.9h-5.2V-583.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000035496841239919574010000005085070023048345023_)",
      fill: "#FFFFFF"
    },
    d: "M-4267.6-576.2v0.9 l0.1,0c2.1,0.1,2.1,0.2,2.1,1.2v2.8c0,0.6-0.2,0.8-0.6,1c-0.5,0.2-1.1,0.3-1.8,0.3c-5,0-5.5-4.7-5.5-6.7c0-2,0.5-6.6,5.3-6.6 c2.3,0,3.5,1,3.9,3.3l0,0.1h0.9v-3.5l-0.1,0c-1.1-0.5-2.9-0.9-4.5-0.9c-5.2,0-8.1,2.8-8.1,7.9c0,2.6,1,4.8,2.6,6l0,0 c1.7,1.2,3.7,1.4,5.3,1.4c1.5,0,3.5-0.5,4.8-0.9l0.1,0v-4.2c0-0.9,0-1,1.4-1.2l0.1,0v-0.9H-4267.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4368.9,
    y: -576.9,
    style: {
      clipPath: "url(#SVGID_00000035496841239919574010000005085070023048345023_)",
      fill: "#FFFFFF"
    },
    width: 5.4,
    height: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000035496841239919574010000005085070023048345023_)",
      fill: "#FFFFFF"
    },
    d: "M-4450.9-553.9 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-7.2h0l2.6,5.7c0.1,0.1,0.1,0.2,0.3,0.2h0.6c0.1,0,0.2,0,0.3-0.2l2.6-5.7h0v7.2 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2V-564c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0-0.2,0.2l-3,7h0l-3.1-7 c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2V-553.9z M-4436.1-553.6c1.3,0,2.3-0.5,2.9-1.2c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6 c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9c0-0.1,0-0.1,0.1-0.1h4.6 c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2c-0.2,0.4-0.2,1-0.2,1.8 s0.1,1.4,0.2,1.8C-4438.6-554.3-4437.5-553.6-4436.1-553.6 M-4437.8-558C-4437.9-558-4437.9-558.1-4437.8-558 c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-4437.8z  M-4424.2-553.8c0.1,0,0.2-0.1,0.2-0.2V-564c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v3.8h0c-0.4-0.6-1-1-2.1-1 c-1.3,0-2.1,0.6-2.5,1.8c-0.2,0.6-0.3,1.2-0.3,2.1c0,0.9,0.1,1.5,0.3,2.1c0.4,1.2,1.2,1.8,2.5,1.8c1.1,0,1.7-0.4,2.1-1h0v0.7 c0,0.1,0.1,0.2,0.2,0.2H-4424.2z M-4427.1-554.8c-0.8,0-1.4-0.4-1.6-1.1c-0.1-0.4-0.2-0.9-0.2-1.5c0-0.7,0-1.1,0.2-1.5 c0.2-0.7,0.8-1.1,1.6-1.1s1.4,0.4,1.6,1.1c0.1,0.4,0.2,0.8,0.2,1.5s0,1.2-0.2,1.5C-4425.8-555.2-4426.3-554.8-4427.1-554.8  M-4420.1-562.7c0.1,0,0.2-0.1,0.2-0.2v-1.1c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v1.1c0,0.1,0.1,0.2,0.2,0.2H-4420.1 z M-4420.1-553.8c0.1,0,0.2-0.1,0.2-0.2v-7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2H-4420.1z  M-4413.8-553.6c1.3,0,2.3-0.5,2.9-1.2c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8 c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9c0-0.1,0-0.1,0.1-0.1h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1 c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2c-0.2,0.4-0.2,1-0.2,1.8s0.1,1.4,0.2,1.8C-4416.4-554.3-4415.3-553.6-4413.8-553.6  M-4415.6-558C-4415.7-558-4415.7-558.1-4415.6-558c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1 c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-4415.6z M-4402.4-553.8c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7 c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2 v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2H-4402.4z M-4399.4-553.9c0,0.1,0.1,0.2,0.2,0.2 h1.2c0.1,0,0.2-0.1,0.2-0.2v-1.3c0-0.1-0.1-0.2-0.2-0.2h-1.2c-0.1,0-0.2,0.1-0.2,0.2V-553.9z M-4392.6-553.9 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-7.2h0l2.6,5.7c0.1,0.1,0.1,0.2,0.3,0.2h0.6c0.1,0,0.2,0,0.3-0.2l2.6-5.7h0v7.2 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2V-564c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0-0.2,0.2l-3,7h0l-3.1-7 c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2V-553.9z M-4377.8-553.6c1.3,0,2.3-0.5,2.9-1.2c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6 c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9c0-0.1,0-0.1,0.1-0.1h4.6 c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2c-0.2,0.4-0.2,1-0.2,1.8 s0.1,1.4,0.2,1.8C-4380.4-554.3-4379.3-553.6-4377.8-553.6 M-4379.6-558C-4379.6-558-4379.7-558.1-4379.6-558 c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-4379.6z  M-4366.1-553.8c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1 c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3 c0,0.1,0.1,0.2,0.2,0.2H-4366.1z M-4360.4-553.6c1.9,0,2.9-1,2.9-2.4c0-1.2-0.7-1.9-2.2-2.1l-0.8-0.1c-1.1-0.1-1.4-0.4-1.4-1 c0-0.6,0.5-1,1.4-1c0.7,0,1.5,0.3,2,0.6c0.1,0,0.2,0,0.2,0l0.5-0.7c0-0.1,0-0.2,0-0.2c-0.6-0.5-1.5-0.8-2.6-0.8 c-1.7,0-2.7,0.8-2.7,2.2c0,1.2,0.7,1.9,2.2,2.1l0.8,0.1c1.1,0.1,1.4,0.4,1.4,1c0,0.7-0.5,1.1-1.6,1.1c-0.9,0-1.7-0.4-2.3-0.8 c-0.1-0.1-0.2-0.1-0.2,0l-0.6,0.7c-0.1,0.1-0.1,0.2,0,0.2C-4362.8-554.2-4361.8-553.6-4360.4-553.6 M-4355-557.4 c0,0.8,0.1,1.4,0.2,1.9c0.4,1.3,1.5,2,2.9,2c1.1,0,2-0.5,2.5-1.2c0-0.1,0-0.1,0-0.2l-0.7-0.5c-0.1-0.1-0.2-0.1-0.2,0 c-0.4,0.5-0.8,0.8-1.6,0.8c-0.8,0-1.4-0.4-1.6-1.1c-0.1-0.4-0.2-0.8-0.2-1.5c0-0.6,0-1.1,0.2-1.5c0.2-0.8,0.8-1.1,1.6-1.1 c0.7,0,1.1,0.3,1.6,0.8c0.1,0.1,0.1,0.1,0.2,0l0.7-0.5c0.1-0.1,0.1-0.1,0-0.2c-0.5-0.8-1.4-1.2-2.5-1.2c-1.4,0-2.5,0.7-2.9,2 C-4354.9-558.8-4355-558.2-4355-557.4 M-4340.7-553.8c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7c-1,0-1.7,0.4-2,1h0v-3.7 c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v10.1c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-4.3 c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2H-4340.7z M-4334.8-553.6c1.3,0,2.3-0.5,2.9-1.2 c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9 c0-0.1,0-0.1,0.1-0.1h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2 c-0.2,0.4-0.2,1-0.2,1.8s0.1,1.4,0.2,1.8C-4337.3-554.3-4336.3-553.6-4334.8-553.6 M-4336.6-558 C-4336.6-558-4336.7-558.1-4336.6-558c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1 c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-4336.6z M-4323.4-553.8c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.5-2.7 c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2 v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2H-4323.4z M-4320.4-553.9c0,0.1,0.1,0.2,0.2,0.2 h1.2c0.1,0,0.2-0.1,0.2-0.2v-1.3c0-0.1-0.1-0.2-0.2-0.2h-1.2c-0.1,0-0.2,0.1-0.2,0.2V-553.9z M-4313.6-553.9 c0,0.1,0.1,0.2,0.2,0.2h1.1c0.1,0,0.2-0.1,0.2-0.2v-4.4c0-0.1,0-0.1,0.1-0.1h4.5c0.1,0,0.1,0,0.1,0.1v4.4c0,0.1,0.1,0.2,0.2,0.2 h1.1c0.1,0,0.2-0.1,0.2-0.2V-564c0-0.1-0.1-0.2-0.2-0.2h-1.1c-0.1,0-0.2,0.1-0.2,0.2v4.3c0,0.1,0,0.1-0.1,0.1h-4.5 c-0.1,0-0.1,0-0.1-0.1v-4.3c0-0.1-0.1-0.2-0.2-0.2h-1.1c-0.1,0-0.2,0.1-0.2,0.2V-553.9z M-4300.4-553.6c1.3,0,2.3-0.5,2.9-1.2 c0.1-0.1,0.1-0.2,0-0.2l-0.6-0.6c-0.1-0.1-0.2,0-0.2,0c-0.4,0.5-1,0.8-1.9,0.8c-0.9,0-1.6-0.4-1.8-1.3c-0.1-0.2-0.1-0.5-0.1-0.9 c0-0.1,0-0.1,0.1-0.1h4.6c0.1,0,0.2-0.1,0.2-0.2c0-1.1-0.1-1.6-0.2-2.1c-0.4-1.2-1.5-2-2.9-2c-1.4,0-2.5,0.7-2.9,2 c-0.2,0.4-0.2,1-0.2,1.8s0.1,1.4,0.2,1.8C-4302.9-554.3-4301.8-553.6-4300.4-553.6 M-4302.1-558 C-4302.2-558-4302.2-558.1-4302.1-558c-0.1-0.4-0.1-0.7,0-0.9c0.2-0.7,0.9-1.1,1.7-1.1c0.8,0,1.4,0.4,1.7,1.1 c0.1,0.2,0.1,0.5,0.1,0.8c0,0.1,0,0.1-0.1,0.1H-4302.1z M-4293.5-562.7c0.1,0,0.2-0.1,0.2-0.2v-1.1c0-0.1-0.1-0.2-0.2-0.2h-1 c-0.1,0-0.2,0.1-0.2,0.2v1.1c0,0.1,0.1,0.2,0.2,0.2H-4293.5z M-4293.5-553.8c0.1,0,0.2-0.1,0.2-0.2v-7c0-0.1-0.1-0.2-0.2-0.2h-1 c-0.1,0-0.2,0.1-0.2,0.2v7c0,0.1,0.1,0.2,0.2,0.2H-4293.5z M-4280.3-553.8c0.1,0,0.2-0.1,0.2-0.2v-4.6c0-1.7-0.9-2.7-2.6-2.7 c-1.1,0-1.9,0.4-2.4,1.1h0c-0.4-0.7-1.1-1.1-2.1-1.1c-1,0-1.7,0.4-2,1h0v-0.7c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v7 c0,0.1,0.1,0.2,0.2,0.2h1c0.1,0,0.2-0.1,0.2-0.2v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2h1 c0.1,0,0.2-0.1,0.2-0.2v-4.3c0-1.1,0.7-1.8,1.7-1.8c1.1,0,1.6,0.7,1.6,1.9v4.3c0,0.1,0.1,0.2,0.2,0.2H-4280.3z M-4271.8-553.8 c0.1,0,0.2-0.1,0.2-0.2v-4.8c0-1.8-0.8-2.5-2.9-2.5c-1.1,0-1.9,0.3-2.5,0.7c-0.1,0.1-0.1,0.1,0,0.2l0.4,0.7c0,0.1,0.1,0.1,0.2,0 c0.4-0.3,0.9-0.5,1.8-0.5c1.4,0,1.8,0.4,1.8,1.4v0.5c0,0.1,0,0.1-0.1,0.1h-1.7c-1.8,0-2.9,0.7-2.9,2.3c0,1.5,1.1,2.2,2.5,2.2 c1.1,0,1.8-0.4,2.2-1h0v0.6c0,0.1,0.1,0.2,0.2,0.2H-4271.8z M-4274.7-554.7c-1,0-1.5-0.4-1.5-1.1c0-0.8,0.5-1.2,1.8-1.2h1.5 c0.1,0,0.1,0,0.1,0.1v0.8C-4272.9-555.2-4273.6-554.7-4274.7-554.7 M-4265.9-553.7c0.1,0,0.2-0.1,0.2-0.2v-0.9 c0-0.1-0.1-0.2-0.2-0.2h-0.3c-0.7,0-0.9-0.2-0.9-0.9v-4.1c0-0.1,0-0.1,0.1-0.1h1.2c0.1,0,0.2-0.1,0.2-0.2v-0.7 c0-0.1-0.1-0.2-0.2-0.2h-1.2c-0.1,0-0.1,0-0.1-0.1v-2.1c0-0.1-0.1-0.2-0.2-0.2h-1c-0.1,0-0.2,0.1-0.2,0.2v2.1 c0,0.1,0,0.1-0.1,0.1h-0.6c-0.1,0-0.2,0.1-0.2,0.2v0.7c0,0.1,0.1,0.2,0.2,0.2h0.6c0.1,0,0.1,0,0.1,0.1v4.2c0,1.4,0.5,2.1,2,2.1 H-4265.9z M-4262.9-553.9c0,0.1,0.1,0.2,0.2,0.2h1.2c0.1,0,0.2-0.1,0.2-0.2v-1.3c0-0.1-0.1-0.2-0.2-0.2h-1.2 c-0.1,0-0.2,0.1-0.2,0.2V-553.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4509.9,
    y: -589.4,
    style: {
      clipPath: "url(#SVGID_00000035496841239919574010000005085070023048345023_)",
      fill: "#FFFFFF"
    },
    width: 48.1,
    height: 40.1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000035496841239919574010000005085070023048345023_)",
      fill: "#005CA9"
    },
    d: "M-4495.1-554.1 c-5.1,0-9.3-4.6-9.3-10.2c0-1.4,0.2-3.1,0.6-4.3c1.4-3.6,4.8-5.9,8.7-5.9c3.8,0,7.2,2.3,8.7,5.9c0.5,1.3,0.7,2.9,0.7,4.3 C-4485.8-558.7-4490-554.1-4495.1-554.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000035496841239919574010000005085070023048345023_)",
      fill: "#005CA9"
    },
    points: " -4486.4,-573.2 -4487.4,-578.9 -4492.4,-580 -4487.4,-581 -4486.4,-586.1 -4485.5,-581 -4480.4,-580 -4485.3,-578.9  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000035496841239919574010000005085070023048345023_)",
      fill: "#005CA9"
    },
    d: "M-4468-554.6h-16.8 v-0.7l10.4-17.2l0-0.4h-4.2c-1.6,0-2.3,0.5-3,1.1c-0.7,0.5-1,1.2-1.3,1.9c-0.2,0.6-0.3,1.3-0.3,1.3h-0.7l0.4-5.4h15.6l-10.9,18 v0.2c0,0,2.5,0.1,3.6,0.1c1-0.1,3.9-0.2,5.3-1.8c1.1-1.3,1.5-2.5,1.8-3.7c0-0.1,0.1-0.3,0.1-0.3l0.7,0L-4468-554.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000035496841239919574010000005085070023048345023_)",
      fill: "#FFFFFF"
    },
    d: "M-4495.1-573 c-1.2,0-2.5,0.9-3.3,2.6c-0.7,1.6-0.9,3.8-1,6.1c-0.1,5.9,1.8,8.7,4.2,8.7c2.4,0,4.1-2.8,4.2-8.7c0-2.3-0.1-4.6-0.8-6.1 C-4492.5-572.1-4493.8-573-4495.1-573"
  })))), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: -1364.1,
    y: -2102.5,
    className: "st16",
    width: 206.8,
    height: 129.6
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: -1158.1,
    y: -2102.5,
    className: "st51",
    width: 204.2,
    height: 129.6
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: -1364.1,
    y: -1947.1,
    className: "st52",
    width: 206.8,
    height: 129.6
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: -1158.1,
    y: -1947.1,
    className: "st8",
    width: 204.2,
    height: 129.6
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: -1570.3,
    y: -2102.5,
    className: "st14",
    width: 206.8,
    height: 129.6
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: -1570.3,
    y: -1947.1,
    className: "st22",
    width: 206.8,
    height: 129.6
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1921,
    height: 55,
    xlinkHref: "9696B930.jpg",
    transform: "matrix(0.9995 0 0 1 -1473.8004 1289.1379)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1920,
    height: 1080,
    xlinkHref: "../../Downloads/MicrosoftTeams-image (98).png (1).png",
    transform: "matrix(1 0 0 1 -1473.8004 2402.1167)"
  }), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: -1473.8,
    y: 1531.9,
    className: "st22",
    width: 954.6,
    height: 148.9
  })), /*#__PURE__*/React.createElement("g", null, _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: -804.5,
    y: 2455.6,
    className: "st0",
    width: 623.9,
    height: 326.6
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: -804.5,
    y: 2455.6,
    className: "st44",
    width: 623.9,
    height: 326.6
  })), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000075860986155912096190000011616153989362512281_",
    x: -804.5,
    y: 2455.4,
    width: 623.9,
    height: 327.3
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000075860986155912096190000011616153989362512281_",
    style: {
      overflow: "visible",
      fill: "#E84E0F"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000177462470176754010600000004722688780481928625_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000075860986155912096190000011616153989362512281_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#XMLID_00000177462470176754010600000004722688780481928625_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1273,
    height: 841,
    xlinkHref: "1x/Asset 2.png",
    transform: "matrix(0.6536 0 0 0.6506 -808.3588 2235.5093)"
  })))), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: -508.4,
    y: 1531.9,
    className: "st22",
    width: 954.6,
    height: 148.9
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: -1473.8,
    y: 2051.1,
    className: "st14",
    width: 954.6,
    height: 146
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: -508.4,
    y: 2051.1,
    className: "st14",
    width: 954.6,
    height: 146
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0035 0 0 1 -1254.8353 1631.4373)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "69.757px"
    }
  }, "Meeting Room 4"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0035 0 0 1 -289.4134 1631.4373)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "69.757px"
    }
  }, "Meeting Room 4"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -1254.8373 2150.7185)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "68.4157px"
    }
  }, "Meeting Room 4"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -289.4149 2150.7185)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "68.4157px"
    }
  }, "Meeting Room 4"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0035 0 0 1 -1081.5836 1498.6492)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.8958px"
    }
  }, "VERF\xDCGBAR"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0035 0 0 1 -116.1615 1498.6492)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.8958px"
    }
  }, "VERF\xDCGBAR"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -1059.5199 2020.4832)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "BESETZT"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -94.0975 2020.4832)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "BESETZT"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -1117.3436 2248.0642)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Aktuelles Meeting"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -151.9212 2248.0642)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Aktuelles Meeting"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -1086.0885 2283.5789)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Bold'",
      fontSize: "22.4794px"
    }
  }, "Demo Meeting 1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -120.6663 2283.5789)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Bold'",
      fontSize: "22.4794px"
    }
  }, "Demo Meeting 2"), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000067920478630264089260000010596442464950036654_",
    x: -1430.1,
    y: 2455.7,
    width: 614,
    height: 327.3
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000067920478630264089260000010596442464950036654_",
    style: {
      overflow: "visible",
      fill: "#4F80FF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000031179252807437006900000004158916295913210536_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000067920478630264089260000010596442464950036654_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#XMLID_00000031179252807437006900000004158916295913210536_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 690,
    height: 402,
    xlinkHref: "9696B955.png",
    transform: "matrix(1 0 0 1 -1467.9779 2418.3933)"
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -1054.3641 2325.3979)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 20
    }
  }, "15:00 - 17:00"), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000047032353156291095540000011810324436471925689_",
    x: -781.4,
    y: 2455.4,
    width: 585.9,
    height: 327.7
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000047032353156291095540000011810324436471925689_",
    style: {
      overflow: "visible",
      fill: "#E84F1C"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000153699078969565839730000011423982145293596546_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000047032353156291095540000011810324436471925689_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#XMLID_00000153699078969565839730000011423982145293596546_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 657,
    height: 404,
    xlinkHref: "9696B957.png",
    transform: "matrix(1 0 0 1 -816.9778 2417.3933)"
  }))), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000132046850773486447560000004121146675915696821_",
    x: -160.8,
    y: 2455.4,
    width: 607,
    height: 327.7
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000132046850773486447560000004121146675915696821_",
    style: {
      overflow: "visible",
      fill: "#E84F1C"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000079482466333396390790000000016356676725459642_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000132046850773486447560000004121146675915696821_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#XMLID_00000079482466333396390790000000016356676725459642_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 678,
    height: 404,
    xlinkHref: "9696B954.png",
    transform: "matrix(1 0 0 1 -195.9779 2417.3933)"
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -88.9425 2325.3979)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 20
    }
  }, "15:00 - 17:30"), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: -195.5,
    y: 2447.7,
    className: "st0",
    width: 34.7,
    height: 335.3
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: -816.1,
    y: 2447.7,
    className: "st0",
    width: 34.7,
    height: 335.3
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -517.1021 2597.7581)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Frei"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -602.5562 2746.9922)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Meeting Room 1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 107.9228 2597.7581)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Frei"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 22.4687 2746.9922)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Meeting Room 2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -1142.3644 2597.7581)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Frei"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -1227.8185 2746.9922)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Meeting Room 3"), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: -4935.9,
    y: 1289.1,
    className: "st0",
    width: 1920,
    height: 1080.9
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: -3970.5,
    y: 1867,
    className: "st5",
    width: 954.6,
    height: 503.1
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: -4935.9,
    y: 1867,
    className: "st5",
    width: 954.6,
    height: 503.1
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: -4935.9,
    y: 1344.1,
    className: "st23",
    width: 954.9,
    height: 512.9
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: -3970.7,
    y: 1344.1,
    className: "st23",
    width: 954.9,
    height: 512.9
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1921,
    height: 55,
    xlinkHref: "9696B953.jpg",
    transform: "matrix(0.9995 0 0 1 -4935.9282 1289.1379)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1920,
    height: 1080,
    xlinkHref: "../../Downloads/MicrosoftTeams-image (98).png (1).png",
    transform: "matrix(1 0 0 1 -4935.9282 2402.1167)"
  }), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: -4935.9,
    y: 1531.9,
    className: "st22",
    width: 954.6,
    height: 148.9
  })), /*#__PURE__*/React.createElement("g", null, _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: -4266.6,
    y: 2455.6,
    className: "st0",
    width: 623.9,
    height: 326.6
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: -4266.6,
    y: 2455.6,
    className: "st44",
    width: 623.9,
    height: 326.6
  })), /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000044177719363155333290000015148285217090194874_",
    x: -4266.6,
    y: 2455.4,
    width: 623.9,
    height: 327.3
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000044177719363155333290000015148285217090194874_",
    style: {
      overflow: "visible",
      fill: "#E84E0F"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000085969110650998318570000011587893462369063834_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000044177719363155333290000015148285217090194874_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#XMLID_00000085969110650998318570000011587893462369063834_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1273,
    height: 841,
    xlinkHref: "1x/Asset 2.png",
    transform: "matrix(0.6536 0 0 0.6506 -4270.4863 2235.5093)"
  })))), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: -3970.5,
    y: 1531.9,
    className: "st22",
    width: 954.6,
    height: 148.9
  })), /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000003084845601892585260000005713836127835563432_",
    x: -4243.5,
    y: 2455.4,
    width: 585.9,
    height: 327.3
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000003084845601892585260000005713836127835563432_",
    style: {
      overflow: "visible",
      fill: "#E84F1C"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000083072839975956672260000010774132225424929208_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000003084845601892585260000005713836127835563432_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: -4288.1,
    y: 2433.1,
    style: {
      clipPath: "url(#XMLID_00000083072839975956672260000010774132225424929208_)",
      fill: "#E84F1C"
    },
    width: 667,
    height: 372.3
  })), /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000083789160962922866550000004849927546635316609_",
    x: -3621.9,
    y: 2455.4,
    width: 606,
    height: 327.3
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000083789160962922866550000004849927546635316609_",
    style: {
      overflow: "visible",
      fill: "#E84F1C"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000033363264589426963590000013048626391196068737_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000083789160962922866550000004849927546635316609_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: -3668.1,
    y: 2433.1,
    style: {
      clipPath: "url(#XMLID_00000033363264589426963590000013048626391196068737_)",
      fill: "#E84F1C"
    },
    width: 689.9,
    height: 372.3
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: -4935.9,
    y: 2051.1,
    className: "st14",
    width: 954.6,
    height: 146
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: -3970.5,
    y: 2051.1,
    className: "st14",
    width: 954.6,
    height: 146
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0035 0 0 1 -4716.9629 1631.4373)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "69.757px"
    }
  }, "Meeting Room 4"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0035 0 0 1 -3751.541 1631.4373)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "69.757px"
    }
  }, "Meeting Room 4"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -4716.9648 2150.7185)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "68.4157px"
    }
  }, "Meeting Room 4"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -3751.5425 2150.7185)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "68.4157px"
    }
  }, "Meeting Room 4"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0035 0 0 1 -4543.7114 1498.6492)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.8958px"
    }
  }, "VERF\xDCGBAR"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0035 0 0 1 -3578.2891 1498.6492)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.8958px"
    }
  }, "VERF\xDCGBAR"), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: -4892.2,
    y: 2455.7,
    className: "st22",
    width: 614,
    height: 327.3
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -4521.6475 2020.4832)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "BESETZT"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -3556.2251 2020.4832)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "BESETZT"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -4579.4712 2248.0642)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Aktuelles Meeting"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -3614.0488 2248.0642)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Aktuelles Meeting"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -4548.2163 2283.5789)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Bold'",
      fontSize: "22.4794px"
    }
  }, "Demo Meeting 1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -3582.7939 2283.5789)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Bold'",
      fontSize: "22.4794px"
    }
  }, "Demo Meeting 2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -4516.4917 2325.3979)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 20
    }
  }, "15:00 - 17:00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -3551.0701 2325.3979)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 20
    }
  }, "15:00 - 17:30"), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: -3657.6,
    y: 2447.7,
    className: "st0",
    width: 34.7,
    height: 335.3
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: -4278.2,
    y: 2447.7,
    className: "st0",
    width: 34.7,
    height: 335.3
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -3979.2297 2597.7581)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Frei"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -4064.6838 2746.9922)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Meeting Room 1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -3354.2048 2597.7581)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Frei"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -3439.6589 2746.9922)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Meeting Room 2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -4604.4922 2597.7581)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Frei"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -4689.9463 2746.9922)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Meeting Room 3"), /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000034772104782553875350000013673734985495307432_",
    x: -6348.2,
    y: 1344.1,
    width: 954.9,
    height: 512.9
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000034772104782553875350000013673734985495307432_",
    style: {
      overflow: "visible",
      fill: "#0080C9"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000176761028744804052100000012049705462206114225_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000034772104782553875350000013673734985495307432_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fotolia_x5F_85652600_x5F_L.tif_00000026866331316227242250000001597139188707943815_",
    style: {
      clipPath: "url(#XMLID_00000176761028744804052100000012049705462206114225_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 2500,
    height: 1650,
    id: "Fotolia_x5F_85652600_x5F_L_00000001630934478638749620000007118526954827026824_",
    xlinkHref: "9696B95D.jpg",
    transform: "matrix(0.5072 0 0 0.5072 -6348.189 1020.1456)"
  }))), /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000058587255177410920310000013959779626546371994_",
    x: -7313.8,
    y: 1344.1,
    width: 954.9,
    height: 512.9
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000058587255177410920310000013959779626546371994_",
    style: {
      overflow: "visible",
      fill: "#0080C9"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000019657139678801425030000002553647941065044146_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000058587255177410920310000013959779626546371994_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fotolia_x5F_85652600_x5F_L.tif_00000035488668075674198720000017620630762728740227_",
    style: {
      clipPath: "url(#XMLID_00000019657139678801425030000002553647941065044146_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 2500,
    height: 1650,
    id: "Fotolia_x5F_85652600_x5F_L_00000041979699638594406570000014729614400351513236_",
    xlinkHref: "9696B954.jpg",
    transform: "matrix(0.5072 0 0 0.5072 -7313.7837 1020.1456)"
  }))), /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000062913726601688104350000005785298166485942413_",
    x: -6348,
    y: 1867,
    width: 954.6,
    height: 503.1
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000062913726601688104350000005785298166485942413_",
    style: {
      overflow: "visible",
      fill: "#E84E0F"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000039108657517773867510000003576810136735567239_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000062913726601688104350000005785298166485942413_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#XMLID_00000039108657517773867510000003576810136735567239_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1273,
    height: 841,
    xlinkHref: "1x/Asset 2.png",
    transform: "matrix(1 0 0 1 -6353.46 1529.0415)"
  }))), /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000035494647307009535420000006065997867029377464_",
    x: -7313.4,
    y: 1867,
    width: 954.6,
    height: 503.1
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000035494647307009535420000006065997867029377464_",
    style: {
      overflow: "visible",
      fill: "#E84E0F"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000145766949777919643150000016882386042489012156_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000035494647307009535420000006065997867029377464_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#XMLID_00000145766949777919643150000016882386042489012156_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1273,
    height: 841,
    xlinkHref: "1x/Asset 2.png",
    transform: "matrix(1 0 0 1 -7319.4009 1529.0415)"
  }))), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: -6348,
    y: 1867,
    className: "st5",
    width: 954.6,
    height: 503.1
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: -7313.4,
    y: 1867,
    className: "st5",
    width: 954.6,
    height: 503.1
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: -7313.8,
    y: 1344.1,
    className: "st23",
    width: 954.9,
    height: 512.9
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: -6348.2,
    y: 1344.1,
    className: "st23",
    width: 954.9,
    height: 512.9
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1921,
    height: 55,
    xlinkHref: "9696B978.jpg",
    transform: "matrix(0.9995 0 0 1 -7313.46 1289.1379)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1920,
    height: 1080,
    xlinkHref: "../../Downloads/MicrosoftTeams-image (98).png (1).png",
    transform: "matrix(1 0 0 1 -7313.46 2402.1167)"
  }), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: -7313.4,
    y: 1531.9,
    className: "st22",
    width: 954.6,
    height: 148.9
  })), /*#__PURE__*/React.createElement("g", null, _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: -6644.1,
    y: 2455.6,
    className: "st0",
    width: 623.9,
    height: 326.6
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: -6644.1,
    y: 2455.6,
    className: "st44",
    width: 623.9,
    height: 326.6
  })), /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000113324866736102343140000005673878181184853159_",
    x: -6644.1,
    y: 2455.4,
    width: 623.9,
    height: 327.3
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000113324866736102343140000005673878181184853159_",
    style: {
      overflow: "visible",
      fill: "#E84E0F"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000024693932609679138770000014171222795072592261_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000113324866736102343140000005673878181184853159_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#XMLID_00000024693932609679138770000014171222795072592261_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1273,
    height: 841,
    xlinkHref: "1x/Asset 2.png",
    transform: "matrix(0.6536 0 0 0.6506 -6648.0186 2235.5093)"
  })))), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: -6348,
    y: 1531.9,
    className: "st22",
    width: 954.6,
    height: 148.9
  })), /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000169543959736998260610000014402683234618133944_",
    x: -6000.4,
    y: 2455.4,
    width: 606.4,
    height: 327.3
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000169543959736998260610000014402683234618133944_",
    style: {
      overflow: "visible",
      fill: "#E84E0F"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000097500419766576388180000003715883123643176594_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000169543959736998260610000014402683234618133944_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -4.882812e-04 0)",
    style: {
      clipPath: "url(#XMLID_00000097500419766576388180000003715883123643176594_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1273,
    height: 841,
    xlinkHref: "1x/Asset 2.png",
    transform: "matrix(0.6352 0 0 0.6506 -6004.2056 2235.5093)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -6321.2,
    y: 2283.6,
    style: {
      opacity: 0.7,
      clipPath: "url(#XMLID_00000097500419766576388180000003715883123643176594_)",
      fill: "#E84F1C"
    },
    width: 927.7,
    height: 503.1
  })), /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000116931749709469232490000009414475351501340555_",
    x: -6621,
    y: 2455.4,
    width: 585.9,
    height: 327.3
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000116931749709469232490000009414475351501340555_",
    style: {
      overflow: "visible",
      fill: "#E84E0F"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000162325493162794443100000013631105784522428586_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000116931749709469232490000009414475351501340555_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#XMLID_00000162325493162794443100000013631105784522428586_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1273,
    height: 841,
    xlinkHref: "1x/Asset 2.png",
    transform: "matrix(0.6138 0 0 0.6506 -6624.6875 2235.5093)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -6780.3,
    y: 2367.8,
    style: {
      opacity: 0.7,
      clipPath: "url(#XMLID_00000162325493162794443100000013631105784522428586_)",
      fill: "#E84F1C"
    },
    width: 896.3,
    height: 503.1
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: -7313.5,
    y: 2051.1,
    className: "st14",
    width: 954.6,
    height: 146
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: -6348,
    y: 2051.1,
    className: "st14",
    width: 954.6,
    height: 146
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0035 0 0 1 -7094.4946 1631.4373)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "69.757px"
    }
  }, "Meeting Room 4"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0035 0 0 1 -6129.0728 1631.4373)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "69.757px"
    }
  }, "Meeting Room 4"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -7094.4966 2150.7185)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "68.4157px"
    }
  }, "Meeting Room 4"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -6129.0742 2150.7185)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "68.4157px"
    }
  }, "Meeting Room 4"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0035 0 0 1 -6921.2432 1498.6492)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.8958px"
    }
  }, "VERF\xDCGBAR"), /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000091710589337261899630000006847249156586427036_",
    x: -7269.7,
    y: 2455.7,
    width: 623.9,
    height: 327.3
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000091710589337261899630000006847249156586427036_",
    style: {
      overflow: "visible",
      fill: "#0080C9"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000054233165056173486120000010123861427937166733_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000091710589337261899630000006847249156586427036_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fotolia_x5F_85652600_x5F_L.tif_00000183243108896106771470000008188123794223756717_",
    style: {
      clipPath: "url(#XMLID_00000054233165056173486120000010123861427937166733_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 2500,
    height: 1650,
    id: "Fotolia_x5F_85652600_x5F_L_00000110470073695073298240000005670057927783245719_",
    xlinkHref: "9696B948.jpg",
    transform: "matrix(0.3314 0 0 0.3237 -7269.7446 2248.9688)"
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0035 0 0 1 -5955.8208 1498.6492)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.8958px"
    }
  }, "VERF\xDCGBAR"), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: -7269.7,
    y: 2455.7,
    className: "st23",
    width: 614,
    height: 327.3
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -6899.1792 2020.4832)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "BESETZT"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -5933.7568 2020.4832)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "BESETZT"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -6957.0029 2248.0642)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Aktuelles Meeting"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -5991.5806 2248.0642)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Aktuelles Meeting"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -6925.748 2283.5789)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Bold'",
      fontSize: "22.4794px"
    }
  }, "Demo Meeting 1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -5960.3257 2283.5789)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Bold'",
      fontSize: "22.4794px"
    }
  }, "Demo Meeting 2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -6894.0239 2325.3979)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 20
    }
  }, "15:00 - 17:00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -5928.6021 2325.3979)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: 20
    }
  }, "15:00 - 17:30"), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: -6035.1,
    y: 2447.7,
    className: "st0",
    width: 34.7,
    height: 335.3
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: -6655.8,
    y: 2447.7,
    className: "st0",
    width: 34.7,
    height: 335.3
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -6356.7617 2597.7581)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Frei"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -6442.2158 2746.9922)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Meeting Room 1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -5731.7368 2597.7581)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Frei"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -5817.1914 2746.9922)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Meeting Room 2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -6982.0239 2597.7581)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Frei"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0232 0 0 1 -7067.478 2746.9922)",
    className: "st0",
    style: {
      fontFamily: "'Aileron-Regular'",
      fontSize: "29.321px"
    }
  }, "Meeting Room 3"), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1273,
    height: 841,
    xlinkHref: "1x/Asset 2.png",
    transform: "matrix(1 0 0 1 -4781.2651 214.6167)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 2160,
    height: 2160,
    xlinkHref: "9696B94B.jpg",
    transform: "matrix(1 0 0 1 -757.7013 -3712.8364)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.765d2ace.svg";
export { ForwardRef as ReactComponent };